/**
 * auth0-js v9.29.0
 * Author: Auth0
 * Date: 2025-10-06
 * License: MIT
 */

var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function createCommonjsModule(fn, module) {
  return fn(module = {
    exports: {}
  }, module.exports), module.exports;
}
var urlJoin = createCommonjsModule(function (module) {
    var context, definition;
    context = commonjsGlobal, definition = function () {
      function normalize(strArray) {
        var resultArray = [];
        if (0 === strArray.length) return "";
        if ("string" != typeof strArray[0]) throw new TypeError("Url must be a string. Received " + strArray[0]);
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
          var first = strArray.shift();
          strArray[0] = first + strArray[0];
        }
        strArray[0].match(/^file:\/\/\//) ? strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///") : strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        for (var i = 0; i < strArray.length; i++) {
          var component = strArray[i];
          if ("string" != typeof component) throw new TypeError("Url must be a string. Received " + component);
          "" !== component && (i > 0 && (component = component.replace(/^[\/]+/, "")), component = i < strArray.length - 1 ? component.replace(/[\/]+$/, "") : component.replace(/[\/]+$/, "/"), resultArray.push(component));
        }
        var str = resultArray.join("/"),
          parts = (str = str.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
        return str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
      }
      return function () {
        return normalize("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
      };
    }, module.exports ? module.exports = definition() : context.urljoin = definition();
  }),
  type = TypeError,
  utilInspect = function (n) {
    return n && n.default || n;
  }(Object.freeze({
    __proto__: null,
    default: {}
  })),
  hasMap = "function" == typeof Map && Map.prototype,
  mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
  mapSize = hasMap && mapSizeDescriptor && "function" == typeof mapSizeDescriptor.get ? mapSizeDescriptor.get : null,
  mapForEach = hasMap && Map.prototype.forEach,
  hasSet = "function" == typeof Set && Set.prototype,
  setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
  setSize = hasSet && setSizeDescriptor && "function" == typeof setSizeDescriptor.get ? setSizeDescriptor.get : null,
  setForEach = hasSet && Set.prototype.forEach,
  weakMapHas = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
  weakSetHas = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
  weakRefDeref = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
  booleanValueOf = Boolean.prototype.valueOf,
  objectToString = Object.prototype.toString,
  functionToString = Function.prototype.toString,
  $match = String.prototype.match,
  $slice = String.prototype.slice,
  $replace = String.prototype.replace,
  $toUpperCase = String.prototype.toUpperCase,
  $toLowerCase = String.prototype.toLowerCase,
  $test = RegExp.prototype.test,
  $concat = Array.prototype.concat,
  $join = Array.prototype.join,
  $arrSlice = Array.prototype.slice,
  $floor = Math.floor,
  bigIntValueOf = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
  gOPS = Object.getOwnPropertySymbols,
  symToString = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
  hasShammedSymbols = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
  toStringTag = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols || "symbol") ? Symbol.toStringTag : null,
  isEnumerable = Object.prototype.propertyIsEnumerable,
  gPO = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (O) {
    return O.__proto__;
  } : null);
function addNumericSeparator(num, str) {
  if (num === 1 / 0 || num === -1 / 0 || num != num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) return str;
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if ("number" == typeof num) {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int),
        dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(str, sepRegex, "$&_");
}
var inspectCustom = utilInspect.custom,
  inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null,
  quotes = {
    __proto__: null,
    double: '"',
    single: "'"
  },
  quoteREs = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  },
  objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && !has(quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && ("number" == typeof opts.maxStringLength ? opts.maxStringLength < 0 && opts.maxStringLength !== 1 / 0 : null !== opts.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = !has(opts, "customInspect") || opts.customInspect;
    if ("boolean" != typeof customInspect && "symbol" !== customInspect) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && null !== opts.indent && "\t" !== opts.indent && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && "boolean" != typeof opts.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (void 0 === obj) return "undefined";
    if (null === obj) return "null";
    if ("boolean" == typeof obj) return obj ? "true" : "false";
    if ("string" == typeof obj) return function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength,
          trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
      }
      var quoteRE = quoteREs[opts.quoteStyle || "single"];
      return quoteRE.lastIndex = 0, wrapQuotes($replace.call($replace.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, lowbyte), "single", opts);
    }(obj, opts);
    if ("number" == typeof obj) {
      if (0 === obj) return 1 / 0 / obj > 0 ? "0" : "-0";
      var str = String(obj);
      return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if ("bigint" == typeof obj) {
      var bigIntStr = String(obj) + "n";
      return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = void 0 === opts.depth ? 5 : opts.depth;
    if (void 0 === depth && (depth = 0), depth >= maxDepth && maxDepth > 0 && "object" == typeof obj) return isArray(obj) ? "[Array]" : "[Object]";
    var indent = function (opts, depth) {
      var baseIndent;
      if ("\t" === opts.indent) baseIndent = "\t";else {
        if (!("number" == typeof opts.indent && opts.indent > 0)) return null;
        baseIndent = $join.call(Array(opts.indent + 1), " ");
      }
      return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
      };
    }(opts, depth);
    if (void 0 === seen) seen = [];else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
      if (from && (seen = $arrSlice.call(seen)).push(from), noIndent) {
        var newOpts = {
          depth: opts.depth
        };
        return has(opts, "quoteStyle") && (newOpts.quoteStyle = opts.quoteStyle), inspect_(value, newOpts, depth + 1, seen);
      }
      return inspect_(value, opts, depth + 1, seen);
    }
    if ("function" == typeof obj && !isRegExp(obj)) {
      var name = function (f) {
          if (f.name) return f.name;
          var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
          if (m) return m[1];
          return null;
        }(obj),
        keys = arrObjKeys(obj, inspect);
      return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
      var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
      return "object" != typeof obj || hasShammedSymbols ? symString : markBoxed(symString);
    }
    if (function (x) {
      if (!x || "object" != typeof x) return !1;
      if ("undefined" != typeof HTMLElement && x instanceof HTMLElement) return !0;
      return "string" == typeof x.nodeName && "function" == typeof x.getAttribute;
    }(obj)) {
      for (var s = "<" + $toLowerCase.call(String(obj.nodeName)), attrs = obj.attributes || [], i = 0; i < attrs.length; i++) s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
      return s += ">", obj.childNodes && obj.childNodes.length && (s += "..."), s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    }
    if (isArray(obj)) {
      if (0 === obj.length) return "[]";
      var xs = arrObjKeys(obj, inspect);
      return indent && !function (xs) {
        for (var i = 0; i < xs.length; i++) if (indexOf(xs[i], "\n") >= 0) return !1;
        return !0;
      }(xs) ? "[" + indentedJoin(xs, indent) + "]" : "[ " + $join.call(xs, ", ") + " ]";
    }
    if (function (obj) {
      return "[object Error]" === toStr(obj) && canTrustToString(obj);
    }(obj)) {
      var parts = arrObjKeys(obj, inspect);
      return "cause" in Error.prototype || !("cause" in obj) || isEnumerable.call(obj, "cause") ? 0 === parts.length ? "[" + String(obj) + "]" : "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }" : "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
    }
    if ("object" == typeof obj && customInspect) {
      if (inspectSymbol && "function" == typeof obj[inspectSymbol] && utilInspect) return utilInspect(obj, {
        depth: maxDepth - depth
      });
      if ("symbol" !== customInspect && "function" == typeof obj.inspect) return obj.inspect();
    }
    if (function (x) {
      if (!mapSize || !x || "object" != typeof x) return !1;
      try {
        mapSize.call(x);
        try {
          setSize.call(x);
        } catch (s) {
          return !0;
        }
        return x instanceof Map;
      } catch (e) {}
      return !1;
    }(obj)) {
      var mapParts = [];
      return mapForEach && mapForEach.call(obj, function (value, key) {
        mapParts.push(inspect(key, obj, !0) + " => " + inspect(value, obj));
      }), collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (function (x) {
      if (!setSize || !x || "object" != typeof x) return !1;
      try {
        setSize.call(x);
        try {
          mapSize.call(x);
        } catch (m) {
          return !0;
        }
        return x instanceof Set;
      } catch (e) {}
      return !1;
    }(obj)) {
      var setParts = [];
      return setForEach && setForEach.call(obj, function (value) {
        setParts.push(inspect(value, obj));
      }), collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (function (x) {
      if (!weakMapHas || !x || "object" != typeof x) return !1;
      try {
        weakMapHas.call(x, weakMapHas);
        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return !0;
        }
        return x instanceof WeakMap;
      } catch (e) {}
      return !1;
    }(obj)) return weakCollectionOf("WeakMap");
    if (function (x) {
      if (!weakSetHas || !x || "object" != typeof x) return !1;
      try {
        weakSetHas.call(x, weakSetHas);
        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return !0;
        }
        return x instanceof WeakSet;
      } catch (e) {}
      return !1;
    }(obj)) return weakCollectionOf("WeakSet");
    if (function (x) {
      if (!weakRefDeref || !x || "object" != typeof x) return !1;
      try {
        return weakRefDeref.call(x), !0;
      } catch (e) {}
      return !1;
    }(obj)) return weakCollectionOf("WeakRef");
    if (function (obj) {
      return "[object Number]" === toStr(obj) && canTrustToString(obj);
    }(obj)) return markBoxed(inspect(Number(obj)));
    if (function (obj) {
      if (!obj || "object" != typeof obj || !bigIntValueOf) return !1;
      try {
        return bigIntValueOf.call(obj), !0;
      } catch (e) {}
      return !1;
    }(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (function (obj) {
      return "[object Boolean]" === toStr(obj) && canTrustToString(obj);
    }(obj)) return markBoxed(booleanValueOf.call(obj));
    if (function (obj) {
      return "[object String]" === toStr(obj) && canTrustToString(obj);
    }(obj)) return markBoxed(inspect(String(obj)));
    if ("undefined" != typeof window && obj === window) return "{ [object Window] }";
    if ("undefined" != typeof globalThis && obj === globalThis || void 0 !== commonjsGlobal && obj === commonjsGlobal) return "{ [object globalThis] }";
    if (!function (obj) {
      return "[object Date]" === toStr(obj) && canTrustToString(obj);
    }(obj) && !isRegExp(obj)) {
      var ys = arrObjKeys(obj, inspect),
        isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object,
        protoTag = obj instanceof Object ? "" : "null prototype",
        stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "",
        tag = (isPlainObject || "function" != typeof obj.constructor ? "" : obj.constructor.name ? obj.constructor.name + " " : "") + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
      return 0 === ys.length ? tag + "{}" : indent ? tag + "{" + indentedJoin(ys, indent) + "}" : tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
  };
function wrapQuotes(s, defaultStyle, opts) {
  var style = opts.quoteStyle || defaultStyle,
    quoteChar = quotes[style];
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, "&quot;");
}
function canTrustToString(obj) {
  return !toStringTag || !("object" == typeof obj && (toStringTag in obj || void 0 !== obj[toStringTag]));
}
function isArray(obj) {
  return "[object Array]" === toStr(obj) && canTrustToString(obj);
}
function isRegExp(obj) {
  return "[object RegExp]" === toStr(obj) && canTrustToString(obj);
}
function isSymbol(obj) {
  if (hasShammedSymbols) return obj && "object" == typeof obj && obj instanceof Symbol;
  if ("symbol" == typeof obj) return !0;
  if (!obj || "object" != typeof obj || !symToString) return !1;
  try {
    return symToString.call(obj), !0;
  } catch (e) {}
  return !1;
}
var hasOwn = Object.prototype.hasOwnProperty || function (key) {
  return key in this;
};
function has(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function indexOf(xs, x) {
  if (xs.indexOf) return xs.indexOf(x);
  for (var i = 0, l = xs.length; i < l; i++) if (xs[i] === x) return i;
  return -1;
}
function lowbyte(c) {
  var n = c.charCodeAt(0),
    x = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[n];
  return x ? "\\" + x : "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type) {
  return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
  return type + " (" + size + ") {" + (indent ? indentedJoin(entries, indent) : $join.call(entries, ", ")) + "}";
}
function indentedJoin(xs, indent) {
  if (0 === xs.length) return "";
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
  var isArr = isArray(obj),
    xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
  }
  var symMap,
    syms = "function" == typeof gOPS ? gOPS(obj) : [];
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) symMap["$" + syms[k]] = syms[k];
  }
  for (var key in obj) has(obj, key) && (isArr && String(Number(key)) === key && key < obj.length || hasShammedSymbols && symMap["$" + key] instanceof Symbol || ($test.call(/[^\w$]/, key) ? xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj)) : xs.push(key + ": " + inspect(obj[key], obj))));
  if ("function" == typeof gOPS) for (var j = 0; j < syms.length; j++) isEnumerable.call(obj, syms[j]) && xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
  return xs;
}
var listGetNode = function (list, key, isDelete) {
    for (var curr, prev = list; null != (curr = prev.next); prev = curr) if (curr.key === key) return prev.next = curr.next, isDelete || (curr.next = list.next, list.next = curr), curr;
  },
  esObjectAtoms = Object,
  esErrors = Error,
  _eval = EvalError,
  range = RangeError,
  ref = ReferenceError,
  syntax = SyntaxError,
  uri = URIError,
  abs = Math.abs,
  floor = Math.floor,
  max = Math.max,
  min = Math.min,
  pow = Math.pow,
  round = Math.round,
  _isNaN = Number.isNaN || function (a) {
    return a != a;
  },
  $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
  $gOPD([], "length");
} catch (e) {
  $gOPD = null;
}
var gopd = $gOPD,
  $defineProperty = Object.defineProperty || !1;
if ($defineProperty) try {
  $defineProperty({}, "a", {
    value: 1
  });
} catch (e) {
  $defineProperty = !1;
}
var hasProtoAccessor,
  esDefineProperty = $defineProperty,
  origSymbol = "undefined" != typeof Symbol && Symbol,
  Reflect_getPrototypeOf = "undefined" != typeof Reflect && Reflect.getPrototypeOf || null,
  Object_getPrototypeOf = esObjectAtoms.getPrototypeOf || null,
  ERROR_MESSAGE = "Function.prototype.bind called on incompatible ",
  toStr$1 = Object.prototype.toString,
  max$1 = Math.max,
  concatty = function (a, b) {
    for (var arr = [], i = 0; i < a.length; i += 1) arr[i] = a[i];
    for (var j = 0; j < b.length; j += 1) arr[j + a.length] = b[j];
    return arr;
  },
  slicy = function (arrLike, offset) {
    for (var arr = [], i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) arr[j] = arrLike[i];
    return arr;
  },
  joiny = function (arr, joiner) {
    for (var str = "", i = 0; i < arr.length; i += 1) str += arr[i], i + 1 < arr.length && (str += joiner);
    return str;
  },
  functionBind = Function.prototype.bind || function (that) {
    var target = this;
    if ("function" != typeof target || "[object Function]" !== toStr$1.apply(target)) throw new TypeError(ERROR_MESSAGE + target);
    for (var bound, args = slicy(arguments, 1), binder = function () {
        if (this instanceof bound) {
          var result = target.apply(this, concatty(args, arguments));
          return Object(result) === result ? result : this;
        }
        return target.apply(that, concatty(args, arguments));
      }, boundLength = max$1(0, target.length - args.length), boundArgs = [], i = 0; i < boundLength; i++) boundArgs[i] = "$" + i;
    if (bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder), target.prototype) {
      var Empty = function () {};
      Empty.prototype = target.prototype, bound.prototype = new Empty(), Empty.prototype = null;
    }
    return bound;
  },
  functionCall = Function.prototype.call,
  functionApply = Function.prototype.apply,
  actualApply = "undefined" != typeof Reflect && Reflect && Reflect.apply || functionBind.call(functionCall, functionApply),
  callBindApplyHelpers = function (args) {
    if (args.length < 1 || "function" != typeof args[0]) throw new type("a function is required");
    return actualApply(functionBind, functionCall, args);
  };
try {
  hasProtoAccessor = [].__proto__ === Array.prototype;
} catch (e) {
  if (!e || "object" != typeof e || !("code" in e) || "ERR_PROTO_ACCESS" !== e.code) throw e;
}
var desc = !!hasProtoAccessor && gopd && gopd(Object.prototype, "__proto__"),
  $Object = Object,
  $getPrototypeOf = $Object.getPrototypeOf,
  get = desc && "function" == typeof desc.get ? callBindApplyHelpers([desc.get]) : "function" == typeof $getPrototypeOf && function (value) {
    return $getPrototypeOf(null == value ? value : $Object(value));
  },
  getProto = Reflect_getPrototypeOf ? function (O) {
    return Reflect_getPrototypeOf(O);
  } : Object_getPrototypeOf ? function (O) {
    if (!O || "object" != typeof O && "function" != typeof O) throw new TypeError("getProto: not an object");
    return Object_getPrototypeOf(O);
  } : get ? function (O) {
    return get(O);
  } : null,
  call = Function.prototype.call,
  $hasOwn = Object.prototype.hasOwnProperty,
  hasown = functionBind.call(call, $hasOwn),
  $Function = Function,
  getEvalledConstructor = function (expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
  },
  throwTypeError = function () {
    throw new type();
  },
  ThrowTypeError = gopd ? function () {
    try {
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        return gopd(arguments, "callee").get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  }() : throwTypeError,
  hasSymbols$1 = "function" == typeof origSymbol && "function" == typeof Symbol && "symbol" == typeof origSymbol("foo") && "symbol" == typeof Symbol("bar") && function () {
    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
    if ("symbol" == typeof Symbol.iterator) return !0;
    var obj = {},
      sym = Symbol("test"),
      symObj = Object(sym);
    if ("string" == typeof sym) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(sym)) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(symObj)) return !1;
    for (var _ in obj[sym] = 42, obj) return !1;
    if ("function" == typeof Object.keys && 0 !== Object.keys(obj).length) return !1;
    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(obj).length) return !1;
    var syms = Object.getOwnPropertySymbols(obj);
    if (1 !== syms.length || syms[0] !== sym) return !1;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return !1;
    if ("function" == typeof Object.getOwnPropertyDescriptor) {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
      if (42 !== descriptor.value || !0 !== descriptor.enumerable) return !1;
    }
    return !0;
  }(),
  needsEval = {},
  TypedArray = "undefined" != typeof Uint8Array && getProto ? getProto(Uint8Array) : void 0,
  INTRINSICS = {
    __proto__: null,
    "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols$1 && getProto ? getProto([][Symbol.iterator]()) : void 0,
    "%AsyncFromSyncIteratorPrototype%": void 0,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
    "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? void 0 : BigInt64Array,
    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? void 0 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": esErrors,
    "%eval%": eval,
    "%EvalError%": _eval,
    "%Float16Array%": "undefined" == typeof Float16Array ? void 0 : Float16Array,
    "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
    "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
    "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
    "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols$1 && getProto ? getProto(getProto([][Symbol.iterator]())) : void 0,
    "%JSON%": "object" == typeof JSON ? JSON : void 0,
    "%Map%": "undefined" == typeof Map ? void 0 : Map,
    "%MapIteratorPrototype%": "undefined" != typeof Map && hasSymbols$1 && getProto ? getProto(new Map()[Symbol.iterator]()) : void 0,
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": esObjectAtoms,
    "%Object.getOwnPropertyDescriptor%": gopd,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
    "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
    "%RangeError%": range,
    "%ReferenceError%": ref,
    "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": "undefined" == typeof Set ? void 0 : Set,
    "%SetIteratorPrototype%": "undefined" != typeof Set && hasSymbols$1 && getProto ? getProto(new Set()[Symbol.iterator]()) : void 0,
    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols$1 && getProto ? getProto(""[Symbol.iterator]()) : void 0,
    "%Symbol%": hasSymbols$1 ? Symbol : void 0,
    "%SyntaxError%": syntax,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": type,
    "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
    "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
    "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
    "%URIError%": uri,
    "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
    "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
    "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet,
    "%Function.prototype.call%": functionCall,
    "%Function.prototype.apply%": functionApply,
    "%Object.defineProperty%": esDefineProperty,
    "%Object.getPrototypeOf%": Object_getPrototypeOf,
    "%Math.abs%": abs,
    "%Math.floor%": floor,
    "%Math.max%": max,
    "%Math.min%": min,
    "%Math.pow%": pow,
    "%Math.round%": round,
    "%Math.sign%": function (number) {
      return _isNaN(number) || 0 === number ? number : number < 0 ? -1 : 1;
    },
    "%Reflect.getPrototypeOf%": Reflect_getPrototypeOf
  };
if (getProto) try {
  null.error;
} catch (e) {
  var errorProto = getProto(getProto(e));
  INTRINSICS["%Error.prototype%"] = errorProto;
}
var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  },
  $concat$1 = functionBind.call(functionCall, Array.prototype.concat),
  $spliceApply = functionBind.call(functionApply, Array.prototype.splice),
  $replace$1 = functionBind.call(functionCall, String.prototype.replace),
  $strSlice = functionBind.call(functionCall, String.prototype.slice),
  $exec = functionBind.call(functionCall, RegExp.prototype.exec),
  rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
  reEscapeChar = /\\(\\)?/g,
  stringToPath = function (string) {
    var first = $strSlice(string, 0, 1),
      last = $strSlice(string, -1);
    if ("%" === first && "%" !== last) throw new syntax("invalid intrinsic syntax, expected closing `%`");
    if ("%" === last && "%" !== first) throw new syntax("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    return $replace$1(string, rePropName, function (match, number, quote, subString) {
      result[result.length] = quote ? $replace$1(subString, reEscapeChar, "$1") : number || match;
    }), result;
  },
  getBaseIntrinsic = function (name, allowMissing) {
    var alias,
      intrinsicName = name;
    if (hasown(LEGACY_ALIASES, intrinsicName) && (intrinsicName = "%" + (alias = LEGACY_ALIASES[intrinsicName])[0] + "%"), hasown(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval && (value = function doEval(name) {
        var value;
        if ("%AsyncFunction%" === name) value = getEvalledConstructor("async function () {}");else if ("%GeneratorFunction%" === name) value = getEvalledConstructor("function* () {}");else if ("%AsyncGeneratorFunction%" === name) value = getEvalledConstructor("async function* () {}");else if ("%AsyncGenerator%" === name) {
          var fn = doEval("%AsyncGeneratorFunction%");
          fn && (value = fn.prototype);
        } else if ("%AsyncIteratorPrototype%" === name) {
          var gen = doEval("%AsyncGenerator%");
          gen && getProto && (value = getProto(gen.prototype));
        }
        return INTRINSICS[name] = value, value;
      }(intrinsicName)), void 0 === value && !allowMissing) throw new type("intrinsic " + name + " exists, but is not available. Please file an issue!");
      return {
        alias: alias,
        name: intrinsicName,
        value: value
      };
    }
    throw new syntax("intrinsic " + name + " does not exist!");
  },
  getIntrinsic = function (name, allowMissing) {
    if ("string" != typeof name || 0 === name.length) throw new type("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && "boolean" != typeof allowMissing) throw new type('"allowMissing" argument must be a boolean');
    if (null === $exec(/^%?[^%]*%?$/, name)) throw new syntax("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name),
      intrinsicBaseName = parts.length > 0 ? parts[0] : "",
      intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing),
      intrinsicRealName = intrinsic.name,
      value = intrinsic.value,
      skipFurtherCaching = !1,
      alias = intrinsic.alias;
    alias && (intrinsicBaseName = alias[0], $spliceApply(parts, $concat$1([0, 1], alias)));
    for (var i = 1, isOwn = !0; i < parts.length; i += 1) {
      var part = parts[i],
        first = $strSlice(part, 0, 1),
        last = $strSlice(part, -1);
      if (('"' === first || "'" === first || "`" === first || '"' === last || "'" === last || "`" === last) && first !== last) throw new syntax("property names with quotes must have matching quotes");
      if ("constructor" !== part && isOwn || (skipFurtherCaching = !0), hasown(INTRINSICS, intrinsicRealName = "%" + (intrinsicBaseName += "." + part) + "%")) value = INTRINSICS[intrinsicRealName];else if (null != value) {
        if (!(part in value)) {
          if (!allowMissing) throw new type("base intrinsic for " + name + " exists, but the property is not available.");
          return;
        }
        if (gopd && i + 1 >= parts.length) {
          var desc = gopd(value, part);
          value = (isOwn = !!desc) && "get" in desc && !("originalValue" in desc.get) ? desc.get : value[part];
        } else isOwn = hasown(value, part), value = value[part];
        isOwn && !skipFurtherCaching && (INTRINSICS[intrinsicRealName] = value);
      }
    }
    return value;
  },
  $indexOf = callBindApplyHelpers([getIntrinsic("%String.prototype.indexOf%")]),
  callBound = function (name, allowMissing) {
    var intrinsic = getIntrinsic(name, !!allowMissing);
    return "function" == typeof intrinsic && $indexOf(name, ".prototype.") > -1 ? callBindApplyHelpers([intrinsic]) : intrinsic;
  },
  $Map = getIntrinsic("%Map%", !0),
  $mapGet = callBound("Map.prototype.get", !0),
  $mapSet = callBound("Map.prototype.set", !0),
  $mapHas = callBound("Map.prototype.has", !0),
  $mapDelete = callBound("Map.prototype.delete", !0),
  $mapSize = callBound("Map.prototype.size", !0),
  sideChannelMap = !!$Map && function () {
    var $m,
      channel = {
        assert: function (key) {
          if (!channel.has(key)) throw new type("Side channel does not contain " + objectInspect(key));
        },
        delete: function (key) {
          if ($m) {
            var result = $mapDelete($m, key);
            return 0 === $mapSize($m) && ($m = void 0), result;
          }
          return !1;
        },
        get: function (key) {
          if ($m) return $mapGet($m, key);
        },
        has: function (key) {
          return !!$m && $mapHas($m, key);
        },
        set: function (key, value) {
          $m || ($m = new $Map()), $mapSet($m, key, value);
        }
      };
    return channel;
  },
  $WeakMap = getIntrinsic("%WeakMap%", !0),
  $weakMapGet = callBound("WeakMap.prototype.get", !0),
  $weakMapSet = callBound("WeakMap.prototype.set", !0),
  $weakMapHas = callBound("WeakMap.prototype.has", !0),
  $weakMapDelete = callBound("WeakMap.prototype.delete", !0),
  makeChannel = ($WeakMap ? function () {
    var $wm,
      $m,
      channel = {
        assert: function (key) {
          if (!channel.has(key)) throw new type("Side channel does not contain " + objectInspect(key));
        },
        delete: function (key) {
          if ($WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
            if ($wm) return $weakMapDelete($wm, key);
          } else if (sideChannelMap && $m) return $m.delete(key);
          return !1;
        },
        get: function (key) {
          return $WeakMap && key && ("object" == typeof key || "function" == typeof key) && $wm ? $weakMapGet($wm, key) : $m && $m.get(key);
        },
        has: function (key) {
          return $WeakMap && key && ("object" == typeof key || "function" == typeof key) && $wm ? $weakMapHas($wm, key) : !!$m && $m.has(key);
        },
        set: function (key, value) {
          $WeakMap && key && ("object" == typeof key || "function" == typeof key) ? ($wm || ($wm = new $WeakMap()), $weakMapSet($wm, key, value)) : sideChannelMap && ($m || ($m = sideChannelMap()), $m.set(key, value));
        }
      };
    return channel;
  } : sideChannelMap) || sideChannelMap || function () {
    var $o,
      channel = {
        assert: function (key) {
          if (!channel.has(key)) throw new type("Side channel does not contain " + objectInspect(key));
        },
        delete: function (key) {
          var root = $o && $o.next,
            deletedNode = function (objects, key) {
              if (objects) return listGetNode(objects, key, !0);
            }($o, key);
          return deletedNode && root && root === deletedNode && ($o = void 0), !!deletedNode;
        },
        get: function (key) {
          return function (objects, key) {
            if (objects) {
              var node = listGetNode(objects, key);
              return node && node.value;
            }
          }($o, key);
        },
        has: function (key) {
          return function (objects, key) {
            return !!objects && !!listGetNode(objects, key);
          }($o, key);
        },
        set: function (key, value) {
          $o || ($o = {
            next: void 0
          }), function (objects, key, value) {
            var node = listGetNode(objects, key);
            node ? node.value = value : objects.next = {
              key: key,
              next: objects.next,
              value: value
            };
          }($o, key, value);
        }
      };
    return channel;
  },
  sideChannel = function () {
    var $channelData,
      channel = {
        assert: function (key) {
          if (!channel.has(key)) throw new type("Side channel does not contain " + objectInspect(key));
        },
        delete: function (key) {
          return !!$channelData && $channelData.delete(key);
        },
        get: function (key) {
          return $channelData && $channelData.get(key);
        },
        has: function (key) {
          return !!$channelData && $channelData.has(key);
        },
        set: function (key, value) {
          $channelData || ($channelData = makeChannel()), $channelData.set(key, value);
        }
      };
    return channel;
  },
  replace = String.prototype.replace,
  percentTwenties = /%20/g,
  Format_RFC3986 = "RFC3986",
  formats = {
    default: Format_RFC3986,
    formatters: {
      RFC1738: function (value) {
        return replace.call(value, percentTwenties, "+");
      },
      RFC3986: function (value) {
        return String(value);
      }
    },
    RFC1738: "RFC1738",
    RFC3986: Format_RFC3986
  },
  has$1 = Object.prototype.hasOwnProperty,
  isArray$1 = Array.isArray,
  hexTable = function () {
    for (var array = [], i = 0; i < 256; ++i) array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
  }(),
  arrayToObject = function (source, options) {
    for (var obj = options && options.plainObjects ? {
        __proto__: null
      } : {}, i = 0; i < source.length; ++i) void 0 !== source[i] && (obj[i] = source[i]);
    return obj;
  },
  utils = {
    arrayToObject: arrayToObject,
    assign: function (target, source) {
      return Object.keys(source).reduce(function (acc, key) {
        return acc[key] = source[key], acc;
      }, target);
    },
    combine: function (a, b) {
      return [].concat(a, b);
    },
    compact: function (value) {
      for (var queue = [{
          obj: {
            o: value
          },
          prop: "o"
        }], refs = [], i = 0; i < queue.length; ++i) for (var item = queue[i], obj = item.obj[item.prop], keys = Object.keys(obj), j = 0; j < keys.length; ++j) {
        var key = keys[j],
          val = obj[key];
        "object" == typeof val && null !== val && -1 === refs.indexOf(val) && (queue.push({
          obj: obj,
          prop: key
        }), refs.push(val));
      }
      return function (queue) {
        for (; queue.length > 1;) {
          var item = queue.pop(),
            obj = item.obj[item.prop];
          if (isArray$1(obj)) {
            for (var compacted = [], j = 0; j < obj.length; ++j) void 0 !== obj[j] && compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
          }
        }
      }(queue), value;
    },
    decode: function (str, defaultDecoder, charset) {
      var strWithoutPlus = str.replace(/\+/g, " ");
      if ("iso-8859-1" === charset) return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    },
    encode: function (str, defaultEncoder, charset, kind, format) {
      if (0 === str.length) return str;
      var string = str;
      if ("symbol" == typeof str ? string = Symbol.prototype.toString.call(str) : "string" != typeof str && (string = String(str)), "iso-8859-1" === charset) return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
      });
      for (var out = "", j = 0; j < string.length; j += 1024) {
        for (var segment = string.length >= 1024 ? string.slice(j, j + 1024) : string, arr = [], i = 0; i < segment.length; ++i) {
          var c = segment.charCodeAt(i);
          45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (40 === c || 41 === c) ? arr[arr.length] = segment.charAt(i) : c < 128 ? arr[arr.length] = hexTable[c] : c < 2048 ? arr[arr.length] = hexTable[192 | c >> 6] + hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? arr[arr.length] = hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & segment.charCodeAt(i)), arr[arr.length] = hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c]);
        }
        out += arr.join("");
      }
      return out;
    },
    isBuffer: function (obj) {
      return !(!obj || "object" != typeof obj) && !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    },
    isRegExp: function (obj) {
      return "[object RegExp]" === Object.prototype.toString.call(obj);
    },
    maybeMap: function (val, fn) {
      if (isArray$1(val)) {
        for (var mapped = [], i = 0; i < val.length; i += 1) mapped.push(fn(val[i]));
        return mapped;
      }
      return fn(val);
    },
    merge: function merge(target, source, options) {
      if (!source) return target;
      if ("object" != typeof source && "function" != typeof source) {
        if (isArray$1(target)) target.push(source);else {
          if (!target || "object" != typeof target) return [target, source];
          (options && (options.plainObjects || options.allowPrototypes) || !has$1.call(Object.prototype, source)) && (target[source] = !0);
        }
        return target;
      }
      if (!target || "object" != typeof target) return [target].concat(source);
      var mergeTarget = target;
      return isArray$1(target) && !isArray$1(source) && (mergeTarget = arrayToObject(target, options)), isArray$1(target) && isArray$1(source) ? (source.forEach(function (item, i) {
        if (has$1.call(target, i)) {
          var targetItem = target[i];
          targetItem && "object" == typeof targetItem && item && "object" == typeof item ? target[i] = merge(targetItem, item, options) : target.push(item);
        } else target[i] = item;
      }), target) : Object.keys(source).reduce(function (acc, key) {
        var value = source[key];
        return has$1.call(acc, key) ? acc[key] = merge(acc[key], value, options) : acc[key] = value, acc;
      }, mergeTarget);
    }
  },
  has$2 = Object.prototype.hasOwnProperty,
  arrayPrefixGenerators = {
    brackets: function (prefix) {
      return prefix + "[]";
    },
    comma: "comma",
    indices: function (prefix, key) {
      return prefix + "[" + key + "]";
    },
    repeat: function (prefix) {
      return prefix;
    }
  },
  isArray$2 = Array.isArray,
  push = Array.prototype.push,
  pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$2(valueOrArray) ? valueOrArray : [valueOrArray]);
  },
  toISO = Date.prototype.toISOString,
  defaultFormat = formats.default,
  defaults = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: utils.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    indices: !1,
    serializeDate: function (date) {
      return toISO.call(date);
    },
    skipNulls: !1,
    strictNullHandling: !1
  },
  sentinel = {},
  stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel$1) {
    for (var obj = object, tmpSc = sideChannel$1, step = 0, findFlag = !1; void 0 !== (tmpSc = tmpSc.get(sentinel)) && !findFlag;) {
      var pos = tmpSc.get(object);
      if (step += 1, void 0 !== pos) {
        if (pos === step) throw new RangeError("Cyclic object value");
        findFlag = !0;
      }
      void 0 === tmpSc.get(sentinel) && (step = 0);
    }
    if ("function" == typeof filter ? obj = filter(prefix, obj) : obj instanceof Date ? obj = serializeDate(obj) : "comma" === generateArrayPrefix && isArray$2(obj) && (obj = utils.maybeMap(obj, function (value) {
      return value instanceof Date ? serializeDate(value) : value;
    })), null === obj) {
      if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
      obj = "";
    }
    if (function (v) {
      return "string" == typeof v || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v;
    }(obj) || utils.isBuffer(obj)) return encoder ? [formatter(encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format)) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))] : [formatter(prefix) + "=" + formatter(String(obj))];
    var objKeys,
      values = [];
    if (void 0 === obj) return values;
    if ("comma" === generateArrayPrefix && isArray$2(obj)) encodeValuesOnly && encoder && (obj = utils.maybeMap(obj, encoder)), objKeys = [{
      value: obj.length > 0 ? obj.join(",") || null : void 0
    }];else if (isArray$2(filter)) objKeys = filter;else {
      var keys = Object.keys(obj);
      objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, "%2E") : String(prefix),
      adjustedPrefix = commaRoundTrip && isArray$2(obj) && 1 === obj.length ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && isArray$2(obj) && 0 === obj.length) return adjustedPrefix + "[]";
    for (var j = 0; j < objKeys.length; ++j) {
      var key = objKeys[j],
        value = "object" == typeof key && key && void 0 !== key.value ? key.value : obj[key];
      if (!skipNulls || null !== value) {
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, "%2E") : String(key),
          keyPrefix = isArray$2(obj) ? "function" == typeof generateArrayPrefix ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel$1.set(object, step);
        var valueSideChannel = sideChannel();
        valueSideChannel.set(sentinel, sideChannel$1), pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, "comma" === generateArrayPrefix && encodeValuesOnly && isArray$2(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
      }
    }
    return values;
  },
  has$3 = Object.prototype.hasOwnProperty,
  isArray$3 = Array.isArray,
  defaults$1 = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  },
  interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
      return String.fromCharCode(parseInt(numberStr, 10));
    });
  },
  parseArrayValue = function (val, options, currentArrayLength) {
    if (val && "string" == typeof val && options.comma && val.indexOf(",") > -1) return val.split(",");
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (1 === options.arrayLimit ? "" : "s") + " allowed in an array.");
    return val;
  },
  parseKeys = function (givenKey, val, options, valuesParsed) {
    if (givenKey) {
      var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey,
        child = /(\[[^[\]]*])/g,
        segment = options.depth > 0 && /(\[[^[\]]*])/.exec(key),
        parent = segment ? key.slice(0, segment.index) : key,
        keys = [];
      if (parent) {
        if (!options.plainObjects && has$3.call(Object.prototype, parent) && !options.allowPrototypes) return;
        keys.push(parent);
      }
      for (var i = 0; options.depth > 0 && null !== (segment = child.exec(key)) && i < options.depth;) {
        if (i += 1, !options.plainObjects && has$3.call(Object.prototype, segment[1].slice(1, -1)) && !options.allowPrototypes) return;
        keys.push(segment[1]);
      }
      if (segment) {
        if (!0 === options.strictDepth) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
      }
      return function (chain, val, options, valuesParsed) {
        var currentArrayLength = 0;
        if (chain.length > 0 && "[]" === chain[chain.length - 1]) {
          var parentKey = chain.slice(0, -1).join("");
          currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
        }
        for (var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength), i = chain.length - 1; i >= 0; --i) {
          var obj,
            root = chain[i];
          if ("[]" === root && options.parseArrays) obj = options.allowEmptyArrays && ("" === leaf || options.strictNullHandling && null === leaf) ? [] : utils.combine([], leaf);else {
            obj = options.plainObjects ? {
              __proto__: null
            } : {};
            var cleanRoot = "[" === root.charAt(0) && "]" === root.charAt(root.length - 1) ? root.slice(1, -1) : root,
              decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot,
              index = parseInt(decodedRoot, 10);
            options.parseArrays || "" !== decodedRoot ? !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit ? (obj = [])[index] = leaf : "__proto__" !== decodedRoot && (obj[decodedRoot] = leaf) : obj = {
              0: leaf
            };
          }
          leaf = obj;
        }
        return leaf;
      }(keys, val, options, valuesParsed);
    }
  },
  lib_parse = function (str, opts) {
    var options = function (opts) {
      if (!opts) return defaults$1;
      if (void 0 !== opts.allowEmptyArrays && "boolean" != typeof opts.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
      if (void 0 !== opts.decodeDotInKeys && "boolean" != typeof opts.decodeDotInKeys) throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
      if (null !== opts.decoder && void 0 !== opts.decoder && "function" != typeof opts.decoder) throw new TypeError("Decoder has to be a function.");
      if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      if (void 0 !== opts.throwOnLimitExceeded && "boolean" != typeof opts.throwOnLimitExceeded) throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
      var charset = void 0 === opts.charset ? defaults$1.charset : opts.charset,
        duplicates = void 0 === opts.duplicates ? defaults$1.duplicates : opts.duplicates;
      if ("combine" !== duplicates && "first" !== duplicates && "last" !== duplicates) throw new TypeError("The duplicates option must be either combine, first, or last");
      return {
        allowDots: void 0 === opts.allowDots ? !0 === opts.decodeDotInKeys || defaults$1.allowDots : !!opts.allowDots,
        allowEmptyArrays: "boolean" == typeof opts.allowEmptyArrays ? !!opts.allowEmptyArrays : defaults$1.allowEmptyArrays,
        allowPrototypes: "boolean" == typeof opts.allowPrototypes ? opts.allowPrototypes : defaults$1.allowPrototypes,
        allowSparse: "boolean" == typeof opts.allowSparse ? opts.allowSparse : defaults$1.allowSparse,
        arrayLimit: "number" == typeof opts.arrayLimit ? opts.arrayLimit : defaults$1.arrayLimit,
        charset: charset,
        charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : defaults$1.charsetSentinel,
        comma: "boolean" == typeof opts.comma ? opts.comma : defaults$1.comma,
        decodeDotInKeys: "boolean" == typeof opts.decodeDotInKeys ? opts.decodeDotInKeys : defaults$1.decodeDotInKeys,
        decoder: "function" == typeof opts.decoder ? opts.decoder : defaults$1.decoder,
        delimiter: "string" == typeof opts.delimiter || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults$1.delimiter,
        depth: "number" == typeof opts.depth || !1 === opts.depth ? +opts.depth : defaults$1.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: !0 === opts.ignoreQueryPrefix,
        interpretNumericEntities: "boolean" == typeof opts.interpretNumericEntities ? opts.interpretNumericEntities : defaults$1.interpretNumericEntities,
        parameterLimit: "number" == typeof opts.parameterLimit ? opts.parameterLimit : defaults$1.parameterLimit,
        parseArrays: !1 !== opts.parseArrays,
        plainObjects: "boolean" == typeof opts.plainObjects ? opts.plainObjects : defaults$1.plainObjects,
        strictDepth: "boolean" == typeof opts.strictDepth ? !!opts.strictDepth : defaults$1.strictDepth,
        strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : defaults$1.strictNullHandling,
        throwOnLimitExceeded: "boolean" == typeof opts.throwOnLimitExceeded && opts.throwOnLimitExceeded
      };
    }(opts);
    if ("" === str || null == str) return options.plainObjects ? {
      __proto__: null
    } : {};
    for (var tempObj = "string" == typeof str ? function (str, options) {
        var obj = {
            __proto__: null
          },
          cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
        cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        var limit = options.parameterLimit === 1 / 0 ? void 0 : options.parameterLimit,
          parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
        if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError("Parameter limit exceeded. Only " + limit + " parameter" + (1 === limit ? "" : "s") + " allowed.");
        var i,
          skipIndex = -1,
          charset = options.charset;
        if (options.charsetSentinel) for (i = 0; i < parts.length; ++i) 0 === parts[i].indexOf("utf8=") && ("utf8=%E2%9C%93" === parts[i] ? charset = "utf-8" : "utf8=%26%2310003%3B" === parts[i] && (charset = "iso-8859-1"), skipIndex = i, i = parts.length);
        for (i = 0; i < parts.length; ++i) if (i !== skipIndex) {
          var key,
            val,
            part = parts[i],
            bracketEqualsPos = part.indexOf("]="),
            pos = -1 === bracketEqualsPos ? part.indexOf("=") : bracketEqualsPos + 1;
          -1 === pos ? (key = options.decoder(part, defaults$1.decoder, charset, "key"), val = options.strictNullHandling ? null : "") : (key = options.decoder(part.slice(0, pos), defaults$1.decoder, charset, "key"), val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options, isArray$3(obj[key]) ? obj[key].length : 0), function (encodedVal) {
            return options.decoder(encodedVal, defaults$1.decoder, charset, "value");
          })), val && options.interpretNumericEntities && "iso-8859-1" === charset && (val = interpretNumericEntities(String(val))), part.indexOf("[]=") > -1 && (val = isArray$3(val) ? [val] : val);
          var existing = has$3.call(obj, key);
          existing && "combine" === options.duplicates ? obj[key] = utils.combine(obj[key], val) : existing && "last" !== options.duplicates || (obj[key] = val);
        }
        return obj;
      }(str, options) : str, obj = options.plainObjects ? {
        __proto__: null
      } : {}, keys = Object.keys(tempObj), i = 0; i < keys.length; ++i) {
      var key = keys[i],
        newObj = parseKeys(key, tempObj[key], options, "string" == typeof str);
      obj = utils.merge(obj, newObj, options);
    }
    return !0 === options.allowSparse ? obj : utils.compact(obj);
  },
  lib_stringify = function (object, opts) {
    var objKeys,
      obj = object,
      options = function (opts) {
        if (!opts) return defaults;
        if (void 0 !== opts.allowEmptyArrays && "boolean" != typeof opts.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
        if (void 0 !== opts.encodeDotInKeys && "boolean" != typeof opts.encodeDotInKeys) throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
        if (null !== opts.encoder && void 0 !== opts.encoder && "function" != typeof opts.encoder) throw new TypeError("Encoder has to be a function.");
        var charset = opts.charset || defaults.charset;
        if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var format = formats.default;
        if (void 0 !== opts.format) {
          if (!has$2.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
          format = opts.format;
        }
        var arrayFormat,
          formatter = formats.formatters[format],
          filter = defaults.filter;
        if (("function" == typeof opts.filter || isArray$2(opts.filter)) && (filter = opts.filter), arrayFormat = opts.arrayFormat in arrayPrefixGenerators ? opts.arrayFormat : "indices" in opts ? opts.indices ? "indices" : "repeat" : defaults.arrayFormat, "commaRoundTrip" in opts && "boolean" != typeof opts.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
        var allowDots = void 0 === opts.allowDots ? !0 === opts.encodeDotInKeys || defaults.allowDots : !!opts.allowDots;
        return {
          addQueryPrefix: "boolean" == typeof opts.addQueryPrefix ? opts.addQueryPrefix : defaults.addQueryPrefix,
          allowDots: allowDots,
          allowEmptyArrays: "boolean" == typeof opts.allowEmptyArrays ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
          arrayFormat: arrayFormat,
          charset: charset,
          charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : defaults.charsetSentinel,
          commaRoundTrip: !!opts.commaRoundTrip,
          delimiter: void 0 === opts.delimiter ? defaults.delimiter : opts.delimiter,
          encode: "boolean" == typeof opts.encode ? opts.encode : defaults.encode,
          encodeDotInKeys: "boolean" == typeof opts.encodeDotInKeys ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
          encoder: "function" == typeof opts.encoder ? opts.encoder : defaults.encoder,
          encodeValuesOnly: "boolean" == typeof opts.encodeValuesOnly ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
          filter: filter,
          format: format,
          formatter: formatter,
          serializeDate: "function" == typeof opts.serializeDate ? opts.serializeDate : defaults.serializeDate,
          skipNulls: "boolean" == typeof opts.skipNulls ? opts.skipNulls : defaults.skipNulls,
          sort: "function" == typeof opts.sort ? opts.sort : null,
          strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : defaults.strictNullHandling
        };
      }(opts);
    "function" == typeof options.filter ? obj = (0, options.filter)("", obj) : isArray$2(options.filter) && (objKeys = options.filter);
    var keys = [];
    if ("object" != typeof obj || null === obj) return "";
    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat],
      commaRoundTrip = "comma" === generateArrayPrefix && options.commaRoundTrip;
    objKeys || (objKeys = Object.keys(obj)), options.sort && objKeys.sort(options.sort);
    for (var sideChannel$1 = sideChannel(), i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i],
        value = obj[key];
      options.skipNulls && null === value || pushToArray(keys, stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel$1));
    }
    var joined = keys.join(options.delimiter),
      prefix = !0 === options.addQueryPrefix ? "?" : "";
    return options.charsetSentinel && ("iso-8859-1" === options.charset ? prefix += "utf8=%26%2310003%3B&" : prefix += "utf8=%E2%9C%93&"), joined.length > 0 ? prefix + joined : "";
  };
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return function (r) {
    if (Array.isArray(r)) return r;
  }(r) || function (r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }(r, e) || _unsupportedIterableToArray(r, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function _toConsumableArray(r) {
  return function (r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }(r) || function (r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }(r) || _unsupportedIterableToArray(r) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function _toPropertyKey(t) {
  var i = function (t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  })(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var componentEmitter = createCommonjsModule(function (module) {
    function Emitter(obj) {
      if (obj) return function (obj) {
        for (var key in Emitter.prototype) obj[key] = Emitter.prototype[key];
        return obj;
      }(obj);
    }
    module.exports = Emitter, Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn), this;
    }, Emitter.prototype.once = function (event, fn) {
      function on() {
        this.off(event, on), fn.apply(this, arguments);
      }
      return on.fn = fn, this.on(event, on), this;
    }, Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var cb,
        callbacks = this._callbacks["$" + event];
      if (!callbacks) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + event], this;
      for (var i = 0; i < callbacks.length; i++) if ((cb = callbacks[i]) === fn || cb.fn === fn) {
        callbacks.splice(i, 1);
        break;
      }
      return 0 === callbacks.length && delete this._callbacks["$" + event], this;
    }, Emitter.prototype.emit = function (event) {
      this._callbacks = this._callbacks || {};
      for (var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event], i = 1; i < arguments.length; i++) args[i - 1] = arguments[i];
      if (callbacks) {
        i = 0;
        for (var len = (callbacks = callbacks.slice(0)).length; i < len; ++i) callbacks[i].apply(this, args);
      }
      return this;
    }, Emitter.prototype.listeners = function (event) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + event] || [];
    }, Emitter.prototype.hasListeners = function (event) {
      return !!this.listeners(event).length;
    };
  }),
  fastSafeStringify = stringify$1;
stringify$1.default = stringify$1, stringify$1.stable = deterministicStringify, stringify$1.stableStringify = deterministicStringify;
var arr = [],
  replacerStack = [];
function defaultOptions() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function stringify$1(obj, replacer, spacer, options) {
  var res;
  void 0 === options && (options = defaultOptions()), function decirc(val, k, edgeIndex, stack, parent, depth, options) {
    var i;
    if (depth += 1, "object" == typeof val && null !== val) {
      for (i = 0; i < stack.length; i++) if (stack[i] === val) return void setReplace("[Circular]", val, k, parent);
      if (void 0 !== options.depthLimit && depth > options.depthLimit) return void setReplace("[...]", val, k, parent);
      if (void 0 !== options.edgesLimit && edgeIndex + 1 > options.edgesLimit) return void setReplace("[...]", val, k, parent);
      if (stack.push(val), Array.isArray(val)) for (i = 0; i < val.length; i++) decirc(val[i], i, i, stack, val, depth, options);else {
        var keys = Object.keys(val);
        for (i = 0; i < keys.length; i++) {
          var key = keys[i];
          decirc(val[key], key, i, stack, val, depth, options);
        }
      }
      stack.pop();
    }
  }(obj, "", 0, [], void 0, 0, options);
  try {
    res = 0 === replacerStack.length ? JSON.stringify(obj, replacer, spacer) : JSON.stringify(obj, replaceGetterValues(replacer), spacer);
  } catch (_) {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; 0 !== arr.length;) {
      var part = arr.pop();
      4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
    }
  }
  return res;
}
function setReplace(replace, val, k, parent) {
  var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
  void 0 !== propertyDescriptor.get ? propertyDescriptor.configurable ? (Object.defineProperty(parent, k, {
    value: replace
  }), arr.push([parent, k, val, propertyDescriptor])) : replacerStack.push([val, k, replace]) : (parent[k] = replace, arr.push([parent, k, val]));
}
function compareFunction(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}
function deterministicStringify(obj, replacer, spacer, options) {
  void 0 === options && (options = defaultOptions());
  var res,
    tmp = function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
      var i;
      if (depth += 1, "object" == typeof val && null !== val) {
        for (i = 0; i < stack.length; i++) if (stack[i] === val) return void setReplace("[Circular]", val, k, parent);
        try {
          if ("function" == typeof val.toJSON) return;
        } catch (_) {
          return;
        }
        if (void 0 !== options.depthLimit && depth > options.depthLimit) return void setReplace("[...]", val, k, parent);
        if (void 0 !== options.edgesLimit && edgeIndex + 1 > options.edgesLimit) return void setReplace("[...]", val, k, parent);
        if (stack.push(val), Array.isArray(val)) for (i = 0; i < val.length; i++) deterministicDecirc(val[i], i, i, stack, val, depth, options);else {
          var tmp = {},
            keys = Object.keys(val).sort(compareFunction);
          for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            deterministicDecirc(val[key], key, i, stack, val, depth, options), tmp[key] = val[key];
          }
          if (void 0 === parent) return tmp;
          arr.push([parent, k, val]), parent[k] = tmp;
        }
        stack.pop();
      }
    }(obj, "", 0, [], void 0, 0, options) || obj;
  try {
    res = 0 === replacerStack.length ? JSON.stringify(tmp, replacer, spacer) : JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
  } catch (_) {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; 0 !== arr.length;) {
      var part = arr.pop();
      4 === part.length ? Object.defineProperty(part[0], part[1], part[3]) : part[0][part[1]] = part[2];
    }
  }
  return res;
}
function replaceGetterValues(replacer) {
  return replacer = void 0 !== replacer ? replacer : function (k, v) {
    return v;
  }, function (key, val) {
    if (replacerStack.length > 0) for (var i = 0; i < replacerStack.length; i++) {
      var part = replacerStack[i];
      if (part[1] === key && part[0] === val) {
        val = part[2], replacerStack.splice(i, 1);
        break;
      }
    }
    return replacer.call(this, key, val);
  };
}
var utils$1 = createCommonjsModule(function (module, exports) {
    exports.type = function (string_) {
      return string_.split(/ *; */).shift();
    }, exports.params = function (value) {
      var _step,
        object = {},
        _iterator = _createForOfIteratorHelper(value.split(/ *; */));
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var parts = _step.value.split(/ *= */),
            key = parts.shift(),
            _value = parts.shift();
          key && _value && (object[key] = _value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return object;
    }, exports.parseLinks = function (value) {
      var _step2,
        object = {},
        _iterator2 = _createForOfIteratorHelper(value.split(/ *, */));
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var parts = _step2.value.split(/ *; */),
            url = parts[0].slice(1, -1);
          object[parts[1].split(/ *= */)[1].slice(1, -1)] = url;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return object;
    }, exports.cleanHeader = function (header, changesOrigin) {
      return delete header["content-type"], delete header["content-length"], delete header["transfer-encoding"], delete header.host, changesOrigin && (delete header.authorization, delete header.cookie), header;
    }, exports.normalizeHostname = function (hostname) {
      return _slicedToArray(hostname.match(/^\[([^\]]+)\]$/) || [], 2)[1] || hostname;
    }, exports.isObject = function (object) {
      return null !== object && "object" === _typeof(object);
    }, exports.hasOwn = Object.hasOwn || function (object, property) {
      if (null == object) throw new TypeError("Cannot convert undefined or null to object");
      return Object.prototype.hasOwnProperty.call(new Object(object), property);
    }, exports.mixin = function (target, source) {
      for (var key in source) exports.hasOwn(source, key) && (target[key] = source[key]);
    }, exports.isGzipOrDeflateEncoding = function (res) {
      return new RegExp(/^\s*(?:deflate|gzip)\s*$/).test(res.headers["content-encoding"]);
    }, exports.isBrotliEncoding = function (res) {
      return new RegExp(/^\s*(?:br)\s*$/).test(res.headers["content-encoding"]);
    };
  }),
  isObject = (utils$1.type, utils$1.params, utils$1.parseLinks, utils$1.cleanHeader, utils$1.normalizeHostname, utils$1.isObject, utils$1.hasOwn, utils$1.mixin, utils$1.isGzipOrDeflateEncoding, utils$1.isBrotliEncoding, utils$1.isObject),
  hasOwn$1 = utils$1.hasOwn,
  requestBase = RequestBase;
function RequestBase() {}
RequestBase.prototype.clearTimeout = function () {
  return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
}, RequestBase.prototype.parse = function (fn) {
  return this._parser = fn, this;
}, RequestBase.prototype.responseType = function (value) {
  return this._responseType = value, this;
}, RequestBase.prototype.serialize = function (fn) {
  return this._serializer = fn, this;
}, RequestBase.prototype.timeout = function (options) {
  if (!options || "object" !== _typeof(options)) return this._timeout = options, this._responseTimeout = 0, this._uploadTimeout = 0, this;
  for (var option in options) if (hasOwn$1(options, option)) switch (option) {
    case "deadline":
      this._timeout = options.deadline;
      break;
    case "response":
      this._responseTimeout = options.response;
      break;
    case "upload":
      this._uploadTimeout = options.upload;
      break;
    default:
      console.warn("Unknown timeout option", option);
  }
  return this;
}, RequestBase.prototype.retry = function (count, fn) {
  return 0 !== arguments.length && !0 !== count || (count = 1), count <= 0 && (count = 0), this._maxRetries = count, this._retries = 0, this._retryCallback = fn, this;
};
var ERROR_CODES = new Set(["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ECONNREFUSED", "EPIPE", "ENOTFOUND", "ENETUNREACH", "EAI_AGAIN"]),
  STATUS_CODES = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);
RequestBase.prototype._shouldRetry = function (error, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
  if (this._retryCallback) try {
    var override = this._retryCallback(error, res);
    if (!0 === override) return !0;
    if (!1 === override) return !1;
  } catch (err) {
    console.error(err);
  }
  if (res && res.status && STATUS_CODES.has(res.status)) return !0;
  if (error) {
    if (error.code && ERROR_CODES.has(error.code)) return !0;
    if (error.timeout && "ECONNABORTED" === error.code) return !0;
    if (error.crossDomain) return !0;
  }
  return !1;
}, RequestBase.prototype._retry = function () {
  return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
}, RequestBase.prototype.then = function (resolve, reject) {
  var _this = this;
  if (!this._fullfilledPromise) {
    var self = this;
    this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function (resolve, reject) {
      self.on("abort", function () {
        if (!(_this._maxRetries && _this._maxRetries > _this._retries)) if (_this.timedout && _this.timedoutError) reject(_this.timedoutError);else {
          var error = new Error("Aborted");
          error.code = "ABORTED", error.status = _this.status, error.method = _this.method, error.url = _this.url, reject(error);
        }
      }), self.end(function (error, res) {
        error ? reject(error) : resolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}, RequestBase.prototype.catch = function (callback) {
  return this.then(void 0, callback);
}, RequestBase.prototype.use = function (fn) {
  return fn(this), this;
}, RequestBase.prototype.ok = function (callback) {
  if ("function" != typeof callback) throw new Error("Callback required");
  return this._okCallback = callback, this;
}, RequestBase.prototype._isResponseOK = function (res) {
  return !!res && (this._okCallback ? this._okCallback(res) : res.status >= 200 && res.status < 300);
}, RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
}, RequestBase.prototype.getHeader = RequestBase.prototype.get, RequestBase.prototype.set = function (field, value) {
  if (isObject(field)) {
    for (var key in field) hasOwn$1(field, key) && this.set(key, field[key]);
    return this;
  }
  return this._header[field.toLowerCase()] = value, this.header[field] = value, this;
}, RequestBase.prototype.unset = function (field) {
  return delete this._header[field.toLowerCase()], delete this.header[field], this;
}, RequestBase.prototype.field = function (name, value, options) {
  if (null == name) throw new Error(".field(name, val) name can not be empty");
  if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  if (isObject(name)) {
    for (var key in name) hasOwn$1(name, key) && this.field(key, name[key]);
    return this;
  }
  if (Array.isArray(value)) {
    for (var i in value) hasOwn$1(value, i) && this.field(name, value[i]);
    return this;
  }
  if (null == value) throw new Error(".field(name, val) val can not be empty");
  return "boolean" == typeof value && (value = String(value)), options ? this._getFormData().append(name, value, options) : this._getFormData().append(name, value), this;
}, RequestBase.prototype.abort = function () {
  return this._aborted || (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort")), this;
}, RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case "basic":
      this.set("Authorization", "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
      break;
    case "auto":
      this.username = user, this.password = pass;
      break;
    case "bearer":
      this.set("Authorization", "Bearer ".concat(user));
  }
  return this;
}, RequestBase.prototype.withCredentials = function (on) {
  return void 0 === on && (on = !0), this._withCredentials = on, this;
}, RequestBase.prototype.redirects = function (n) {
  return this._maxRedirects = n, this;
}, RequestBase.prototype.maxResponseSize = function (n) {
  if ("number" != typeof n) throw new TypeError("Invalid argument");
  return this._maxResponseSize = n, this;
}, RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
}, RequestBase.prototype.send = function (data) {
  var isObject_ = isObject(data),
    type = this._header["content-type"];
  if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  if (isObject_ && !this._data) Array.isArray(data) ? this._data = [] : this._isHost(data) || (this._data = {});else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
  if (isObject_ && isObject(this._data)) for (var key in data) {
    if ("bigint" == typeof data[key] && !data[key].toJSON) throw new Error("Cannot serialize BigInt value to json");
    hasOwn$1(data, key) && (this._data[key] = data[key]);
  } else {
    if ("bigint" == typeof data) throw new Error("Cannot send value of type BigInt");
    "string" == typeof data ? (type || this.type("form"), (type = this._header["content-type"]) && (type = type.toLowerCase().trim()), this._data = "application/x-www-form-urlencoded" === type ? this._data ? "".concat(this._data, "&").concat(data) : data : (this._data || "") + data) : this._data = data;
  }
  return !isObject_ || this._isHost(data) || type || this.type("json"), this;
}, RequestBase.prototype.sortQuery = function (sort) {
  return this._sort = void 0 === sort || sort, this;
}, RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join("&");
  if (query && (this.url += (this.url.includes("?") ? "&" : "?") + query), this._query.length = 0, this._sort) {
    var index = this.url.indexOf("?");
    if (index >= 0) {
      var queryArray = this.url.slice(index + 1).split("&");
      "function" == typeof this._sort ? queryArray.sort(this._sort) : queryArray.sort(), this.url = this.url.slice(0, index) + "?" + queryArray.join("&");
    }
  }
}, RequestBase.prototype._appendQueryString = function () {
  console.warn("Unsupported");
}, RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (!this._aborted) {
    var error = new Error("".concat(reason + timeout, "ms exceeded"));
    error.timeout = timeout, error.code = "ECONNABORTED", error.errno = errno, this.timedout = !0, this.timedoutError = error, this.abort(), this.callback(error);
  }
}, RequestBase.prototype._setTimeouts = function () {
  var self = this;
  this._timeout && !this._timer && (this._timer = setTimeout(function () {
    self._timeoutError("Timeout of ", self._timeout, "ETIME");
  }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function () {
    self._timeoutError("Response timeout of ", self._responseTimeout, "ETIMEDOUT");
  }, this._responseTimeout));
};
var responseBase = ResponseBase;
function ResponseBase() {}
ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
}, ResponseBase.prototype._setHeaderProperties = function (header) {
  var ct = header["content-type"] || "";
  this.type = utils$1.type(ct);
  var parameters = utils$1.params(ct);
  for (var key in parameters) Object.prototype.hasOwnProperty.call(parameters, key) && (this[key] = parameters[key]);
  this.links = {};
  try {
    header.link && (this.links = utils$1.parseLinks(header.link));
  } catch (err) {}
}, ResponseBase.prototype._setStatusProperties = function (status) {
  var type = Math.trunc(status / 100);
  this.statusCode = status, this.status = this.statusCode, this.statusType = type, this.info = 1 === type, this.ok = 2 === type, this.redirect = 3 === type, this.clientError = 4 === type, this.serverError = 5 === type, this.error = (4 === type || 5 === type) && this.toError(), this.created = 201 === status, this.accepted = 202 === status, this.noContent = 204 === status, this.badRequest = 400 === status, this.unauthorized = 401 === status, this.notAcceptable = 406 === status, this.forbidden = 403 === status, this.notFound = 404 === status, this.unprocessableEntity = 422 === status;
};
for (var Agent = function () {
    return function (e, r, t) {
      return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }(function Agent() {
      !function (a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, Agent), this._defaults = [];
    }, [{
      key: "_setDefaults",
      value: function (request) {
        var _step,
          _iterator = _createForOfIteratorHelper(this._defaults);
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var def = _step.value;
            request[def.fn].apply(request, _toConsumableArray(def.args));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }]);
  }(), _loop = function () {
    var fn = _defaults[_i];
    Agent.prototype[fn] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
      return this._defaults.push({
        fn: fn,
        args: args
      }), this;
    };
  }, _i = 0, _defaults = ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert", "disableTLSCerts"]; _i < _defaults.length; _i++) _loop();
for (var agentBase = Agent, client = createCommonjsModule(function (module, exports) {
    var root;
    "undefined" != typeof window ? root = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), root = void 0) : root = self;
    var isObject = utils$1.isObject,
      mixin = utils$1.mixin,
      hasOwn = utils$1.hasOwn;
    function noop() {}
    module.exports = function (method, url) {
      return "function" == typeof url ? new exports.Request("GET", method).end(url) : 1 === arguments.length ? new exports.Request("GET", method) : new exports.Request(method, url);
    };
    var request = exports = module.exports;
    exports.Request = Request, request.getXHR = function () {
      if (root.XMLHttpRequest) return new root.XMLHttpRequest();
      throw new Error("Browser-only version of superagent could not find XHR");
    };
    var trim = "".trim ? function (s) {
      return s.trim();
    } : function (s) {
      return s.replace(/(^\s*|\s*$)/g, "");
    };
    function serialize(object) {
      if (!isObject(object)) return object;
      var pairs = [];
      for (var key in object) hasOwn(object, key) && pushEncodedKeyValuePair(pairs, key, object[key]);
      return pairs.join("&");
    }
    function pushEncodedKeyValuePair(pairs, key, value) {
      if (void 0 !== value) if (null !== value) {
        if (Array.isArray(value)) {
          var _step,
            _iterator = _createForOfIteratorHelper(value);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              pushEncodedKeyValuePair(pairs, key, _step.value);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else if (isObject(value)) for (var subkey in value) hasOwn(value, subkey) && pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), value[subkey]);else pairs.push(encodeURI(key) + "=" + encodeURIComponent(value));
      } else pairs.push(encodeURI(key));
    }
    function parseString(string_) {
      for (var pair, pos, object = {}, pairs = string_.split("&"), i = 0, length_ = pairs.length; i < length_; ++i) -1 === (pos = (pair = pairs[i]).indexOf("=")) ? object[decodeURIComponent(pair)] = "" : object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
      return object;
    }
    function isJSON(mime) {
      return /[/+]json($|[^-\w])/i.test(mime);
    }
    function Response(request_) {
      this.req = request_, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
      var status = this.xhr.status;
      1223 === status && (status = 204), this._setStatusProperties(status), this.headers = function (string_) {
        for (var index, line, field, value, lines = string_.split(/\r?\n/), fields = {}, i = 0, length_ = lines.length; i < length_; ++i) -1 !== (index = (line = lines[i]).indexOf(":")) && (field = line.slice(0, index).toLowerCase(), value = trim(line.slice(index + 1)), fields[field] = value);
        return fields;
      }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && request_._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
    }
    function Request(method, url) {
      var self = this;
      this._query = this._query || [], this.method = method, this.url = url, this.header = {}, this._header = {}, this.on("end", function () {
        var new_error,
          error = null,
          res = null;
        try {
          res = new Response(self);
        } catch (err) {
          return (error = new Error("Parser is unable to parse the response")).parse = !0, error.original = err, self.xhr ? (error.rawResponse = void 0 === self.xhr.responseType ? self.xhr.responseText : self.xhr.response, error.status = self.xhr.status ? self.xhr.status : null, error.statusCode = error.status) : (error.rawResponse = null, error.status = null), self.callback(error);
        }
        self.emit("response", res);
        try {
          self._isResponseOK(res) || (new_error = new Error(res.statusText || res.text || "Unsuccessful HTTP response"));
        } catch (err) {
          new_error = err;
        }
        new_error ? (new_error.original = error, new_error.response = res, new_error.status = new_error.status || res.status, self.callback(new_error, res)) : self.callback(null, res);
      });
    }
    request.serializeObject = serialize, request.parseString = parseString, request.types = {
      html: "text/html",
      json: "application/json",
      xml: "text/xml",
      urlencoded: "application/x-www-form-urlencoded",
      form: "application/x-www-form-urlencoded",
      "form-data": "application/x-www-form-urlencoded"
    }, request.serialize = {
      "application/x-www-form-urlencoded": function (obj) {
        return lib_stringify(obj, {
          indices: !1,
          strictNullHandling: !0
        });
      },
      "application/json": fastSafeStringify
    }, request.parse = {
      "application/x-www-form-urlencoded": parseString,
      "application/json": JSON.parse
    }, mixin(Response.prototype, responseBase.prototype), Response.prototype._parseBody = function (string_) {
      var parse = request.parse[this.type];
      return this.req._parser ? this.req._parser(this, string_) : (!parse && isJSON(this.type) && (parse = request.parse["application/json"]), parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null);
    }, Response.prototype.toError = function () {
      var req = this.req,
        method = req.method,
        url = req.url,
        message = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")"),
        error = new Error(message);
      return error.status = this.status, error.method = method, error.url = url, error;
    }, request.Response = Response, componentEmitter(Request.prototype), mixin(Request.prototype, requestBase.prototype), Request.prototype.type = function (type) {
      return this.set("Content-Type", request.types[type] || type), this;
    }, Request.prototype.accept = function (type) {
      return this.set("Accept", request.types[type] || type), this;
    }, Request.prototype.auth = function (user, pass, options) {
      1 === arguments.length && (pass = ""), "object" === _typeof(pass) && null !== pass && (options = pass, pass = ""), options || (options = {
        type: "function" == typeof btoa ? "basic" : "auto"
      });
      var encoder = options.encoder ? options.encoder : function (string) {
        if ("function" == typeof btoa) return btoa(string);
        throw new Error("Cannot use basic auth, btoa is not a function");
      };
      return this._auth(user, pass, options, encoder);
    }, Request.prototype.query = function (value) {
      return "string" != typeof value && (value = serialize(value)), value && this._query.push(value), this;
    }, Request.prototype.attach = function (field, file, options) {
      if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
      }
      return this;
    }, Request.prototype._getFormData = function () {
      return this._formData || (this._formData = new root.FormData()), this._formData;
    }, Request.prototype.callback = function (error, res) {
      if (this._shouldRetry(error, res)) return this._retry();
      var fn = this._callback;
      this.clearTimeout(), error && (this._maxRetries && (error.retries = this._retries - 1), this.emit("error", error)), fn(error, res);
    }, Request.prototype.crossDomainError = function () {
      var error = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
      error.crossDomain = !0, error.status = this.status, error.method = this.method, error.url = this.url, this.callback(error);
    }, Request.prototype.agent = function () {
      return console.warn("This is not supported in browser version of superagent"), this;
    }, Request.prototype.ca = Request.prototype.agent, Request.prototype.buffer = Request.prototype.ca, Request.prototype.write = function () {
      throw new Error("Streaming is not supported in browser version of superagent");
    }, Request.prototype.pipe = Request.prototype.write, Request.prototype._isHost = function (object) {
      return object && "object" === _typeof(object) && !Array.isArray(object) && "[object Object]" !== Object.prototype.toString.call(object);
    }, Request.prototype.end = function (fn) {
      this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = fn || noop, this._finalizeQueryString(), this._end();
    }, Request.prototype._setUploadTimeout = function () {
      var self = this;
      this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function () {
        self._timeoutError("Upload timeout of ", self._uploadTimeout, "ETIMEDOUT");
      }, this._uploadTimeout));
    }, Request.prototype._end = function () {
      if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
      var self = this;
      this.xhr = request.getXHR();
      var xhr = this.xhr,
        data = this._formData || this._data;
      this._setTimeouts(), xhr.addEventListener("readystatechange", function () {
        var readyState = xhr.readyState;
        if (readyState >= 2 && self._responseTimeoutTimer && clearTimeout(self._responseTimeoutTimer), 4 === readyState) {
          var status;
          try {
            status = xhr.status;
          } catch (err) {
            status = 0;
          }
          if (!status) {
            if (self.timedout || self._aborted) return;
            return self.crossDomainError();
          }
          self.emit("end");
        }
      });
      var handleProgress = function (direction, e) {
        e.total > 0 && (e.percent = e.loaded / e.total * 100, 100 === e.percent && clearTimeout(self._uploadTimeoutTimer)), e.direction = direction, self.emit("progress", e);
      };
      if (this.hasListeners("progress")) try {
        xhr.addEventListener("progress", handleProgress.bind(null, "download")), xhr.upload && xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
      } catch (err) {}
      xhr.upload && this._setUploadTimeout();
      try {
        this.username && this.password ? xhr.open(this.method, this.url, !0, this.username, this.password) : xhr.open(this.method, this.url, !0);
      } catch (err) {
        return this.callback(err);
      }
      if (this._withCredentials && (xhr.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof data && !this._isHost(data)) {
        var contentType = this._header["content-type"],
          _serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
        !_serialize && isJSON(contentType) && (_serialize = request.serialize["application/json"]), _serialize && (data = _serialize(data));
      }
      for (var field in this.header) null !== this.header[field] && hasOwn(this.header, field) && xhr.setRequestHeader(field, this.header[field]);
      this._responseType && (xhr.responseType = this._responseType), this.emit("request", this), xhr.send(void 0 === data ? null : data);
    }, request.agent = function () {
      return new agentBase();
    };
    for (var _loop = function () {
        var method = _arr[_i];
        agentBase.prototype[method.toLowerCase()] = function (url, fn) {
          var request_ = new request.Request(method, url);
          return this._setDefaults(request_), fn && request_.end(fn), request_;
        };
      }, _i = 0, _arr = ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"]; _i < _arr.length; _i++) _loop();
    function del(url, data, fn) {
      var request_ = request("DELETE", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }
    agentBase.prototype.del = agentBase.prototype.delete, request.get = function (url, data, fn) {
      var request_ = request("GET", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.query(data), fn && request_.end(fn), request_;
    }, request.head = function (url, data, fn) {
      var request_ = request("HEAD", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.query(data), fn && request_.end(fn), request_;
    }, request.options = function (url, data, fn) {
      var request_ = request("OPTIONS", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.del = del, request.delete = del, request.patch = function (url, data, fn) {
      var request_ = request("PATCH", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.post = function (url, data, fn) {
      var request_ = request("POST", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    }, request.put = function (url, data, fn) {
      var request_ = request("PUT", url);
      return "function" == typeof data && (fn = data, data = null), data && request_.send(data), fn && request_.end(fn), request_;
    };
  }), byteLength_1 = (client.Request, function (b64) {
    var lens = getLens(b64),
      validLen = lens[0],
      placeHoldersLen = lens[1];
    return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
  }), toByteArray_1 = function (b64) {
    var tmp,
      i,
      lens = getLens(b64),
      validLen = lens[0],
      placeHoldersLen = lens[1],
      arr = new Arr(function (b64, validLen, placeHoldersLen) {
        return 3 * (validLen + placeHoldersLen) / 4 - placeHoldersLen;
      }(0, validLen, placeHoldersLen)),
      curByte = 0,
      len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for (i = 0; i < len; i += 4) tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)], arr[curByte++] = tmp >> 16 & 255, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp;
    2 === placeHoldersLen && (tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4, arr[curByte++] = 255 & tmp);
    1 === placeHoldersLen && (tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2, arr[curByte++] = tmp >> 8 & 255, arr[curByte++] = 255 & tmp);
    return arr;
  }, fromByteArray_1 = function (uint8) {
    for (var tmp, len = uint8.length, extraBytes = len % 3, parts = [], i = 0, len2 = len - extraBytes; i < len2; i += 16383) parts.push(encodeChunk(uint8, i, i + 16383 > len2 ? len2 : i + 16383));
    1 === extraBytes ? (tmp = uint8[len - 1], parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==")) : 2 === extraBytes && (tmp = (uint8[len - 2] << 8) + uint8[len - 1], parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="));
    return parts.join("");
  }, lookup = [], revLookup = [], Arr = "undefined" != typeof Uint8Array ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, len = code.length; i < len; ++i) lookup[i] = code[i], revLookup[code.charCodeAt(i)] = i;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var validLen = b64.indexOf("=");
  return -1 === validLen && (validLen = len), [validLen, validLen === len ? 0 : 4 - validLen % 4];
}
function encodeChunk(uint8, start, end) {
  for (var tmp, num, output = [], i = start; i < end; i += 3) tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (255 & uint8[i + 2]), output.push(lookup[(num = tmp) >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[63 & num]);
  return output.join("");
}
revLookup["-".charCodeAt(0)] = 62, revLookup["_".charCodeAt(0)] = 63;
var base64Js = {
  byteLength: byteLength_1,
  toByteArray: toByteArray_1,
  fromByteArray: fromByteArray_1
};
var base64Url = {
    encode: function (str) {
      return base64Js.fromByteArray(function (str) {
        for (var arr = new Array(str.length), a = 0; a < str.length; a++) arr[a] = str.charCodeAt(a);
        return arr;
      }(str)).replace(/\+/g, "-").replace(/\//g, "_");
    },
    decode: function (str) {
      return str = function (str) {
        var mod = str.length % 4;
        return 0 === mod ? str : str + new Array(1 + (4 - mod)).join("=");
      }(str).replace(/-/g, "+").replace(/_/g, "/"), function (array) {
        for (var result = "", i = 0; i < array.length; i++) result += String.fromCharCode(array[i]);
        return result;
      }(base64Js.toByteArray(str));
    }
  },
  version = {
    raw: "9.29.0"
  },
  toString = Object.prototype.toString;
function attribute(o, attr, type, text) {
  if (type = "array" === type ? "object" : type, o && _typeof(o[attr]) !== type) throw new Error(text);
}
function variable(o, type, text) {
  if (_typeof(o) !== type) throw new Error(text);
}
function value(o, values, text) {
  if (-1 === values.indexOf(o)) throw new Error(text);
}
var assert = {
  check: function (o, config, attributes) {
    if (config.optional && !o || variable(o, config.type, config.message), "object" === config.type && attributes) for (var keys = Object.keys(attributes), index = 0; index < keys.length; index++) {
      var a = keys[index];
      attributes[a].optional && !o[a] || attributes[a].condition && !attributes[a].condition(o) || (attribute(o, a, attributes[a].type, attributes[a].message), attributes[a].values && value(o[a], attributes[a].values, attributes[a].value_message));
    }
  },
  attribute: attribute,
  variable: variable,
  value: value,
  isArray: function (array) {
    return this.supportsIsArray() ? Array.isArray(array) : "[object Array]" === toString.call(array);
  },
  supportsIsArray: function () {
    return null != Array.isArray;
  }
};
function objectAssignPolyfill(target) {
  if (null == target) throw new TypeError("Cannot convert first argument to object");
  for (var to = Object(target), i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (null != nextSource) for (var keysArray = Object.keys(Object(nextSource)), nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex],
        desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      void 0 !== desc && desc.enumerable && (to[nextKey] = nextSource[nextKey]);
    }
  }
  return to;
}
var objectAssign = {
  get: function () {
    return Object.assign ? Object.assign : objectAssignPolyfill;
  },
  objectAssignPolyfill: objectAssignPolyfill
};
function pick(object, keys) {
  return keys.reduce(function (prev, key) {
    return object[key] && (prev[key] = object[key]), prev;
  }, {});
}
function objectValues(obj) {
  var values = [];
  for (var key in obj) values.push(obj[key]);
  return values;
}
function extend() {
  var params = objectValues(arguments);
  return params.unshift({}), objectAssign.get().apply(void 0, params);
}
function getLocationFromUrl(href) {
  var match = href.match(/^(https?:|file:|chrome-extension:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  };
}
function trim(options, key) {
  var trimmed = extend(options);
  return options[key] && (trimmed[key] = options[key].trim()), trimmed;
}
var objectHelper = {
  toSnakeCase: function toSnakeCase(object, exceptions) {
    return "object" !== _typeof(object) || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function (p, key) {
      return p[-1 === exceptions.indexOf(key) ? function (str) {
        for (var code, newKey = "", index = 0, wasPrevNumber = !0, wasPrevUppercase = !0; index < str.length;) code = str.charCodeAt(index), !wasPrevUppercase && code >= 65 && code <= 90 || !wasPrevNumber && code >= 48 && code <= 57 ? (newKey += "_", newKey += str[index].toLowerCase()) : newKey += str[index].toLowerCase(), wasPrevNumber = code >= 48 && code <= 57, wasPrevUppercase = code >= 65 && code <= 90, index++;
        return newKey;
      }(key) : key] = toSnakeCase(object[key]), p;
    }, {}));
  },
  toCamelCase: function toCamelCase(object, exceptions, options) {
    return "object" !== _typeof(object) || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], options = options || {}, Object.keys(object).reduce(function (p, key) {
      var parts,
        newKey = -1 === exceptions.indexOf(key) ? (parts = key.split("_")).reduce(function (p, c) {
          return p + c.charAt(0).toUpperCase() + c.slice(1);
        }, parts.shift()) : key;
      return p[newKey] = toCamelCase(object[newKey] || object[key], [], options), options.keepOriginal && (p[key] = toCamelCase(object[key], [], options)), p;
    }, {}));
  },
  blacklist: function (object, blacklistedKeys) {
    return Object.keys(object).reduce(function (p, key) {
      return -1 === blacklistedKeys.indexOf(key) && (p[key] = object[key]), p;
    }, {});
  },
  merge: function (object, keys) {
    return {
      base: keys ? pick(object, keys) : object,
      with: function (object2, keys2) {
        return object2 = keys2 ? pick(object2, keys2) : object2, extend(this.base, object2);
      }
    };
  },
  pick: pick,
  getKeysNotIn: function (obj, allowedKeys) {
    var notAllowed = [];
    for (var key in obj) -1 === allowedKeys.indexOf(key) && notAllowed.push(key);
    return notAllowed;
  },
  extend: extend,
  getOriginFromUrl: function (url) {
    if (url) {
      var parsed = getLocationFromUrl(url);
      if (!parsed) return null;
      var origin = parsed.protocol + "//" + parsed.hostname;
      return parsed.port && (origin += ":" + parsed.port), origin;
    }
  },
  getLocationFromUrl: getLocationFromUrl,
  trimUserDetails: function (options) {
    return function (options, keys) {
      return keys.reduce(trim, options);
    }(options, ["username", "email", "phoneNumber"]);
  },
  updatePropertyOn: function updatePropertyOn(obj, path, value) {
    "string" == typeof path && (path = path.split("."));
    var next = path[0];
    obj.hasOwnProperty(next) && (1 === path.length ? obj[next] = value : updatePropertyOn(obj[next], path.slice(1), value));
  }
};
function RequestWrapper(req) {
  this.request = req, this.method = req.method, this.url = req.url, this.body = req._data, this.headers = req._header;
}
function RequestObj(req) {
  this.request = req;
}
function RequestBuilder(options) {
  this._sendTelemetry = !1 !== options._sendTelemetry || options._sendTelemetry, this._telemetryInfo = options._telemetryInfo || null, this._timesToRetryFailedRequests = options._timesToRetryFailedRequests, this.headers = options.headers || {}, this._universalLoginPage = options.universalLoginPage;
}
function getWindow() {
  return window;
}
RequestWrapper.prototype.abort = function () {
  this.request.abort();
}, RequestWrapper.prototype.getMethod = function () {
  return this.method;
}, RequestWrapper.prototype.getBody = function () {
  return this.body;
}, RequestWrapper.prototype.getUrl = function () {
  return this.url;
}, RequestWrapper.prototype.getHeaders = function () {
  return this.headers;
}, RequestObj.prototype.set = function (key, value) {
  return this.request = this.request.set(key, value), this;
}, RequestObj.prototype.send = function (body) {
  return this.request = this.request.send(objectHelper.trimUserDetails(body)), this;
}, RequestObj.prototype.withCredentials = function () {
  return this.request = this.request.withCredentials(), this;
}, RequestObj.prototype.end = function (cb) {
  return this.request.end(cb), new RequestWrapper(this.request);
}, RequestBuilder.prototype.setCommonConfiguration = function (ongoingRequest, options) {
  if (options = options || {}, this._timesToRetryFailedRequests > 0 && (ongoingRequest = ongoingRequest.retry(this._timesToRetryFailedRequests)), options.noHeaders) return ongoingRequest;
  var headers = this.headers;
  ongoingRequest = ongoingRequest.set("Content-Type", "application/json"), options.xRequestLanguage && (ongoingRequest = ongoingRequest.set("X-Request-Language", options.xRequestLanguage));
  for (var keys = Object.keys(this.headers), a = 0; a < keys.length; a++) ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
  return this._sendTelemetry && (ongoingRequest = ongoingRequest.set("Auth0-Client", this.getTelemetryData())), ongoingRequest;
}, RequestBuilder.prototype.getTelemetryData = function () {
  var telemetryName = this._universalLoginPage ? "auth0.js-ulp" : "auth0.js",
    clientInfo = {
      name: telemetryName,
      version: version.raw
    };
  this._telemetryInfo && ((clientInfo = objectHelper.extend({}, this._telemetryInfo)).env = objectHelper.extend({}, this._telemetryInfo.env), clientInfo.env[telemetryName] = version.raw);
  var jsonClientInfo = JSON.stringify(clientInfo);
  return base64Url.encode(jsonClientInfo);
}, RequestBuilder.prototype.get = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(client.get(url), options));
}, RequestBuilder.prototype.post = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(client.post(url), options));
}, RequestBuilder.prototype.patch = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(client.patch(url), options));
};
var windowHelper = {
  redirect: function (url) {
    getWindow().location = url;
  },
  getDocument: function () {
    return getWindow().document;
  },
  getWindow: getWindow,
  getOrigin: function () {
    var location = getWindow().location,
      origin = location.origin;
    return origin || (origin = objectHelper.getOriginFromUrl(location.href)), origin;
  }
};
function DummyStorage() {}
DummyStorage.prototype.getItem = function () {
  return null;
}, DummyStorage.prototype.removeItem = function () {}, DummyStorage.prototype.setItem = function () {};
var js_cookie = createCommonjsModule(function (module, exports) {
  var factory;
  factory = function () {
    function extend() {
      for (var i = 0, result = {}; i < arguments.length; i++) {
        var attributes = arguments[i];
        for (var key in attributes) result[key] = attributes[key];
      }
      return result;
    }
    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    return function init(converter) {
      function api() {}
      function set(key, value, attributes) {
        if ("undefined" != typeof document) {
          "number" == typeof (attributes = extend({
            path: "/"
          }, api.defaults, attributes)).expires && (attributes.expires = new Date(1 * new Date() + 864e5 * attributes.expires)), attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
          try {
            var result = JSON.stringify(value);
            /^[\{\[]/.test(result) && (value = result);
          } catch (e) {}
          value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var stringifiedAttributes = "";
          for (var attributeName in attributes) attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, !0 !== attributes[attributeName] && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
          return document.cookie = key + "=" + value + stringifiedAttributes;
        }
      }
      function get(key, json) {
        if ("undefined" != typeof document) {
          for (var jar = {}, cookies = document.cookie ? document.cookie.split("; ") : [], i = 0; i < cookies.length; i++) {
            var parts = cookies[i].split("="),
              cookie = parts.slice(1).join("=");
            json || '"' !== cookie.charAt(0) || (cookie = cookie.slice(1, -1));
            try {
              var name = decode(parts[0]);
              if (cookie = (converter.read || converter)(cookie, name) || decode(cookie), json) try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
              if (jar[name] = cookie, key === name) break;
            } catch (e) {}
          }
          return key ? jar[key] : jar;
        }
      }
      return api.set = set, api.get = function (key) {
        return get(key, !1);
      }, api.getJSON = function (key) {
        return get(key, !0);
      }, api.remove = function (key, attributes) {
        set(key, "", extend(attributes, {
          expires: -1
        }));
      }, api.defaults = {}, api.withConverter = init, api;
    }(function () {});
  }, module.exports = factory();
});
function buildCompatCookieKey(key) {
  return "_" + key + "_compat";
}
function CookieStorage(options) {
  this._options = options || {};
}
function Warn(options) {
  this.disableWarnings = options.disableWarnings;
}
function StorageHandler(options) {
  if (this.warn = new Warn({}), this.storage = new CookieStorage(options), !0 === options.__tryLocalStorageFirst) try {
    var localStorage = windowHelper.getWindow().localStorage;
    localStorage && (this.storage = localStorage);
  } catch (e) {
    this.warn.warning(e), this.warn.warning("Can't use localStorage. Using CookieStorage instead.");
  }
}
function Storage(options) {
  this.handler = new StorageHandler(options);
}
function SSODataStorage(options) {
  this.storage = new Storage(options);
}
function buildResponse(error, description) {
  return {
    error: error,
    errorDescription: description
  };
}
CookieStorage.prototype.getItem = function (key) {
  return js_cookie.get(key) || js_cookie.get(buildCompatCookieKey(key));
}, CookieStorage.prototype.removeItem = function (key) {
  var params = {};
  this._options.cookieDomain && (params.domain = this._options.cookieDomain), js_cookie.remove(key, params), js_cookie.remove(buildCompatCookieKey(key), params);
}, CookieStorage.prototype.setItem = function (key, value, options) {
  var params = objectHelper.extend({
    expires: 1
  }, options);
  if ("https:" === windowHelper.getWindow().location.protocol && (params.secure = !0, params.sameSite = "none", this._options.legacySameSiteCookie)) {
    var legacyOptions = objectHelper.blacklist(params, ["sameSite"]);
    js_cookie.set(buildCompatCookieKey(key), value, legacyOptions);
  }
  this._options.cookieDomain && (params.domain = this._options.cookieDomain), js_cookie.set(key, value, params);
}, Warn.prototype.warning = function (message) {
  this.disableWarnings || console.warn(message);
}, StorageHandler.prototype.failover = function () {
  this.storage instanceof DummyStorage ? this.warn.warning("DummyStorage: ignore failover") : this.storage instanceof CookieStorage ? (this.warn.warning("CookieStorage: failing over DummyStorage"), this.storage = new DummyStorage()) : (this.warn.warning("LocalStorage: failing over CookieStorage"), this.storage = new CookieStorage());
}, StorageHandler.prototype.getItem = function (key) {
  try {
    return this.storage.getItem(key);
  } catch (e) {
    return this.warn.warning(e), this.failover(), this.getItem(key);
  }
}, StorageHandler.prototype.removeItem = function (key) {
  try {
    return this.storage.removeItem(key);
  } catch (e) {
    return this.warn.warning(e), this.failover(), this.removeItem(key);
  }
}, StorageHandler.prototype.setItem = function (key, value, options) {
  try {
    return this.storage.setItem(key, value, options);
  } catch (e) {
    return this.warn.warning(e), this.failover(), this.setItem(key, value, options);
  }
}, Storage.prototype.getItem = function (key) {
  var value = this.handler.getItem(key);
  try {
    return JSON.parse(value);
  } catch (_) {
    return value;
  }
}, Storage.prototype.removeItem = function (key) {
  return this.handler.removeItem(key);
}, Storage.prototype.setItem = function (key, value, options) {
  var json = JSON.stringify(value);
  return this.handler.setItem(key, json, options);
}, SSODataStorage.prototype.set = function (connection, sub) {
  var ssodata = {
    lastUsedConnection: connection,
    lastUsedSub: sub
  };
  this.storage.setItem("auth0.ssodata", JSON.stringify(ssodata));
}, SSODataStorage.prototype.get = function () {
  var ssodata = this.storage.getItem("auth0.ssodata");
  if (ssodata) return JSON.parse(ssodata);
};
var error = {
  buildResponse: buildResponse,
  invalidToken: function (description) {
    return buildResponse("invalid_token", description);
  }
};
function wrapCallback(cb, options) {
  return (options = options || {}).ignoreCasing = !!options.ignoreCasing && options.ignoreCasing, function (err, data) {
    var errObj;
    return err || data ? (!err && data.err && (err = data.err, data = null), !err && data.error && (err = data, data = null), err ? (errObj = {
      original: err
    }, objectHelper.updatePropertyOn(errObj, "original.response.req._data.password", "*****"), err.response && err.response.statusCode && (errObj.statusCode = err.response.statusCode), err.response && err.response.statusText && (errObj.statusText = err.response.statusText), err.response && err.response.body && (err = err.response.body), err.err && (err = err.err), errObj.code = err.code || err.error || err.error_code || err.status || null, errObj.description = err.errorDescription || err.error_description || err.description || err.error || err.details || err.err || null, options.forceLegacyError && (errObj.error = errObj.code, errObj.error_description = errObj.description), err.error_codes && err.error_details && (errObj.errorDetails = {
      codes: err.error_codes,
      details: err.error_details
    }), err.name && (errObj.name = err.name), err.policy && (errObj.policy = err.policy), cb(errObj)) : !data.type || "text/html" !== data.type && "text/plain" !== data.type ? options.ignoreCasing ? cb(null, data.body || data) : cb(null, objectHelper.toCamelCase(data.body || data, [], {
      keepOriginal: options.keepOriginalCasing
    })) : cb(null, data.text)) : cb(error.buildResponse("generic_error", "Something went wrong"));
  };
}
var tokenParams = ["realm", "audience", "otp", "client_id", "client_secret", "redirect_uri", "scope", "code", "grant_type", "username", "password", "refresh_token", "assertion", "client_assertion", "client_assertion_type", "code_verifier"],
  authorizeParams = ["connection", "connection_scope", "auth0Client", "owp", "device", "realm", "organization", "invitation", "protocol", "_csrf", "_intstate", "login_ticket", "client_id", "response_type", "response_mode", "redirect_uri", "audience", "scope", "state", "nonce", "display", "prompt", "screen_hint", "max_age", "ui_locales", "claims_locales", "id_token_hint", "login_hint", "acr_values", "claims", "registration", "request", "request_uri", "code_challenge", "code_challenge_method", "access_type", "display"];
var parametersWhitelist = {
    oauthTokenParams: function (warn, params) {
      return objectHelper.pick(params, tokenParams);
    },
    oauthAuthorizeParams: function (warn, params) {
      var notAllowed = objectHelper.getKeysNotIn(params, authorizeParams);
      return notAllowed.length > 0 && warn.warning("Following parameters are not allowed on the `/authorize` endpoint: [" + notAllowed.join(",") + "]"), params;
    }
  },
  t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function e(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}
var r = e(function (e, r) {
    e.exports = function () {
      function e(t) {
        return "function" == typeof t;
      }
      var r = Array.isArray ? Array.isArray : function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        },
        i = 0,
        n = void 0,
        o = void 0,
        s = function (t, e) {
          l[i] = t, l[i + 1] = e, 2 === (i += 2) && (o ? o(d) : w());
        },
        h = "undefined" != typeof window ? window : void 0,
        u = h || {},
        a = u.MutationObserver || u.WebKitMutationObserver,
        f = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
        c = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
      function p() {
        var t = setTimeout;
        return function () {
          return t(d, 1);
        };
      }
      var l = new Array(1e3);
      function d() {
        for (var t = 0; t < i; t += 2) (0, l[t])(l[t + 1]), l[t] = void 0, l[t + 1] = void 0;
        i = 0;
      }
      var m,
        v,
        y,
        g,
        w = void 0;
      function T(t, e) {
        var r = this,
          i = new this.constructor(S);
        void 0 === i[_] && N(i);
        var n = r._state;
        if (n) {
          var o = arguments[n - 1];
          s(function () {
            return O(n, i, o, r._result);
          });
        } else C(r, i, t, e);
        return i;
      }
      function b(t) {
        if (t && "object" == typeof t && t.constructor === this) return t;
        var e = new this(S);
        return E(e, t), e;
      }
      w = f ? function () {
        return process.nextTick(d);
      } : a ? (v = 0, y = new a(d), g = document.createTextNode(""), y.observe(g, {
        characterData: !0
      }), function () {
        g.data = v = ++v % 2;
      }) : c ? ((m = new MessageChannel()).port1.onmessage = d, function () {
        return m.port2.postMessage(0);
      }) : void 0 === h ? function () {
        try {
          var t = Function("return this")().require("vertx");
          return void 0 !== (n = t.runOnLoop || t.runOnContext) ? function () {
            n(d);
          } : p();
        } catch (t) {
          return p();
        }
      }() : p();
      var _ = Math.random().toString(36).substring(2);
      function S() {}
      var A = void 0;
      function x(t, r, i) {
        r.constructor === t.constructor && i === T && r.constructor.resolve === b ? function (t, e) {
          1 === e._state ? I(t, e._result) : 2 === e._state ? M(t, e._result) : C(e, void 0, function (e) {
            return E(t, e);
          }, function (e) {
            return M(t, e);
          });
        }(t, r) : void 0 === i ? I(t, r) : e(i) ? function (t, e, r) {
          s(function (t) {
            var i = !1,
              n = function (r, n, o, s) {
                try {
                  r.call(n, function (r) {
                    i || (i = !0, e !== r ? E(t, r) : I(t, r));
                  }, function (e) {
                    i || (i = !0, M(t, e));
                  });
                } catch (t) {
                  return t;
                }
              }(r, e);
            !i && n && (i = !0, M(t, n));
          }, t);
        }(t, r, i) : I(t, r);
      }
      function E(t, e) {
        if (t === e) M(t, new TypeError("You cannot resolve a promise with itself"));else if (n = typeof (i = e), null === i || "object" !== n && "function" !== n) I(t, e);else {
          var r = void 0;
          try {
            r = e.then;
          } catch (e) {
            return void M(t, e);
          }
          x(t, e, r);
        }
        var i, n;
      }
      function k(t) {
        t._onerror && t._onerror(t._result), R(t);
      }
      function I(t, e) {
        t._state === A && (t._result = e, t._state = 1, 0 !== t._subscribers.length && s(R, t));
      }
      function M(t, e) {
        t._state === A && (t._state = 2, t._result = e, s(k, t));
      }
      function C(t, e, r, i) {
        var n = t._subscribers,
          o = n.length;
        t._onerror = null, n[o] = e, n[o + 1] = r, n[o + 2] = i, 0 === o && t._state && s(R, t);
      }
      function R(t) {
        var e = t._subscribers,
          r = t._state;
        if (0 !== e.length) {
          for (var i = void 0, n = void 0, o = t._result, s = 0; s < e.length; s += 3) n = e[s + r], (i = e[s]) ? O(r, i, n, o) : n(o);
          t._subscribers.length = 0;
        }
      }
      function O(t, r, i, n) {
        var o = e(i),
          s = void 0,
          h = void 0,
          u = !0;
        if (o) {
          try {
            s = i(n);
          } catch (t) {
            u = !1, h = t;
          }
          if (r === s) return void M(r, new TypeError("A promises callback cannot return that same promise."));
        } else s = n;
        r._state !== A || (o && u ? E(r, s) : !1 === u ? M(r, h) : 1 === t ? I(r, s) : 2 === t && M(r, s));
      }
      var j = 0;
      function N(t) {
        t[_] = j++, t._state = void 0, t._result = void 0, t._subscribers = [];
      }
      var P = function () {
          function t(t, e) {
            this._instanceConstructor = t, this.promise = new t(S), this.promise[_] || N(this.promise), r(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? I(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && I(this.promise, this._result))) : M(this.promise, new Error("Array Methods must be provided an Array"));
          }
          return t.prototype._enumerate = function (t) {
            for (var e = 0; this._state === A && e < t.length; e++) this._eachEntry(t[e], e);
          }, t.prototype._eachEntry = function (t, e) {
            var r = this._instanceConstructor,
              i = r.resolve;
            if (i === b) {
              var n = void 0,
                o = void 0,
                s = !1;
              try {
                n = t.then;
              } catch (t) {
                s = !0, o = t;
              }
              if (n === T && t._state !== A) this._settledAt(t._state, e, t._result);else if ("function" != typeof n) this._remaining--, this._result[e] = t;else if (r === V) {
                var h = new r(S);
                s ? M(h, o) : x(h, t, n), this._willSettleAt(h, e);
              } else this._willSettleAt(new r(function (e) {
                return e(t);
              }), e);
            } else this._willSettleAt(i(t), e);
          }, t.prototype._settledAt = function (t, e, r) {
            var i = this.promise;
            i._state === A && (this._remaining--, 2 === t ? M(i, r) : this._result[e] = r), 0 === this._remaining && I(i, this._result);
          }, t.prototype._willSettleAt = function (t, e) {
            var r = this;
            C(t, void 0, function (t) {
              return r._settledAt(1, e, t);
            }, function (t) {
              return r._settledAt(2, e, t);
            });
          }, t;
        }(),
        V = function () {
          function t(e) {
            this[_] = j++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function () {
              throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            }(), this instanceof t ? function (t, e) {
              try {
                e(function (e) {
                  E(t, e);
                }, function (e) {
                  M(t, e);
                });
              } catch (e) {
                M(t, e);
              }
            }(this, e) : function () {
              throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }());
          }
          return t.prototype.catch = function (t) {
            return this.then(null, t);
          }, t.prototype.finally = function (t) {
            var r = this,
              i = r.constructor;
            return e(t) ? r.then(function (e) {
              return i.resolve(t()).then(function () {
                return e;
              });
            }, function (e) {
              return i.resolve(t()).then(function () {
                throw e;
              });
            }) : r.then(t, t);
          }, t;
        }();
      return V.prototype.then = T, V.all = function (t) {
        return new P(this, t).promise;
      }, V.race = function (t) {
        var e = this;
        return r(t) ? new e(function (r, i) {
          for (var n = t.length, o = 0; o < n; o++) e.resolve(t[o]).then(r, i);
        }) : new e(function (t, e) {
          return e(new TypeError("You must pass an array to race."));
        });
      }, V.resolve = b, V.reject = function (t) {
        var e = new this(S);
        return M(e, t), e;
      }, V._setScheduler = function (t) {
        o = t;
      }, V._setAsap = function (t) {
        s = t;
      }, V._asap = s, V.polyfill = function () {
        var e = void 0;
        if (void 0 !== t) e = t;else if ("undefined" != typeof self) e = self;else try {
          e = Function("return this")();
        } catch (t) {
          throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var r = e.Promise;
        if (r) {
          var i = null;
          try {
            i = Object.prototype.toString.call(r.resolve());
          } catch (t) {}
          if ("[object Promise]" === i && !r.cast) return;
        }
        e.Promise = V;
      }, V.Promise = V, V;
    }();
  }),
  i$1 = {
    __proto__: null,
    default: {}
  },
  n = e(function (e, r) {
    var n;
    e.exports = n = n || function (e, r) {
      var n;
      if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== t && t.crypto && (n = t.crypto), !n) try {
        n = i$1;
      } catch (t) {}
      var o = function () {
          if (n) {
            if ("function" == typeof n.getRandomValues) try {
              return n.getRandomValues(new Uint32Array(1))[0];
            } catch (t) {}
            if ("function" == typeof n.randomBytes) try {
              return n.randomBytes(4).readInt32LE();
            } catch (t) {}
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        },
        s = Object.create || function () {
          function t() {}
          return function (e) {
            var r;
            return t.prototype = e, r = new t(), t.prototype = null, r;
          };
        }(),
        h = {},
        u = h.lib = {},
        a = u.Base = {
          extend: function (t) {
            var e = s(this);
            return t && e.mixIn(t), e.hasOwnProperty("init") && this.init !== e.init || (e.init = function () {
              e.$super.init.apply(this, arguments);
            }), e.init.prototype = e, e.$super = this, e;
          },
          create: function () {
            var t = this.extend();
            return t.init.apply(t, arguments), t;
          },
          init: function () {},
          mixIn: function (t) {
            for (var e in t) t.hasOwnProperty(e) && (this[e] = t[e]);
            t.hasOwnProperty("toString") && (this.toString = t.toString);
          },
          clone: function () {
            return this.init.prototype.extend(this);
          }
        },
        f = u.WordArray = a.extend({
          init: function (t, e) {
            t = this.words = t || [], this.sigBytes = null != e ? e : 4 * t.length;
          },
          toString: function (t) {
            return (t || p).stringify(this);
          },
          concat: function (t) {
            var e = this.words,
              r = t.words,
              i = this.sigBytes,
              n = t.sigBytes;
            if (this.clamp(), i % 4) for (var o = 0; o < n; o++) e[i + o >>> 2] |= (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 24 - (i + o) % 4 * 8;else for (var s = 0; s < n; s += 4) e[i + s >>> 2] = r[s >>> 2];
            return this.sigBytes += n, this;
          },
          clamp: function () {
            var t = this.words,
              r = this.sigBytes;
            t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = e.ceil(r / 4);
          },
          clone: function () {
            var t = a.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          random: function (t) {
            for (var e = [], r = 0; r < t; r += 4) e.push(o());
            return new f.init(e, t);
          }
        }),
        c = h.enc = {},
        p = c.Hex = {
          stringify: function (t) {
            for (var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++) {
              var o = e[n >>> 2] >>> 24 - n % 4 * 8 & 255;
              i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
            }
            return i.join("");
          },
          parse: function (t) {
            for (var e = t.length, r = [], i = 0; i < e; i += 2) r[i >>> 3] |= parseInt(t.substr(i, 2), 16) << 24 - i % 8 * 4;
            return new f.init(r, e / 2);
          }
        },
        l = c.Latin1 = {
          stringify: function (t) {
            for (var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++) i.push(String.fromCharCode(e[n >>> 2] >>> 24 - n % 4 * 8 & 255));
            return i.join("");
          },
          parse: function (t) {
            for (var e = t.length, r = [], i = 0; i < e; i++) r[i >>> 2] |= (255 & t.charCodeAt(i)) << 24 - i % 4 * 8;
            return new f.init(r, e);
          }
        },
        d = c.Utf8 = {
          stringify: function (t) {
            try {
              return decodeURIComponent(escape(l.stringify(t)));
            } catch (t) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function (t) {
            return l.parse(unescape(encodeURIComponent(t)));
          }
        },
        m = u.BufferedBlockAlgorithm = a.extend({
          reset: function () {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          _append: function (t) {
            "string" == typeof t && (t = d.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          _process: function (t) {
            var r,
              i = this._data,
              n = i.words,
              o = i.sigBytes,
              s = this.blockSize,
              h = o / (4 * s),
              u = (h = t ? e.ceil(h) : e.max((0 | h) - this._minBufferSize, 0)) * s,
              a = e.min(4 * u, o);
            if (u) {
              for (var c = 0; c < u; c += s) this._doProcessBlock(n, c);
              r = n.splice(0, u), i.sigBytes -= a;
            }
            return new f.init(r, a);
          },
          clone: function () {
            var t = a.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
      u.Hasher = m.extend({
        cfg: a.extend(),
        init: function (t) {
          this.cfg = this.cfg.extend(t), this.reset();
        },
        reset: function () {
          m.reset.call(this), this._doReset();
        },
        update: function (t) {
          return this._append(t), this._process(), this;
        },
        finalize: function (t) {
          return t && this._append(t), this._doFinalize();
        },
        blockSize: 16,
        _createHelper: function (t) {
          return function (e, r) {
            return new t.init(r).finalize(e);
          };
        },
        _createHmacHelper: function (t) {
          return function (e, r) {
            return new v.HMAC.init(t, r).finalize(e);
          };
        }
      });
      var v = h.algo = {};
      return h;
    }(Math);
  }),
  o = e(function (t, e) {
    var r;
    t.exports = (r = n, function (t) {
      var e = r,
        i = e.lib,
        n = i.WordArray,
        o = i.Hasher,
        s = e.algo,
        h = [],
        u = [];
      !function () {
        function e(e) {
          for (var r = t.sqrt(e), i = 2; i <= r; i++) if (!(e % i)) return !1;
          return !0;
        }
        function r(t) {
          return 4294967296 * (t - (0 | t)) | 0;
        }
        for (var i = 2, n = 0; n < 64;) e(i) && (n < 8 && (h[n] = r(t.pow(i, .5))), u[n] = r(t.pow(i, 1 / 3)), n++), i++;
      }();
      var a = [],
        f = s.SHA256 = o.extend({
          _doReset: function () {
            this._hash = new n.init(h.slice(0));
          },
          _doProcessBlock: function (t, e) {
            for (var r = this._hash.words, i = r[0], n = r[1], o = r[2], s = r[3], h = r[4], f = r[5], c = r[6], p = r[7], l = 0; l < 64; l++) {
              if (l < 16) a[l] = 0 | t[e + l];else {
                var d = a[l - 15],
                  m = a[l - 2];
                a[l] = ((d << 25 | d >>> 7) ^ (d << 14 | d >>> 18) ^ d >>> 3) + a[l - 7] + ((m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10) + a[l - 16];
              }
              var v = i & n ^ i & o ^ n & o,
                y = p + ((h << 26 | h >>> 6) ^ (h << 21 | h >>> 11) ^ (h << 7 | h >>> 25)) + (h & f ^ ~h & c) + u[l] + a[l];
              p = c, c = f, f = h, h = s + y | 0, s = o, o = n, n = i, i = y + (((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + v) | 0;
            }
            r[0] = r[0] + i | 0, r[1] = r[1] + n | 0, r[2] = r[2] + o | 0, r[3] = r[3] + s | 0, r[4] = r[4] + h | 0, r[5] = r[5] + f | 0, r[6] = r[6] + c | 0, r[7] = r[7] + p | 0;
          },
          _doFinalize: function () {
            var e = this._data,
              r = e.words,
              i = 8 * this._nDataBytes,
              n = 8 * e.sigBytes;
            return r[n >>> 5] |= 128 << 24 - n % 32, r[14 + (n + 64 >>> 9 << 4)] = t.floor(i / 4294967296), r[15 + (n + 64 >>> 9 << 4)] = i, e.sigBytes = 4 * r.length, this._process(), this._hash;
          },
          clone: function () {
            var t = o.clone.call(this);
            return t._hash = this._hash.clone(), t;
          }
        });
      e.SHA256 = o._createHelper(f), e.HmacSHA256 = o._createHmacHelper(f);
    }(Math), r.SHA256);
  }),
  s = e(function (t, e) {
    var r, i;
    t.exports = (i = (r = n).lib.WordArray, r.enc.Base64 = {
      stringify: function (t) {
        var e = t.words,
          r = t.sigBytes,
          i = this._map;
        t.clamp();
        for (var n = [], o = 0; o < r; o += 3) for (var s = (e[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (e[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | e[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, h = 0; h < 4 && o + .75 * h < r; h++) n.push(i.charAt(s >>> 6 * (3 - h) & 63));
        var u = i.charAt(64);
        if (u) for (; n.length % 4;) n.push(u);
        return n.join("");
      },
      parse: function (t) {
        var e = t.length,
          r = this._map,
          n = this._reverseMap;
        if (!n) {
          n = this._reverseMap = [];
          for (var o = 0; o < r.length; o++) n[r.charCodeAt(o)] = o;
        }
        var s = r.charAt(64);
        if (s) {
          var h = t.indexOf(s);
          -1 !== h && (e = h);
        }
        return function (t, e, r) {
          for (var n = [], o = 0, s = 0; s < e; s++) if (s % 4) {
            var h = r[t.charCodeAt(s - 1)] << s % 4 * 2,
              u = r[t.charCodeAt(s)] >>> 6 - s % 4 * 2;
            n[o >>> 2] |= (h | u) << 24 - o % 4 * 8, o++;
          }
          return i.create(n, o);
        }(t, e, n);
      },
      _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, r.enc.Base64);
  }),
  h = e(function (t, e) {
    t.exports = n.enc.Hex;
  }),
  u = e(function (e, r) {
    (function () {
      var t;
      function r(t, e, r) {
        null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : this.fromString(t, null == e && "string" != typeof t ? 256 : e));
      }
      function i() {
        return new r(null);
      }
      var n = "undefined" != typeof navigator;
      n && "Microsoft Internet Explorer" == navigator.appName ? (r.prototype.am = function (t, e, r, i, n, o) {
        for (var s = 32767 & e, h = e >> 15; --o >= 0;) {
          var u = 32767 & this[t],
            a = this[t++] >> 15,
            f = h * u + a * s;
          n = ((u = s * u + ((32767 & f) << 15) + r[i] + (1073741823 & n)) >>> 30) + (f >>> 15) + h * a + (n >>> 30), r[i++] = 1073741823 & u;
        }
        return n;
      }, t = 30) : n && "Netscape" != navigator.appName ? (r.prototype.am = function (t, e, r, i, n, o) {
        for (; --o >= 0;) {
          var s = e * this[t++] + r[i] + n;
          n = Math.floor(s / 67108864), r[i++] = 67108863 & s;
        }
        return n;
      }, t = 26) : (r.prototype.am = function (t, e, r, i, n, o) {
        for (var s = 16383 & e, h = e >> 14; --o >= 0;) {
          var u = 16383 & this[t],
            a = this[t++] >> 14,
            f = h * u + a * s;
          n = ((u = s * u + ((16383 & f) << 14) + r[i] + n) >> 28) + (f >> 14) + h * a, r[i++] = 268435455 & u;
        }
        return n;
      }, t = 28), r.prototype.DB = t, r.prototype.DM = (1 << t) - 1, r.prototype.DV = 1 << t, r.prototype.FV = Math.pow(2, 52), r.prototype.F1 = 52 - t, r.prototype.F2 = 2 * t - 52;
      var o,
        s,
        h = new Array();
      for (o = "0".charCodeAt(0), s = 0; s <= 9; ++s) h[o++] = s;
      for (o = "a".charCodeAt(0), s = 10; s < 36; ++s) h[o++] = s;
      for (o = "A".charCodeAt(0), s = 10; s < 36; ++s) h[o++] = s;
      function u(t) {
        return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
      }
      function a(t, e) {
        var r = h[t.charCodeAt(e)];
        return null == r ? -1 : r;
      }
      function f(t) {
        var e = i();
        return e.fromInt(t), e;
      }
      function c(t) {
        var e,
          r = 1;
        return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
      }
      function p(t) {
        this.m = t;
      }
      function l(t) {
        this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
      }
      function d(t, e) {
        return t & e;
      }
      function m(t, e) {
        return t | e;
      }
      function v(t, e) {
        return t ^ e;
      }
      function y(t, e) {
        return t & ~e;
      }
      function g(t) {
        if (0 == t) return -1;
        var e = 0;
        return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
      }
      function w(t) {
        for (var e = 0; 0 != t;) t &= t - 1, ++e;
        return e;
      }
      function T() {}
      function b(t) {
        return t;
      }
      function _(t) {
        this.r2 = i(), this.q3 = i(), r.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
      }
      p.prototype.convert = function (t) {
        return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
      }, p.prototype.revert = function (t) {
        return t;
      }, p.prototype.reduce = function (t) {
        t.divRemTo(this.m, null, t);
      }, p.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, p.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      }, l.prototype.convert = function (t) {
        var e = i();
        return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(r.ZERO) > 0 && this.m.subTo(e, e), e;
      }, l.prototype.revert = function (t) {
        var e = i();
        return t.copyTo(e), this.reduce(e), e;
      }, l.prototype.reduce = function (t) {
        for (; t.t <= this.mt2;) t[t.t++] = 0;
        for (var e = 0; e < this.m.t; ++e) {
          var r = 32767 & t[e],
            i = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
          for (t[r = e + this.m.t] += this.m.am(0, i, t, e, 0, this.m.t); t[r] >= t.DV;) t[r] -= t.DV, t[++r]++;
        }
        t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
      }, l.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, l.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      }, r.prototype.copyTo = function (t) {
        for (var e = this.t - 1; e >= 0; --e) t[e] = this[e];
        t.t = this.t, t.s = this.s;
      }, r.prototype.fromInt = function (t) {
        this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
      }, r.prototype.fromString = function (t, e) {
        var i;
        if (16 == e) i = 4;else if (8 == e) i = 3;else if (256 == e) i = 8;else if (2 == e) i = 1;else if (32 == e) i = 5;else {
          if (4 != e) return void this.fromRadix(t, e);
          i = 2;
        }
        this.t = 0, this.s = 0;
        for (var n = t.length, o = !1, s = 0; --n >= 0;) {
          var h = 8 == i ? 255 & t[n] : a(t, n);
          h < 0 ? "-" == t.charAt(n) && (o = !0) : (o = !1, 0 == s ? this[this.t++] = h : s + i > this.DB ? (this[this.t - 1] |= (h & (1 << this.DB - s) - 1) << s, this[this.t++] = h >> this.DB - s) : this[this.t - 1] |= h << s, (s += i) >= this.DB && (s -= this.DB));
        }
        8 == i && 0 != (128 & t[0]) && (this.s = -1, s > 0 && (this[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), o && r.ZERO.subTo(this, this);
      }, r.prototype.clamp = function () {
        for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;) --this.t;
      }, r.prototype.dlShiftTo = function (t, e) {
        var r;
        for (r = this.t - 1; r >= 0; --r) e[r + t] = this[r];
        for (r = t - 1; r >= 0; --r) e[r] = 0;
        e.t = this.t + t, e.s = this.s;
      }, r.prototype.drShiftTo = function (t, e) {
        for (var r = t; r < this.t; ++r) e[r - t] = this[r];
        e.t = Math.max(this.t - t, 0), e.s = this.s;
      }, r.prototype.lShiftTo = function (t, e) {
        var r,
          i = t % this.DB,
          n = this.DB - i,
          o = (1 << n) - 1,
          s = Math.floor(t / this.DB),
          h = this.s << i & this.DM;
        for (r = this.t - 1; r >= 0; --r) e[r + s + 1] = this[r] >> n | h, h = (this[r] & o) << i;
        for (r = s - 1; r >= 0; --r) e[r] = 0;
        e[s] = h, e.t = this.t + s + 1, e.s = this.s, e.clamp();
      }, r.prototype.rShiftTo = function (t, e) {
        e.s = this.s;
        var r = Math.floor(t / this.DB);
        if (r >= this.t) e.t = 0;else {
          var i = t % this.DB,
            n = this.DB - i,
            o = (1 << i) - 1;
          e[0] = this[r] >> i;
          for (var s = r + 1; s < this.t; ++s) e[s - r - 1] |= (this[s] & o) << n, e[s - r] = this[s] >> i;
          i > 0 && (e[this.t - r - 1] |= (this.s & o) << n), e.t = this.t - r, e.clamp();
        }
      }, r.prototype.subTo = function (t, e) {
        for (var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;) i += this[r] - t[r], e[r++] = i & this.DM, i >>= this.DB;
        if (t.t < this.t) {
          for (i -= t.s; r < this.t;) i += this[r], e[r++] = i & this.DM, i >>= this.DB;
          i += this.s;
        } else {
          for (i += this.s; r < t.t;) i -= t[r], e[r++] = i & this.DM, i >>= this.DB;
          i -= t.s;
        }
        e.s = i < 0 ? -1 : 0, i < -1 ? e[r++] = this.DV + i : i > 0 && (e[r++] = i), e.t = r, e.clamp();
      }, r.prototype.multiplyTo = function (t, e) {
        var i = this.abs(),
          n = t.abs(),
          o = i.t;
        for (e.t = o + n.t; --o >= 0;) e[o] = 0;
        for (o = 0; o < n.t; ++o) e[o + i.t] = i.am(0, n[o], e, o, 0, i.t);
        e.s = 0, e.clamp(), this.s != t.s && r.ZERO.subTo(e, e);
      }, r.prototype.squareTo = function (t) {
        for (var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;) t[r] = 0;
        for (r = 0; r < e.t - 1; ++r) {
          var i = e.am(r, e[r], t, 2 * r, 0, 1);
          (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, i, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
        }
        t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
      }, r.prototype.divRemTo = function (t, e, n) {
        var o = t.abs();
        if (!(o.t <= 0)) {
          var s = this.abs();
          if (s.t < o.t) return null != e && e.fromInt(0), void (null != n && this.copyTo(n));
          null == n && (n = i());
          var h = i(),
            u = this.s,
            a = t.s,
            f = this.DB - c(o[o.t - 1]);
          f > 0 ? (o.lShiftTo(f, h), s.lShiftTo(f, n)) : (o.copyTo(h), s.copyTo(n));
          var p = h.t,
            l = h[p - 1];
          if (0 != l) {
            var d = l * (1 << this.F1) + (p > 1 ? h[p - 2] >> this.F2 : 0),
              m = this.FV / d,
              v = (1 << this.F1) / d,
              y = 1 << this.F2,
              g = n.t,
              w = g - p,
              T = null == e ? i() : e;
            for (h.dlShiftTo(w, T), n.compareTo(T) >= 0 && (n[n.t++] = 1, n.subTo(T, n)), r.ONE.dlShiftTo(p, T), T.subTo(h, h); h.t < p;) h[h.t++] = 0;
            for (; --w >= 0;) {
              var b = n[--g] == l ? this.DM : Math.floor(n[g] * m + (n[g - 1] + y) * v);
              if ((n[g] += h.am(0, b, n, w, 0, p)) < b) for (h.dlShiftTo(w, T), n.subTo(T, n); n[g] < --b;) n.subTo(T, n);
            }
            null != e && (n.drShiftTo(p, e), u != a && r.ZERO.subTo(e, e)), n.t = p, n.clamp(), f > 0 && n.rShiftTo(f, n), u < 0 && r.ZERO.subTo(n, n);
          }
        }
      }, r.prototype.invDigit = function () {
        if (this.t < 1) return 0;
        var t = this[0];
        if (0 == (1 & t)) return 0;
        var e = 3 & t;
        return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
      }, r.prototype.isEven = function () {
        return 0 == (this.t > 0 ? 1 & this[0] : this.s);
      }, r.prototype.exp = function (t, e) {
        if (t > 4294967295 || t < 1) return r.ONE;
        var n = i(),
          o = i(),
          s = e.convert(this),
          h = c(t) - 1;
        for (s.copyTo(n); --h >= 0;) if (e.sqrTo(n, o), (t & 1 << h) > 0) e.mulTo(o, s, n);else {
          var u = n;
          n = o, o = u;
        }
        return e.revert(n);
      }, r.prototype.toString = function (t) {
        if (this.s < 0) return "-" + this.negate().toString(t);
        var e;
        if (16 == t) e = 4;else if (8 == t) e = 3;else if (2 == t) e = 1;else if (32 == t) e = 5;else {
          if (4 != t) return this.toRadix(t);
          e = 2;
        }
        var r,
          i = (1 << e) - 1,
          n = !1,
          o = "",
          s = this.t,
          h = this.DB - s * this.DB % e;
        if (s-- > 0) for (h < this.DB && (r = this[s] >> h) > 0 && (n = !0, o = u(r)); s >= 0;) h < e ? (r = (this[s] & (1 << h) - 1) << e - h, r |= this[--s] >> (h += this.DB - e)) : (r = this[s] >> (h -= e) & i, h <= 0 && (h += this.DB, --s)), r > 0 && (n = !0), n && (o += u(r));
        return n ? o : "0";
      }, r.prototype.negate = function () {
        var t = i();
        return r.ZERO.subTo(this, t), t;
      }, r.prototype.abs = function () {
        return this.s < 0 ? this.negate() : this;
      }, r.prototype.compareTo = function (t) {
        var e = this.s - t.s;
        if (0 != e) return e;
        var r = this.t;
        if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;
        for (; --r >= 0;) if (0 != (e = this[r] - t[r])) return e;
        return 0;
      }, r.prototype.bitLength = function () {
        return this.t <= 0 ? 0 : this.DB * (this.t - 1) + c(this[this.t - 1] ^ this.s & this.DM);
      }, r.prototype.mod = function (t) {
        var e = i();
        return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(r.ZERO) > 0 && t.subTo(e, e), e;
      }, r.prototype.modPowInt = function (t, e) {
        var r;
        return r = t < 256 || e.isEven() ? new p(e) : new l(e), this.exp(t, r);
      }, r.ZERO = f(0), r.ONE = f(1), T.prototype.convert = b, T.prototype.revert = b, T.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r);
      }, T.prototype.sqrTo = function (t, e) {
        t.squareTo(e);
      }, _.prototype.convert = function (t) {
        if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
        if (t.compareTo(this.m) < 0) return t;
        var e = i();
        return t.copyTo(e), this.reduce(e), e;
      }, _.prototype.revert = function (t) {
        return t;
      }, _.prototype.reduce = function (t) {
        for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) t.dAddOffset(1, this.m.t + 1);
        for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) t.subTo(this.m, t);
      }, _.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, _.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      };
      var S,
        A,
        D,
        B = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
        x = (1 << 26) / B[B.length - 1];
      function E() {
        var t;
        t = new Date().getTime(), A[D++] ^= 255 & t, A[D++] ^= t >> 8 & 255, A[D++] ^= t >> 16 & 255, A[D++] ^= t >> 24 & 255, D >= j && (D -= j);
      }
      if (r.prototype.chunkSize = function (t) {
        return Math.floor(Math.LN2 * this.DB / Math.log(t));
      }, r.prototype.toRadix = function (t) {
        if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
        var e = this.chunkSize(t),
          r = Math.pow(t, e),
          n = f(r),
          o = i(),
          s = i(),
          h = "";
        for (this.divRemTo(n, o, s); o.signum() > 0;) h = (r + s.intValue()).toString(t).substr(1) + h, o.divRemTo(n, o, s);
        return s.intValue().toString(t) + h;
      }, r.prototype.fromRadix = function (t, e) {
        this.fromInt(0), null == e && (e = 10);
        for (var i = this.chunkSize(e), n = Math.pow(e, i), o = !1, s = 0, h = 0, u = 0; u < t.length; ++u) {
          var f = a(t, u);
          f < 0 ? "-" == t.charAt(u) && 0 == this.signum() && (o = !0) : (h = e * h + f, ++s >= i && (this.dMultiply(n), this.dAddOffset(h, 0), s = 0, h = 0));
        }
        s > 0 && (this.dMultiply(Math.pow(e, s)), this.dAddOffset(h, 0)), o && r.ZERO.subTo(this, this);
      }, r.prototype.fromNumber = function (t, e, i) {
        if ("number" == typeof e) {
          if (t < 2) this.fromInt(1);else for (this.fromNumber(t, i), this.testBit(t - 1) || this.bitwiseTo(r.ONE.shiftLeft(t - 1), m, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);) this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(r.ONE.shiftLeft(t - 1), this);
        } else {
          var n = new Array(),
            o = 7 & t;
          n.length = 1 + (t >> 3), e.nextBytes(n), o > 0 ? n[0] &= (1 << o) - 1 : n[0] = 0, this.fromString(n, 256);
        }
      }, r.prototype.bitwiseTo = function (t, e, r) {
        var i,
          n,
          o = Math.min(t.t, this.t);
        for (i = 0; i < o; ++i) r[i] = e(this[i], t[i]);
        if (t.t < this.t) {
          for (n = t.s & this.DM, i = o; i < this.t; ++i) r[i] = e(this[i], n);
          r.t = this.t;
        } else {
          for (n = this.s & this.DM, i = o; i < t.t; ++i) r[i] = e(n, t[i]);
          r.t = t.t;
        }
        r.s = e(this.s, t.s), r.clamp();
      }, r.prototype.changeBit = function (t, e) {
        var i = r.ONE.shiftLeft(t);
        return this.bitwiseTo(i, e, i), i;
      }, r.prototype.addTo = function (t, e) {
        for (var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;) i += this[r] + t[r], e[r++] = i & this.DM, i >>= this.DB;
        if (t.t < this.t) {
          for (i += t.s; r < this.t;) i += this[r], e[r++] = i & this.DM, i >>= this.DB;
          i += this.s;
        } else {
          for (i += this.s; r < t.t;) i += t[r], e[r++] = i & this.DM, i >>= this.DB;
          i += t.s;
        }
        e.s = i < 0 ? -1 : 0, i > 0 ? e[r++] = i : i < -1 && (e[r++] = this.DV + i), e.t = r, e.clamp();
      }, r.prototype.dMultiply = function (t) {
        this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
      }, r.prototype.dAddOffset = function (t, e) {
        if (0 != t) {
          for (; this.t <= e;) this[this.t++] = 0;
          for (this[e] += t; this[e] >= this.DV;) this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
        }
      }, r.prototype.multiplyLowerTo = function (t, e, r) {
        var i,
          n = Math.min(this.t + t.t, e);
        for (r.s = 0, r.t = n; n > 0;) r[--n] = 0;
        for (i = r.t - this.t; n < i; ++n) r[n + this.t] = this.am(0, t[n], r, n, 0, this.t);
        for (i = Math.min(t.t, e); n < i; ++n) this.am(0, t[n], r, n, 0, e - n);
        r.clamp();
      }, r.prototype.multiplyUpperTo = function (t, e, r) {
        --e;
        var i = r.t = this.t + t.t - e;
        for (r.s = 0; --i >= 0;) r[i] = 0;
        for (i = Math.max(e - this.t, 0); i < t.t; ++i) r[this.t + i - e] = this.am(e - i, t[i], r, 0, 0, this.t + i - e);
        r.clamp(), r.drShiftTo(1, r);
      }, r.prototype.modInt = function (t) {
        if (t <= 0) return 0;
        var e = this.DV % t,
          r = this.s < 0 ? t - 1 : 0;
        if (this.t > 0) if (0 == e) r = this[0] % t;else for (var i = this.t - 1; i >= 0; --i) r = (e * r + this[i]) % t;
        return r;
      }, r.prototype.millerRabin = function (t) {
        var e = this.subtract(r.ONE),
          n = e.getLowestSetBit();
        if (n <= 0) return !1;
        var o = e.shiftRight(n);
        (t = t + 1 >> 1) > B.length && (t = B.length);
        for (var s = i(), h = 0; h < t; ++h) {
          s.fromInt(B[Math.floor(Math.random() * B.length)]);
          var u = s.modPow(o, this);
          if (0 != u.compareTo(r.ONE) && 0 != u.compareTo(e)) {
            for (var a = 1; a++ < n && 0 != u.compareTo(e);) if (0 == (u = u.modPowInt(2, this)).compareTo(r.ONE)) return !1;
            if (0 != u.compareTo(e)) return !1;
          }
        }
        return !0;
      }, r.prototype.clone = function () {
        var t = i();
        return this.copyTo(t), t;
      }, r.prototype.intValue = function () {
        if (this.s < 0) {
          if (1 == this.t) return this[0] - this.DV;
          if (0 == this.t) return -1;
        } else {
          if (1 == this.t) return this[0];
          if (0 == this.t) return 0;
        }
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
      }, r.prototype.byteValue = function () {
        return 0 == this.t ? this.s : this[0] << 24 >> 24;
      }, r.prototype.shortValue = function () {
        return 0 == this.t ? this.s : this[0] << 16 >> 16;
      }, r.prototype.signum = function () {
        return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
      }, r.prototype.toByteArray = function () {
        var t = this.t,
          e = new Array();
        e[0] = this.s;
        var r,
          i = this.DB - t * this.DB % 8,
          n = 0;
        if (t-- > 0) for (i < this.DB && (r = this[t] >> i) != (this.s & this.DM) >> i && (e[n++] = r | this.s << this.DB - i); t >= 0;) i < 8 ? (r = (this[t] & (1 << i) - 1) << 8 - i, r |= this[--t] >> (i += this.DB - 8)) : (r = this[t] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == n && (128 & this.s) != (128 & r) && ++n, (n > 0 || r != this.s) && (e[n++] = r);
        return e;
      }, r.prototype.equals = function (t) {
        return 0 == this.compareTo(t);
      }, r.prototype.min = function (t) {
        return this.compareTo(t) < 0 ? this : t;
      }, r.prototype.max = function (t) {
        return this.compareTo(t) > 0 ? this : t;
      }, r.prototype.and = function (t) {
        var e = i();
        return this.bitwiseTo(t, d, e), e;
      }, r.prototype.or = function (t) {
        var e = i();
        return this.bitwiseTo(t, m, e), e;
      }, r.prototype.xor = function (t) {
        var e = i();
        return this.bitwiseTo(t, v, e), e;
      }, r.prototype.andNot = function (t) {
        var e = i();
        return this.bitwiseTo(t, y, e), e;
      }, r.prototype.not = function () {
        for (var t = i(), e = 0; e < this.t; ++e) t[e] = this.DM & ~this[e];
        return t.t = this.t, t.s = ~this.s, t;
      }, r.prototype.shiftLeft = function (t) {
        var e = i();
        return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
      }, r.prototype.shiftRight = function (t) {
        var e = i();
        return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
      }, r.prototype.getLowestSetBit = function () {
        for (var t = 0; t < this.t; ++t) if (0 != this[t]) return t * this.DB + g(this[t]);
        return this.s < 0 ? this.t * this.DB : -1;
      }, r.prototype.bitCount = function () {
        for (var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r) t += w(this[r] ^ e);
        return t;
      }, r.prototype.testBit = function (t) {
        var e = Math.floor(t / this.DB);
        return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
      }, r.prototype.setBit = function (t) {
        return this.changeBit(t, m);
      }, r.prototype.clearBit = function (t) {
        return this.changeBit(t, y);
      }, r.prototype.flipBit = function (t) {
        return this.changeBit(t, v);
      }, r.prototype.add = function (t) {
        var e = i();
        return this.addTo(t, e), e;
      }, r.prototype.subtract = function (t) {
        var e = i();
        return this.subTo(t, e), e;
      }, r.prototype.multiply = function (t) {
        var e = i();
        return this.multiplyTo(t, e), e;
      }, r.prototype.divide = function (t) {
        var e = i();
        return this.divRemTo(t, e, null), e;
      }, r.prototype.remainder = function (t) {
        var e = i();
        return this.divRemTo(t, null, e), e;
      }, r.prototype.divideAndRemainder = function (t) {
        var e = i(),
          r = i();
        return this.divRemTo(t, e, r), new Array(e, r);
      }, r.prototype.modPow = function (t, e) {
        var r,
          n,
          o = t.bitLength(),
          s = f(1);
        if (o <= 0) return s;
        r = o < 18 ? 1 : o < 48 ? 3 : o < 144 ? 4 : o < 768 ? 5 : 6, n = o < 8 ? new p(e) : e.isEven() ? new _(e) : new l(e);
        var h = new Array(),
          u = 3,
          a = r - 1,
          d = (1 << r) - 1;
        if (h[1] = n.convert(this), r > 1) {
          var m = i();
          for (n.sqrTo(h[1], m); u <= d;) h[u] = i(), n.mulTo(m, h[u - 2], h[u]), u += 2;
        }
        var v,
          y,
          g = t.t - 1,
          w = !0,
          T = i();
        for (o = c(t[g]) - 1; g >= 0;) {
          for (o >= a ? v = t[g] >> o - a & d : (v = (t[g] & (1 << o + 1) - 1) << a - o, g > 0 && (v |= t[g - 1] >> this.DB + o - a)), u = r; 0 == (1 & v);) v >>= 1, --u;
          if ((o -= u) < 0 && (o += this.DB, --g), w) h[v].copyTo(s), w = !1;else {
            for (; u > 1;) n.sqrTo(s, T), n.sqrTo(T, s), u -= 2;
            u > 0 ? n.sqrTo(s, T) : (y = s, s = T, T = y), n.mulTo(T, h[v], s);
          }
          for (; g >= 0 && 0 == (t[g] & 1 << o);) n.sqrTo(s, T), y = s, s = T, T = y, --o < 0 && (o = this.DB - 1, --g);
        }
        return n.revert(s);
      }, r.prototype.modInverse = function (t) {
        var e = t.isEven();
        if (this.isEven() && e || 0 == t.signum()) return r.ZERO;
        for (var i = t.clone(), n = this.clone(), o = f(1), s = f(0), h = f(0), u = f(1); 0 != i.signum();) {
          for (; i.isEven();) i.rShiftTo(1, i), e ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(t, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(t, s), s.rShiftTo(1, s);
          for (; n.isEven();) n.rShiftTo(1, n), e ? (h.isEven() && u.isEven() || (h.addTo(this, h), u.subTo(t, u)), h.rShiftTo(1, h)) : u.isEven() || u.subTo(t, u), u.rShiftTo(1, u);
          i.compareTo(n) >= 0 ? (i.subTo(n, i), e && o.subTo(h, o), s.subTo(u, s)) : (n.subTo(i, n), e && h.subTo(o, h), u.subTo(s, u));
        }
        return 0 != n.compareTo(r.ONE) ? r.ZERO : u.compareTo(t) >= 0 ? u.subtract(t) : u.signum() < 0 ? (u.addTo(t, u), u.signum() < 0 ? u.add(t) : u) : u;
      }, r.prototype.pow = function (t) {
        return this.exp(t, new T());
      }, r.prototype.gcd = function (t) {
        var e = this.s < 0 ? this.negate() : this.clone(),
          r = t.s < 0 ? t.negate() : t.clone();
        if (e.compareTo(r) < 0) {
          var i = e;
          e = r, r = i;
        }
        var n = e.getLowestSetBit(),
          o = r.getLowestSetBit();
        if (o < 0) return e;
        for (n < o && (o = n), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;) (n = e.getLowestSetBit()) > 0 && e.rShiftTo(n, e), (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
        return o > 0 && r.lShiftTo(o, r), r;
      }, r.prototype.isProbablePrime = function (t) {
        var e,
          r = this.abs();
        if (1 == r.t && r[0] <= B[B.length - 1]) {
          for (e = 0; e < B.length; ++e) if (r[0] == B[e]) return !0;
          return !1;
        }
        if (r.isEven()) return !1;
        for (e = 1; e < B.length;) {
          for (var i = B[e], n = e + 1; n < B.length && i < x;) i *= B[n++];
          for (i = r.modInt(i); e < n;) if (i % B[e++] == 0) return !1;
        }
        return r.millerRabin(t);
      }, r.prototype.square = function () {
        var t = i();
        return this.squareTo(t), t;
      }, r.prototype.Barrett = _, null == A) {
        var k;
        if (A = new Array(), D = 0, "undefined" != typeof window && window.crypto) if (window.crypto.getRandomValues) {
          var I = new Uint8Array(32);
          for (window.crypto.getRandomValues(I), k = 0; k < 32; ++k) A[D++] = I[k];
        } else if ("Netscape" == navigator.appName && navigator.appVersion < "5") {
          var M = window.crypto.random(32);
          for (k = 0; k < M.length; ++k) A[D++] = 255 & M.charCodeAt(k);
        }
        for (; D < j;) k = Math.floor(65536 * Math.random()), A[D++] = k >>> 8, A[D++] = 255 & k;
        D = 0, E();
      }
      function C() {
        if (null == S) {
          for (E(), (S = new O()).init(A), D = 0; D < A.length; ++D) A[D] = 0;
          D = 0;
        }
        return S.next();
      }
      function R() {}
      function O() {
        this.i = 0, this.j = 0, this.S = new Array();
      }
      R.prototype.nextBytes = function (t) {
        var e;
        for (e = 0; e < t.length; ++e) t[e] = C();
      }, O.prototype.init = function (t) {
        var e, r, i;
        for (e = 0; e < 256; ++e) this.S[e] = e;
        for (r = 0, e = 0; e < 256; ++e) i = this.S[e], this.S[e] = this.S[r = r + this.S[e] + t[e % t.length] & 255], this.S[r] = i;
        this.i = 0, this.j = 0;
      }, O.prototype.next = function () {
        var t;
        return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255];
      };
      var j = 256;
      e.exports = {
        default: r,
        BigInteger: r,
        SecureRandom: R
      };
    }).call(t);
  }),
  a = {
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    ripemd160: "3021300906052b2403020105000414"
  },
  f = {
    sha256: o
  };
function c(t, e) {
  if (this.n = null, this.e = 0, !(null != t && null != e && t.length > 0 && e.length > 0)) throw new Error("Invalid key data");
  this.n = new u.BigInteger(t, 16), this.e = parseInt(e, 16);
}
c.prototype.verify = function (t, e) {
  e = e.replace(/[^0-9a-f]|[\s\n]]/gi, "");
  var r = new u.BigInteger(e, 16);
  if (r.bitLength() > this.n.bitLength()) throw new Error("Signature does not match with the key modulus.");
  var i = function (t) {
    for (var e in a) {
      var r = a[e],
        i = r.length;
      if (t.substring(0, i) === r) return {
        alg: e,
        hash: t.substring(i)
      };
    }
    return [];
  }(r.modPowInt(this.e, this.n).toString(16).replace(/^1f+00/, ""));
  if (0 === i.length) return !1;
  if (!f.hasOwnProperty(i.alg)) throw new Error("Hashing algorithm is not supported.");
  var n = f[i.alg](t).toString();
  return i.hash === n;
};
for (var p = [], l = [], d = "undefined" != typeof Uint8Array ? Uint8Array : Array, m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", v = 0; v < 64; ++v) p[v] = m[v], l[m.charCodeAt(v)] = v;
l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
var y = function (t) {
  var e,
    r,
    i = function (t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }(t),
    n = i[0],
    o = i[1],
    s = new d(function (t, e, r) {
      return 3 * (e + r) / 4 - r;
    }(0, n, o)),
    h = 0,
    u = o > 0 ? n - 4 : n;
  for (r = 0; r < u; r += 4) e = l[t.charCodeAt(r)] << 18 | l[t.charCodeAt(r + 1)] << 12 | l[t.charCodeAt(r + 2)] << 6 | l[t.charCodeAt(r + 3)], s[h++] = e >> 16 & 255, s[h++] = e >> 8 & 255, s[h++] = 255 & e;
  return 2 === o && (e = l[t.charCodeAt(r)] << 2 | l[t.charCodeAt(r + 1)] >> 4, s[h++] = 255 & e), 1 === o && (e = l[t.charCodeAt(r)] << 10 | l[t.charCodeAt(r + 1)] << 4 | l[t.charCodeAt(r + 2)] >> 2, s[h++] = e >> 8 & 255, s[h++] = 255 & e), s;
};
function g(t) {
  var e = t.length % 4;
  return 0 === e ? t : t + new Array(4 - e + 1).join("=");
}
function w(t) {
  return t = g(t).replace(/\-/g, "+").replace(/_/g, "/"), decodeURIComponent(function (t) {
    for (var e = "", r = 0; r < t.length; r++) e += String.fromCharCode(t[r]);
    return e;
  }(y(t)).split("").map(function (t) {
    return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
}
function T(t) {
  return function (t) {
    for (var e = "", r = 0; r < t.length; r++) {
      var i = t[r].toString(16);
      e += 2 === i.length ? i : "0" + i;
    }
    return e;
  }(y(g(t)));
}
var b = e(function (e) {
  var r, i;
  r = t, i = function () {
    return function () {
      return function (t) {
        var e = [];
        if (0 === t.length) return "";
        if ("string" != typeof t[0]) throw new TypeError("Url must be a string. Received " + t[0]);
        if (t[0].match(/^[^/:]+:\/*$/) && t.length > 1) {
          var r = t.shift();
          t[0] = r + t[0];
        }
        t[0] = t[0].match(/^file:\/\/\//) ? t[0].replace(/^([^/:]+):\/*/, "$1:///") : t[0].replace(/^([^/:]+):\/*/, "$1://");
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          if ("string" != typeof n) throw new TypeError("Url must be a string. Received " + n);
          "" !== n && (i > 0 && (n = n.replace(/^[\/]+/, "")), n = n.replace(/[\/]+$/, i < t.length - 1 ? "" : "/"), e.push(n));
        }
        var o = e.join("/"),
          s = (o = o.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
        return s.shift() + (s.length > 0 ? "?" : "") + s.join("&");
      }("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
    };
  }, e.exports ? e.exports = i() : r.urljoin = i();
});
function _(t, e) {
  return e = e || {}, new Promise(function (r, i) {
    var n = new XMLHttpRequest(),
      o = [],
      s = [],
      h = {},
      u = function () {
        return {
          ok: 2 == (n.status / 100 | 0),
          statusText: n.statusText,
          status: n.status,
          url: n.responseURL,
          text: function () {
            return Promise.resolve(n.responseText);
          },
          json: function () {
            return Promise.resolve(n.responseText).then(JSON.parse);
          },
          blob: function () {
            return Promise.resolve(new Blob([n.response]));
          },
          clone: u,
          headers: {
            keys: function () {
              return o;
            },
            entries: function () {
              return s;
            },
            get: function (t) {
              return h[t.toLowerCase()];
            },
            has: function (t) {
              return t.toLowerCase() in h;
            }
          }
        };
      };
    for (var a in n.open(e.method || "get", t, !0), n.onload = function () {
      n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (t, e, r) {
        o.push(e = e.toLowerCase()), s.push([e, r]), h[e] = h[e] ? h[e] + "," + r : r;
      }), r(u());
    }, n.onerror = i, n.withCredentials = "include" == e.credentials, e.headers) n.setRequestHeader(a, e.headers[a]);
    n.send(e.body || null);
  });
}
function S(t) {
  if (t.ok) return t.json();
  var e = new Error(t.statusText);
  return e.response = t, Promise.reject(e);
}
function A(t) {
  this.name = "ConfigurationError", this.message = t || "";
}
function D(t) {
  this.name = "TokenValidationError", this.message = t || "";
}
A.prototype = Error.prototype, D.prototype = Error.prototype;
var B = function () {
  function t() {}
  var e = t.prototype;
  return e.get = function () {
    return null;
  }, e.has = function () {
    return null;
  }, e.set = function () {
    return null;
  }, t;
}();
r.polyfill();
var x = "RS256",
  E = function (t) {
    return "number" == typeof t;
  },
  k = function () {
    return new Date();
  };
function I(t) {
  var e = t || {};
  if (this.jwksCache = e.jwksCache || new B(), this.expectedAlg = e.expectedAlg || "RS256", this.issuer = e.issuer, this.audience = e.audience, this.leeway = 0 === e.leeway ? 0 : e.leeway || 60, this.jwksURI = e.jwksURI, this.maxAge = e.maxAge, this.__clock = "function" == typeof e.__clock ? e.__clock : k, this.leeway < 0 || this.leeway > 300) throw new A("The leeway should be positive and lower than five minutes.");
  if (x !== this.expectedAlg) throw new A('Signature algorithm of "' + this.expectedAlg + '" is not supported. Expected the ID token to be signed with "' + x + '".');
}
function PluginHandler(webAuth, plugins) {
  this.plugins = plugins;
  for (var a = 0; a < this.plugins.length; a++) {
    if (this.plugins[a].version !== version.raw) {
      var pluginName = "";
      throw this.plugins[a].constructor && this.plugins[a].constructor.name && (pluginName = this.plugins[a].constructor.name), new Error("Plugin " + pluginName + " version (" + this.plugins[a].version + ") is not compatible with the SDK version (" + version.raw + ")");
    }
    this.plugins[a].setWebAuth(webAuth);
  }
}
I.prototype.verify = function (t, e, r) {
  if (!r && e && "function" == typeof e && (r = e, e = void 0), !t) return r(new D("ID token is required but missing"), null);
  var i = this.decode(t);
  if (i instanceof Error) return r(new D("ID token could not be decoded"), null);
  var n = i.encoded.header + "." + i.encoded.payload,
    o = T(i.encoded.signature),
    s = i.header.alg,
    h = i.header.kid,
    u = i.payload.aud,
    a = i.payload.sub,
    f = i.payload.iss,
    c = i.payload.exp,
    p = i.payload.nbf,
    l = i.payload.iat,
    d = i.payload.azp,
    m = i.payload.auth_time,
    v = i.payload.nonce,
    y = this.__clock(),
    g = this;
  if (g.expectedAlg !== s) return r(new D('Signature algorithm of "' + s + '" is not supported. Expected the ID token to be signed with "' + x + '".'), null);
  this.getRsaVerifier(f, h, function (t, s) {
    if (t) return r(t, null);
    if (!s.verify(n, o)) return r(new D("Invalid ID token signature."), null);
    if (!f || "string" != typeof f) return r(new D("Issuer (iss) claim must be a string present in the ID token"), null);
    if (g.issuer !== f) return r(new D('Issuer (iss) claim mismatch in the ID token, expected "' + g.issuer + '", found "' + f + '"'), null);
    if (!a || "string" != typeof a) return r(new D("Subject (sub) claim must be a string present in the ID token"), null);
    if (!u || "string" != typeof u && !Array.isArray(u)) return r(new D("Audience (aud) claim must be a string or array of strings present in the ID token"), null);
    if (Array.isArray(u) && !u.includes(g.audience)) return r(new D('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but was not one of "' + u.join(", ") + '"'), null);
    if ("string" == typeof u && g.audience !== u) return r(new D('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but found "' + u + '"'), null);
    if (e) {
      if (!v || "string" != typeof v) return r(new D("Nonce (nonce) claim must be a string present in the ID token"), null);
      if (v !== e) return r(new D('Nonce (nonce) claim value mismatch in the ID token; expected "' + e + '", found "' + v + '"'), null);
    }
    if (Array.isArray(u) && u.length > 1) {
      if (!d || "string" != typeof d) return r(new D("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values"), null);
      if (d !== g.audience) return r(new D('Authorized Party (azp) claim mismatch in the ID token; expected "' + g.audience + '", found "' + d + '"'), null);
    }
    if (!c || !E(c)) return r(new D("Expiration Time (exp) claim must be a number present in the ID token"), null);
    if (!l || !E(l)) return r(new D("Issued At (iat) claim must be a number present in the ID token"), null);
    var h = c + g.leeway,
      w = new Date(0);
    if (w.setUTCSeconds(h), y > w) return r(new D('Expiration Time (exp) claim error in the ID token; current time "' + y + '" is after expiration time "' + w + '"'), null);
    if (p && E(p)) {
      var T = p - g.leeway,
        b = new Date(0);
      if (b.setUTCSeconds(T), y < b) return r(new D('Not Before Time (nbf) claim error in the ID token; current time "' + y + '" is before the not before time "' + b + '"'), null);
    }
    if (g.maxAge) {
      if (!m || !E(m)) return r(new D("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified"), null);
      var _ = m + g.maxAge + g.leeway,
        S = new Date(0);
      if (S.setUTCSeconds(_), y > S) return r(new D('Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time "' + y + '" is after last auth time at "' + S + '"'), null);
    }
    return r(null, i.payload);
  });
}, I.prototype.getRsaVerifier = function (t, e, r) {
  var i = this,
    n = t + e;
  Promise.resolve(this.jwksCache.has(n)).then(function (r) {
    return r ? i.jwksCache.get(n) : (s = (o = {
      jwksURI: i.jwksURI,
      iss: t,
      kid: e
    }).jwksURI || b(o.iss, ".well-known", "jwks.json"), ("undefined" == fetch ? _ : fetch)(s).then(S).then(function (t) {
      var e,
        r,
        i,
        n = null;
      for (e = 0; e < t.keys.length && null === n; e++) (r = t.keys[e]).kid === o.kid && (n = r);
      if (!n) throw new Error('Could not find a public key for Key ID (kid) "' + o.kid + '"');
      return {
        modulus: T((i = n).n),
        exp: T(i.e)
      };
    }).catch(function (t) {
      throw t;
    }));
    var o, s;
  }).then(function (t) {
    if (!t || !t.modulus || !t.exp) throw new Error("Empty keyInfo in response");
    return Promise.resolve(i.jwksCache.set(n, t)).then(function () {
      r && r(null, new c(t.modulus, t.exp));
    });
  }).catch(function (t) {
    r && r(t);
  });
}, I.prototype.decode = function (t) {
  var e,
    r,
    i = t.split(".");
  if (3 !== i.length) return new D("Cannot decode a malformed JWT");
  try {
    e = JSON.parse(w(i[0])), r = JSON.parse(w(i[1]));
  } catch (t) {
    return new D("Token header or payload is not valid JSON");
  }
  return {
    header: e,
    payload: r,
    encoded: {
      header: i[0],
      payload: i[1],
      signature: i[2]
    }
  };
}, I.prototype.validateAccessToken = function (t, e, r, i) {
  if (this.expectedAlg !== e) return i(new D('Signature algorithm of "' + e + '" is not supported. Expected "' + this.expectedAlg + '"'));
  var n,
    u = o(t),
    a = h.stringify(u),
    f = a.substring(0, a.length / 2),
    c = h.parse(f),
    p = s.stringify(c);
  return i((n = {
    "+": "-",
    "/": "_",
    "=": ""
  }, p.replace(/[+/=]/g, function (t) {
    return n[t];
  }) !== r ? new D("Invalid access_token") : null));
}, PluginHandler.prototype.get = function (extensibilityPoint) {
  for (var a = 0; a < this.plugins.length; a++) if (this.plugins[a].supports(extensibilityPoint)) return this.plugins[a].init();
  return null;
};
var random = {
  randomString: function (length) {
    var bytes = new Uint8Array(length),
      result = [],
      charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~",
      cryptoObj = windowHelper.getWindow().crypto || windowHelper.getWindow().msCrypto;
    if (!cryptoObj) return null;
    for (var random = cryptoObj.getRandomValues(bytes), a = 0; a < random.length; a++) result.push(charset[random[a] % charset.length]);
    return result.join("");
  }
};
function TransactionManager(options) {
  var transaction = options.transaction || {};
  this.namespace = transaction.namespace || "com.auth0.auth.", this.keyLength = transaction.keyLength || 32, this.stateExpiration = options.stateExpiration ? options.stateExpiration / 60 / 24 : 1 / 48, this.storage = new Storage(options), this.options = options;
}
function IframeHandler(options) {
  if (this.url = options.url, this.callback = options.callback, this.timeout = options.timeout || 6e4, this.timeoutCallback = options.timeoutCallback || null, this.eventListenerType = options.eventListenerType || "message", this.iframe = null, this.timeoutHandle = null, this._destroyTimeout = null, this.transientMessageEventListener = null, this.proxyEventListener = null, this.eventValidator = options.eventValidator || {
    isValid: function () {
      return !0;
    }
  }, "function" != typeof this.callback) throw new Error("options.callback must be a function");
}
function WebMessageHandler(webAuth) {
  this.webAuth = webAuth, this.warn = new Warn(webAuth.baseOptions);
}
function CrossOriginAuthentication(webAuth, options) {
  this.webAuth = webAuth, this.baseOptions = options, this.request = new RequestBuilder(options), this.webMessageHandler = new WebMessageHandler(webAuth), this.storage = new Storage(options);
}
function createKey(origin, coId) {
  return ["co/verifier", encodeURIComponent(origin), encodeURIComponent(coId)].join("/");
}
function Redirect(auth0, options) {
  this.webAuth = auth0, this.baseOptions = options, this.crossOriginAuthentication = new CrossOriginAuthentication(auth0, this.baseOptions), this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}
TransactionManager.prototype.process = function (options) {
  if (!options.responseType) throw new Error("responseType is required");
  var lastUsedConnection = options.realm || options.connection,
    responseTypeIncludesIdToken = -1 !== options.responseType.indexOf("id_token"),
    transaction = this.generateTransaction(options.appState, options.state, options.nonce, lastUsedConnection, responseTypeIncludesIdToken, options.organization);
  return options.state || (options.state = transaction.state), responseTypeIncludesIdToken && !options.nonce && (options.nonce = transaction.nonce), options;
}, TransactionManager.prototype.generateTransaction = function (appState, state, nonce, lastUsedConnection, generateNonce, organization) {
  if (state = state || random.randomString(this.keyLength), nonce = nonce || (generateNonce ? random.randomString(this.keyLength) : null), !(windowHelper.getWindow().location.host === this.options.domain)) {
    var transactionPayload = {
      nonce: nonce,
      appState: appState,
      state: state,
      lastUsedConnection: lastUsedConnection
    };
    organization && (transactionPayload.organization = organization), this.storage.setItem(this.namespace + state, transactionPayload, {
      expires: this.stateExpiration
    });
  }
  return {
    state: state,
    nonce: nonce
  };
}, TransactionManager.prototype.getStoredTransaction = function (state) {
  var transactionData;
  return transactionData = this.storage.getItem(this.namespace + state), this.clearTransaction(state), transactionData;
}, TransactionManager.prototype.clearTransaction = function (state) {
  this.storage.removeItem(this.namespace + state);
}, IframeHandler.prototype.init = function () {
  var _this = this,
    _window = windowHelper.getWindow();
  switch (this.iframe = _window.document.createElement("iframe"), this.iframe.style.display = "none", this.proxyEventListener = function (e) {
    _this.eventListener(e);
  }, this.eventListenerType) {
    case "message":
      this.eventSourceObject = _window;
      break;
    case "load":
      this.eventSourceObject = this.iframe;
      break;
    default:
      throw new Error("Unsupported event listener type: " + this.eventListenerType);
  }
  this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, !1), _window.document.body.appendChild(this.iframe), this.iframe.src = this.url, this.timeoutHandle = setTimeout(function () {
    _this.timeoutHandler();
  }, this.timeout);
}, IframeHandler.prototype.eventListener = function (event) {
  var eventData = {
    event: event,
    sourceObject: this.eventSourceObject
  };
  this.eventValidator.isValid(eventData) && (this.destroy(), this.callback(eventData));
}, IframeHandler.prototype.timeoutHandler = function () {
  this.destroy(), this.timeoutCallback && this.timeoutCallback();
}, IframeHandler.prototype.destroy = function () {
  var _this = this;
  clearTimeout(this.timeoutHandle), this._destroyTimeout = setTimeout(function () {
    _this.eventSourceObject.removeEventListener(_this.eventListenerType, _this.proxyEventListener, !1), _this.iframe.parentNode && _this.iframe.parentNode.removeChild(_this.iframe);
  }, 0);
}, WebMessageHandler.prototype.run = function (options, cb) {
  var _this = this;
  options.responseMode = "web_message", options.prompt = "none";
  var currentOrigin = windowHelper.getOrigin(),
    redirectUriOrigin = objectHelper.getOriginFromUrl(options.redirectUri);
  if (redirectUriOrigin && currentOrigin !== redirectUriOrigin) return cb({
    error: "origin_mismatch",
    error_description: "The redirectUri's origin (" + redirectUriOrigin + ") should match the window's origin (" + currentOrigin + ")."
  });
  !function (authorizeUrl, options, _callback) {
    new IframeHandler({
      url: authorizeUrl,
      eventListenerType: "message",
      callback: function (eventData) {
        _callback(null, eventData);
      },
      timeout: options.timeout,
      eventValidator: {
        isValid: function (eventData) {
          return !(!eventData.event.data || "authorization_response" !== eventData.event.data.type || options.state !== eventData.event.data.response.state);
        }
      },
      timeoutCallback: function () {
        _callback({
          error: "timeout",
          error_description: "Timeout during executing web_message communication",
          state: options.state
        });
      }
    }).init();
  }(this.webAuth.client.buildAuthorizeUrl(options), options, function (err, eventData) {
    var error = err;
    if (!err && eventData.event.data.response.error && (error = eventData.event.data.response), !error) {
      var parsedHash = eventData.event.data.response;
      return _this.webAuth.validateAuthenticationResponse(options, parsedHash, cb);
    }
    return "consent_required" === error.error && "localhost" === windowHelper.getWindow().location.hostname && _this.warn.warning("Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"), _this.webAuth.transactionManager.clearTransaction(error.state), cb(objectHelper.pick(error, ["error", "error_description"]));
  });
}, CrossOriginAuthentication.prototype.login = function (options, cb) {
  var _this = this,
    url = urlJoin(this.baseOptions.rootUrl, "/co/authenticate");
  options.username = options.username || options.email, delete options.email;
  var authenticateBody = {
    client_id: options.clientID || this.baseOptions.clientID,
    username: options.username
  };
  options.password && (authenticateBody.password = options.password), options.otp && (authenticateBody.otp = options.otp);
  var realm = options.realm || this.baseOptions.realm;
  if (realm) {
    var credentialType = options.credentialType || this.baseOptions.credentialType || "http://auth0.com/oauth/grant-type/password-realm";
    authenticateBody.realm = realm, authenticateBody.credential_type = credentialType;
  } else authenticateBody.credential_type = "password";
  this.request.post(url).withCredentials().send(authenticateBody).end(function (err, data) {
    if (err) {
      var errorObject = err.response && err.response.body || {
        error: "request_error",
        error_description: JSON.stringify(err)
      };
      return wrapCallback(cb, {
        forceLegacyError: !0
      })(errorObject);
    }
    function doAuth() {
      var popupMode = !0 === options.popup;
      options = objectHelper.blacklist(options, ["password", "credentialType", "otp", "popup", "onRedirecting"]);
      var authorizeOptions = objectHelper.merge(options).with({
          loginTicket: data.body.login_ticket
        }),
        key = createKey(_this.baseOptions.rootUrl, data.body.co_id);
      _this.storage.setItem(key, data.body.co_verifier, {
        expires: 1 / 96
      }), popupMode ? _this.webMessageHandler.run(authorizeOptions, wrapCallback(cb, {
        forceLegacyError: !0
      })) : _this.webAuth.authorize(authorizeOptions);
    }
    "function" == typeof options.onRedirecting ? options.onRedirecting(doAuth) : doAuth();
  });
}, CrossOriginAuthentication.prototype.callback = function () {
  var targetOrigin = decodeURIComponent(function (name) {
      var parts = ("&" + windowHelper.getWindow().location.hash.substring(1)).split("&" + name + "=");
      if (2 === parts.length) return parts.pop().split("&").shift();
    }("origin")),
    theWindow = windowHelper.getWindow(),
    _this = this;
  theWindow.addEventListener("message", function (evt) {
    if ("co_verifier_request" === evt.data.type) {
      var key = createKey(evt.origin, evt.data.request.id),
        verifier = function (storage, key) {
          try {
            var verifier = storage.getItem(key);
            return storage.removeItem(key), verifier || "";
          } catch (e) {
            return "";
          }
        }(_this.storage, key);
      evt.source.postMessage({
        type: "co_verifier_response",
        response: {
          verifier: verifier
        }
      }, evt.origin);
    }
  }), theWindow.parent.postMessage({
    type: "ready"
  }, targetOrigin);
}, Redirect.prototype.loginWithCredentials = function (options, cb) {
  options.realm = options.realm || options.connection, delete options.connection, this.crossOriginAuthentication.login(options, cb);
}, Redirect.prototype.signupAndLogin = function (options, cb) {
  var _this = this;
  return this.webAuth.client.dbConnection.signup(options, function (err) {
    return err ? cb(err) : (options.realm = options.realm || options.connection, delete options.connection, _this.webAuth.login(options, cb));
  });
};
var winchan = createCommonjsModule(function (module) {
  var WinChan = function () {
    function addListener(w, event, cb) {
      w.attachEvent ? w.attachEvent("on" + event, cb) : w.addEventListener && w.addEventListener(event, cb, !1);
    }
    function removeListener(w, event, cb) {
      w.detachEvent ? w.detachEvent("on" + event, cb) : w.removeEventListener && w.removeEventListener(event, cb, !1);
    }
    function extractOrigin(url) {
      /^https?:\/\//.test(url) || (url = window.location.href);
      var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
      return m ? m[1] : url;
    }
    var isIE = function () {
      if ("undefined" == typeof navigator) return !1;
      var rv = -1,
        ua = navigator.userAgent;
      if ("Microsoft Internet Explorer" === navigator.appName) null != new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));else if (ua.indexOf("Trident") > -1) {
        null !== new RegExp("rv:([0-9]{2,2}[.0-9]{0,})").exec(ua) && (rv = parseFloat(RegExp.$1));
      }
      return rv >= 8;
    }();
    return "undefined" != typeof window && window.JSON && window.JSON.stringify && window.JSON.parse && window.postMessage ? {
      open: function (opts, cb) {
        if (!cb) throw "missing required callback argument";
        var err, iframe;
        opts.url || (err = "missing required 'url' parameter"), opts.relay_url || (err = "missing required 'relay_url' parameter"), err && setTimeout(function () {
          cb(err);
        }, 0), opts.window_name || (opts.window_name = null), opts.window_features && !function () {
          try {
            var userAgent = navigator.userAgent;
            return -1 != userAgent.indexOf("Fennec/") || -1 != userAgent.indexOf("Firefox/") && -1 != userAgent.indexOf("Android");
          } catch (e) {}
          return !1;
        }() || (opts.window_features = void 0);
        var messageTarget,
          origin = opts.origin || extractOrigin(opts.url);
        if (origin !== extractOrigin(opts.relay_url)) return setTimeout(function () {
          cb("invalid arguments: origin of url and relay_url must match");
        }, 0);
        isIE && ((iframe = document.createElement("iframe")).setAttribute("src", opts.relay_url), iframe.style.display = "none", iframe.setAttribute("name", "__winchan_relay_frame"), document.body.appendChild(iframe), messageTarget = iframe.contentWindow);
        var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
        opts.popup && (w.location.href = opts.url), messageTarget || (messageTarget = w);
        var closeInterval = setInterval(function () {
            w && w.closed && (cleanup(), cb && (cb("User closed the popup window"), cb = null));
          }, 500),
          req = JSON.stringify({
            a: "request",
            d: opts.params
          });
        function cleanup() {
          if (iframe && document.body.removeChild(iframe), iframe = void 0, closeInterval && (closeInterval = clearInterval(closeInterval)), removeListener(window, "message", onMessage), removeListener(window, "unload", cleanup), w) try {
            w.close();
          } catch (securityViolation) {
            messageTarget.postMessage("die", origin);
          }
          w = messageTarget = void 0;
        }
        function onMessage(e) {
          if (e.origin === origin) {
            try {
              var d = JSON.parse(e.data);
            } catch (err) {
              if (cb) return cb(err);
              throw err;
            }
            "ready" === d.a ? messageTarget.postMessage(req, origin) : "error" === d.a ? (cleanup(), cb && (cb(d.d), cb = null)) : "response" === d.a && (cleanup(), cb && (cb(null, d.d), cb = null));
          }
        }
        return addListener(window, "unload", cleanup), addListener(window, "message", onMessage), {
          originalPopup: w,
          close: cleanup,
          focus: function () {
            if (w) try {
              w.focus();
            } catch (e) {}
          }
        };
      },
      onOpen: function (cb) {
        var o = "*",
          msgTarget = isIE ? function () {
            for (var frames = window.opener.frames, i = frames.length - 1; i >= 0; i--) try {
              if (frames[i].location.protocol === window.location.protocol && frames[i].location.host === window.location.host && "__winchan_relay_frame" === frames[i].name) return frames[i];
            } catch (e) {}
          }() : window.opener;
        if (!msgTarget) throw "can't find relay frame";
        function doPost(msg) {
          msg = JSON.stringify(msg), isIE ? msgTarget.doPost(msg, o) : msgTarget.postMessage(msg, o);
        }
        function onDie(e) {
          if ("die" === e.data) try {
            window.close();
          } catch (o_O) {}
        }
        addListener(isIE ? msgTarget : window, "message", function onMessage(e) {
          var d;
          try {
            d = JSON.parse(e.data);
          } catch (err) {}
          d && "request" === d.a && (removeListener(window, "message", onMessage), o = e.origin, cb && setTimeout(function () {
            cb(o, d.d, function (r) {
              cb = void 0, doPost({
                a: "response",
                d: r
              });
            });
          }, 0));
        }), addListener(isIE ? msgTarget : window, "message", onDie);
        try {
          doPost({
            a: "ready"
          });
        } catch (e) {
          addListener(msgTarget, "load", function (e) {
            doPost({
              a: "ready"
            });
          });
        }
        var onUnload = function () {
          try {
            removeListener(isIE ? msgTarget : window, "message", onDie);
          } catch (ohWell) {}
          cb && doPost({
            a: "error",
            d: "client closed window"
          }), cb = void 0;
          try {
            window.close();
          } catch (e) {}
        };
        return addListener(window, "unload", onUnload), {
          detach: function () {
            removeListener(window, "unload", onUnload);
          }
        };
      }
    } : {
      open: function (url, winopts, arg, cb) {
        setTimeout(function () {
          cb("unsupported browser");
        }, 0);
      },
      onOpen: function (cb) {
        setTimeout(function () {
          cb("unsupported browser");
        }, 0);
      }
    };
  }();
  module.exports && (module.exports = WinChan);
});
var urlHelper = {
  extractOrigin: function (url) {
    /^https?:\/\//.test(url) || (url = window.location.href);
    var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
    return m ? m[1] : url;
  }
};
function PopupHandler() {
  this._current_popup = null;
}
function Popup(webAuth, options) {
  this.baseOptions = options, this.baseOptions.popupOrigin = options.popupOrigin, this.client = webAuth.client, this.webAuth = webAuth, this.transactionManager = new TransactionManager(this.baseOptions), this.crossOriginAuthentication = new CrossOriginAuthentication(webAuth, this.baseOptions), this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}
function SilentAuthenticationHandler(options) {
  this.authenticationUrl = options.authenticationUrl, this.timeout = options.timeout || 6e4, this.handler = null, this.postMessageDataType = options.postMessageDataType || !1, this.postMessageOrigin = options.postMessageOrigin || windowHelper.getWindow().location.origin || windowHelper.getWindow().location.protocol + "//" + windowHelper.getWindow().location.hostname + (windowHelper.getWindow().location.port ? ":" + windowHelper.getWindow().location.port : "");
}
function UsernamePassword(options) {
  this.baseOptions = options, this.request = new RequestBuilder(options), this.transactionManager = new TransactionManager(this.baseOptions);
}
function HostedPages(client, options) {
  this.baseOptions = options, this.client = client, this.baseOptions.universalLoginPage = !0, this.request = new RequestBuilder(this.baseOptions), this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}
PopupHandler.prototype.calculatePosition = function (options) {
  var width = options.width || 500,
    height = options.height || 600,
    _window = windowHelper.getWindow(),
    screenX = void 0 !== _window.screenX ? _window.screenX : _window.screenLeft,
    screenY = void 0 !== _window.screenY ? _window.screenY : _window.screenTop,
    outerWidth = void 0 !== _window.outerWidth ? _window.outerWidth : _window.document.body.clientWidth,
    outerHeight = void 0 !== _window.outerHeight ? _window.outerHeight : _window.document.body.clientHeight;
  return {
    width: width,
    height: height,
    left: options.left || screenX + (outerWidth - width) / 2,
    top: options.top || screenY + (outerHeight - height) / 2
  };
}, PopupHandler.prototype.preload = function (options) {
  var _this = this,
    _window = windowHelper.getWindow(),
    popupPosition = this.calculatePosition(options.popupOptions || {}),
    popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions),
    url = options.url || "about:blank",
    windowFeatures = lib_stringify(popupOptions, {
      encode: !1,
      delimiter: ","
    });
  return this._current_popup && !this._current_popup.closed || (this._current_popup = _window.open(url, "auth0_signup_popup", windowFeatures), this._current_popup.kill = function () {
    this.close(), _this._current_popup = null;
  }), this._current_popup;
}, PopupHandler.prototype.load = function (url, relayUrl, options, cb) {
  var _this = this,
    popupPosition = this.calculatePosition(options.popupOptions || {}),
    popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions),
    winchanOptions = objectHelper.merge({
      url: url,
      relay_url: relayUrl,
      window_features: lib_stringify(popupOptions, {
        delimiter: ",",
        encode: !1
      }),
      popup: this._current_popup
    }).with(options),
    popup = winchan.open(winchanOptions, function (err, data) {
      if (!err || "SyntaxError" !== err.name) return _this._current_popup = null, cb(err, data);
    });
  return popup.focus(), popup;
}, Popup.prototype.buildPopupHandler = function () {
  var pluginHandler = this.baseOptions.plugins.get("popup.getPopupHandler");
  return pluginHandler ? pluginHandler.getPopupHandler() : new PopupHandler();
}, Popup.prototype.preload = function (options) {
  options = options || {};
  var popup = this.buildPopupHandler();
  return popup.preload(options), popup;
}, Popup.prototype.getPopupHandler = function (options, preload) {
  return options.popupHandler ? options.popupHandler : preload ? this.preload(options) : this.buildPopupHandler();
}, Popup.prototype.callback = function (options) {
  var _this = this,
    theWindow = windowHelper.getWindow(),
    originUrl = (options = options || {}).popupOrigin || this.baseOptions.popupOrigin || windowHelper.getOrigin();
  theWindow.opener ? winchan.onOpen(function (popupOrigin, r, cb) {
    if (popupOrigin !== originUrl) return cb({
      error: "origin_mismatch",
      error_description: "The popup's origin (" + popupOrigin + ") should match the `popupOrigin` parameter (" + originUrl + ")."
    });
    _this.webAuth.parseHash(options || {}, function (err, data) {
      return cb(err || data);
    });
  }) : theWindow.doPost = function (msg) {
    theWindow.parent && theWindow.parent.postMessage(msg, originUrl);
  };
}, Popup.prototype.authorize = function (options, cb) {
  var url,
    relayUrl,
    popOpts = {},
    pluginHandler = this.baseOptions.plugins.get("popup.authorize"),
    params = objectHelper.merge(this.baseOptions, ["clientID", "scope", "domain", "audience", "tenant", "responseType", "redirectUri", "_csrf", "state", "_intstate", "nonce", "organization", "invitation"]).with(objectHelper.blacklist(options, ["popupHandler"]));
  return assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    responseType: {
      type: "string",
      message: "responseType option is required"
    }
  }), relayUrl = urlJoin(this.baseOptions.rootUrl, "relay.html"), options.owp ? params.owp = !0 : (popOpts.origin = urlHelper.extractOrigin(params.redirectUri), relayUrl = params.redirectUri), options.popupOptions && (popOpts.popupOptions = objectHelper.pick(options.popupOptions, ["width", "height", "top", "left"])), pluginHandler && (params = pluginHandler.processParams(params)), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", delete params.domain, url = this.client.buildAuthorizeUrl(params), this.getPopupHandler(options).load(url, relayUrl, popOpts, wrapCallback(cb, {
    keepOriginalCasing: !0
  }));
}, Popup.prototype.loginWithCredentials = function (options, cb) {
  options.realm = options.realm || options.connection, options.popup = !0, options = objectHelper.merge(this.baseOptions, ["redirectUri", "responseType", "state", "nonce", "timeout"]).with(objectHelper.blacklist(options, ["popupHandler", "connection"])), options = this.transactionManager.process(options), this.crossOriginAuthentication.login(options, cb);
}, Popup.prototype.passwordlessVerify = function (options, cb) {
  var _this = this;
  return this.client.passwordless.verify(objectHelper.blacklist(options, ["popupHandler"]), function (err) {
    if (err) return cb(err);
    options.username = options.phoneNumber || options.email, options.password = options.verificationCode, delete options.email, delete options.phoneNumber, delete options.verificationCode, delete options.type, _this.client.loginWithResourceOwner(options, cb);
  });
}, Popup.prototype.signupAndLogin = function (options, cb) {
  var _this = this;
  return this.client.dbConnection.signup(options, function (err) {
    if (err) return cb(err);
    _this.loginWithCredentials(options, cb);
  });
}, SilentAuthenticationHandler.create = function (options) {
  return new SilentAuthenticationHandler(options);
}, SilentAuthenticationHandler.prototype.login = function (usePostMessage, callback) {
  this.handler = new IframeHandler({
    auth0: this.auth0,
    url: this.authenticationUrl,
    eventListenerType: usePostMessage ? "message" : "load",
    callback: this.getCallbackHandler(callback, usePostMessage),
    timeout: this.timeout,
    eventValidator: this.getEventValidator(),
    timeoutCallback: function () {
      callback(null, "#error=timeout&error_description=Timeout+during+authentication+renew.");
    },
    usePostMessage: usePostMessage || !1
  }), this.handler.init();
}, SilentAuthenticationHandler.prototype.getEventValidator = function () {
  var _this = this;
  return {
    isValid: function (eventData) {
      switch (eventData.event.type) {
        case "message":
          return eventData.event.origin === _this.postMessageOrigin && eventData.event.source === _this.handler.iframe.contentWindow && (!1 === _this.postMessageDataType || eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType);
        case "load":
          if ("about:" === eventData.sourceObject.contentWindow.location.protocol) return !1;
        default:
          return !0;
      }
    }
  };
}, SilentAuthenticationHandler.prototype.getCallbackHandler = function (callback, usePostMessage) {
  return function (eventData) {
    var callbackValue;
    callbackValue = usePostMessage ? "object" === _typeof(eventData.event.data) && eventData.event.data.hash ? eventData.event.data.hash : eventData.event.data : eventData.sourceObject.contentWindow.location.hash, callback(null, callbackValue);
  };
}, UsernamePassword.prototype.login = function (options, cb) {
  var url, body;
  return url = urlJoin(this.baseOptions.rootUrl, "usernamepassword", "login"), options.username = options.username || options.email, options = objectHelper.blacklist(options, ["email", "onRedirecting"]), body = objectHelper.merge(this.baseOptions, ["clientID", "redirectUri", "tenant", "responseType", "responseMode", "scope", "audience"]).with(options), body = this.transactionManager.process(body), body = objectHelper.toSnakeCase(body, ["auth0Client"]), this.request.post(url).send(body).end(wrapCallback(cb));
}, UsernamePassword.prototype.callback = function (formHtml) {
  var div,
    _document = windowHelper.getDocument();
  (div = _document.createElement("div")).innerHTML = formHtml, _document.body.appendChild(div).children[0].submit();
}, HostedPages.prototype.login = function (options, cb) {
  if (windowHelper.getWindow().location.host !== this.baseOptions.domain) throw new Error("This method is meant to be used only inside the Universal Login Page.");
  var usernamePassword,
    params = objectHelper.merge(this.baseOptions, ["clientID", "redirectUri", "tenant", "responseType", "responseMode", "scope", "audience", "_csrf", "state", "_intstate", "nonce"]).with(options);
  return assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    responseType: {
      type: "string",
      message: "responseType option is required"
    }
  }), (usernamePassword = new UsernamePassword(this.baseOptions)).login(params, function (err, data) {
    if (err) return cb(err);
    function doAuth() {
      usernamePassword.callback(data);
    }
    if ("function" == typeof options.onRedirecting) return options.onRedirecting(function () {
      doAuth();
    });
    doAuth();
  });
}, HostedPages.prototype.signupAndLogin = function (options, cb) {
  var _this = this;
  return _this.client.client.dbConnection.signup(options, function (err) {
    return err ? cb(err) : _this.login(options, cb);
  });
}, HostedPages.prototype.getSSOData = function (withActiveDirectories, cb) {
  var url,
    params = "";
  return "function" == typeof withActiveDirectories && (cb = withActiveDirectories, withActiveDirectories = !1), assert.check(withActiveDirectories, {
    type: "boolean",
    message: "withActiveDirectories parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), withActiveDirectories && (params = "?" + lib_stringify({
    ldaps: 1,
    client_id: this.baseOptions.clientID
  })), url = urlJoin(this.baseOptions.rootUrl, "user", "ssodata", params), this.request.get(url, {
    noHeaders: !0
  }).withCredentials().end(wrapCallback(cb));
};
var noop = function () {},
  captchaSolved = noop,
  done = noop,
  captchaReloaded = !1,
  Flow = {
    DEFAULT: "default",
    SIGNUP: "signup",
    PASSWORDLESS: "passwordless",
    PASSWORD_RESET: "password_reset"
  },
  defaults$3 = {
    lang: "en",
    templates: {
      auth0: function (challenge) {
        var message = "code" === challenge.type ? "Enter the code shown above" : "Solve the formula shown above";
        return '<div class="captcha-challenge">\n  <img src="' + challenge.image + '" />\n  <button type="button" class="captcha-reload">↺</button>\n</div>\n<input type="text" name="captcha"\n  class="form-control captcha-control"\n  placeholder="' + message + '" />';
      },
      recaptcha_v2: function () {
        return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
      },
      recaptcha_enterprise: function () {
        return '<div class="recaptcha" ></div><input type="hidden" name="captcha" />';
      },
      hcaptcha: function () {
        return '<div class="hcaptcha" ></div><input type="hidden" name="captcha" />';
      },
      friendly_captcha: function () {
        return '<div class="friendly-captcha" ></div><input type="hidden" name="captcha" />';
      },
      arkose: function () {
        return '<div class="arkose" ></div><input type="hidden" name="captcha" />';
      },
      auth0_v2: function () {
        return '<div class="auth0_v2" ></div><input type="hidden" name="captcha" />';
      },
      error: function () {
        return '<div class="error" style="color: red;">Error getting the bot detection challenge. Please contact the system administrator.</div>';
      }
    }
  };
function globalForCaptchaProvider(provider) {
  switch (provider) {
    case "recaptcha_v2":
      return window.grecaptcha;
    case "recaptcha_enterprise":
      return window.grecaptcha.enterprise;
    case "hcaptcha":
      return window.hcaptcha;
    case "friendly_captcha":
      return window.friendlyChallenge;
    case "arkose":
      return window.arkose;
    case "auth0_v2":
      return window.turnstile;
    default:
      throw new Error("Unknown captcha provider");
  }
}
function loadScript(url, attributes) {
  var script = window.document.createElement("script");
  for (var attr in attributes) attr.startsWith("data-") ? script.dataset[attr.replace("data-", "")] = attributes[attr] : script[attr] = attributes[attr];
  script.src = url, window.document.body.appendChild(script);
}
function removeScript(url) {
  window.document.querySelectorAll('script[src="' + url + '"]').forEach(function (script) {
    script.remove();
  });
}
function injectCaptchaScript(opts, callback, setValue) {
  var callbackName = opts.provider + "Callback_" + Math.floor(1000001 * Math.random()),
    attributes = {
      async: !0,
      defer: !0
    },
    scriptSrc = function (provider, lang, callback, clientSubdomain, siteKey) {
      switch (provider) {
        case "recaptcha_v2":
          return "https://www.recaptcha.net/recaptcha/api.js?hl=" + lang + "&onload=" + callback;
        case "recaptcha_enterprise":
          return "https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit&hl=" + lang + "&onload=" + callback;
        case "hcaptcha":
          return "https://js.hcaptcha.com/1/api.js?hl=" + lang + "&onload=" + callback;
        case "friendly_captcha":
          return "https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.12/widget.min.js";
        case "arkose":
          return "https://" + clientSubdomain + ".arkoselabs.com/v2/" + siteKey + "/api.js";
        case "auth0_v2":
          return "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=" + callback;
        default:
          throw new Error("Unknown captcha provider");
      }
    }(opts.provider, opts.lang, callbackName, opts.clientSubdomain, opts.siteKey);
  if ("arkose" === opts.provider || "auth0_v2" === opts.provider) {
    var retryCount = 0;
    attributes["data-callback"] = callbackName, attributes.onerror = function () {
      if (retryCount < 3) return removeScript(scriptSrc), loadScript(scriptSrc, attributes), void retryCount++;
      removeScript(scriptSrc), done(new Error(opts.provider + " failed to load")), setValue("BYPASS_CAPTCHA");
    }, window[callbackName] = function (arkose) {
      window.arkose = arkose, callback(arkose);
    };
  } else window[callbackName] = function () {
    delete window[callbackName], callback();
  }, "friendly_captcha" === opts.provider && (attributes.onload = window[callbackName]);
  loadScript(scriptSrc, attributes);
}
var captcha = {
  render: function (auth0Client, flow, element, options, callback) {
    function load(loadDone) {
      function challengeCallback(err, challenge) {
        return err ? (element.innerHTML = options.templates.error(err), done(err)) : challenge.required ? (element.style.display = "", void ("auth0" === challenge.provider ? (!function (element, options, challenge, load) {
          element.innerHTML = options.templates[challenge.provider](challenge), element.querySelector(".captcha-reload").addEventListener("click", function (e) {
            e.preventDefault(), load();
          });
        }(element, options, challenge, load), done()) : "recaptcha_v2" !== challenge.provider && "recaptcha_enterprise" !== challenge.provider && "hcaptcha" !== challenge.provider && "friendly_captcha" !== challenge.provider && "arkose" !== challenge.provider && "auth0_v2" !== challenge.provider || function (element, options, challenge) {
          var captchaClass,
            widgetId = element.hasAttribute("data-wid") && element.getAttribute("data-wid");
          function setValue(value) {
            element.querySelector('input[name="captcha"]').value = value || "";
          }
          if ("friendly_captcha" === challenge.provider && window.auth0FCInstance) return setValue(), void window.auth0FCInstance.reset();
          if ("arkose" === challenge.provider && globalForCaptchaProvider(challenge.provider)) return setValue(), void globalForCaptchaProvider(challenge.provider).reset();
          if (widgetId) return setValue(), void globalForCaptchaProvider(challenge.provider).reset(widgetId);
          switch (element.innerHTML = options.templates[challenge.provider](challenge), challenge.provider) {
            case "recaptcha_enterprise":
            case "recaptcha_v2":
              captchaClass = ".recaptcha";
              break;
            case "hcaptcha":
              captchaClass = ".hcaptcha";
              break;
            case "friendly_captcha":
              captchaClass = ".friendly-captcha";
              break;
            case "arkose":
              captchaClass = ".arkose";
              break;
            case "auth0_v2":
              captchaClass = ".auth0_v2";
          }
          var captchaDiv = element.querySelector(captchaClass);
          injectCaptchaScript({
            lang: options.lang,
            provider: challenge.provider,
            clientSubdomain: challenge.clientSubdomain,
            siteKey: challenge.siteKey
          }, function (arkose) {
            var global = globalForCaptchaProvider(challenge.provider);
            if ("arkose" === challenge.provider) {
              var retryCount = 0,
                arkoseLoaded = !1;
              arkose.setConfig({
                onReady: function () {
                  arkoseLoaded && !captchaReloaded || (done(null, {
                    triggerCaptcha: function (solvedCallback) {
                      arkose.run(), captchaSolved = solvedCallback;
                    }
                  }), captchaReloaded && (captchaReloaded = !1), arkoseLoaded = !0);
                },
                onCompleted: function (response) {
                  setValue(response.token), captchaSolved();
                },
                onError: function (response) {
                  retryCount < 3 ? (setValue(), arkose.reset(), setTimeout(function () {
                    arkose.run();
                  }, 500), retryCount++) : (arkoseLoaded || (done(new Error(response.error.error)), arkoseLoaded = !0), setValue("BYPASS_CAPTCHA"));
                }
              });
            } else if ("friendly_captcha" === challenge.provider) window.auth0FCInstance = new global.WidgetInstance(captchaDiv, {
              sitekey: challenge.siteKey,
              language: options.lang,
              doneCallback: function (solution) {
                setValue(solution);
              },
              errorCallback: function () {
                setValue();
              }
            }), done();else {
              var renderParams = {
                callback: setValue,
                "expired-callback": function () {
                  setValue();
                },
                "error-callback": function () {
                  setValue();
                },
                sitekey: challenge.siteKey
              };
              "auth0_v2" === challenge.provider && (retryCount = 0, renderParams.language = options.lang, renderParams.theme = "light", renderParams.retry = "never", renderParams["response-field"] = !1, renderParams["error-callback"] = function () {
                return retryCount < 3 ? (setValue(), globalForCaptchaProvider(challenge.provider).reset(widgetId), retryCount++) : setValue("BYPASS_CAPTCHA"), !0;
              }), widgetId = global.render(captchaDiv, renderParams), element.setAttribute("data-wid", widgetId), done();
            }
          }, setValue);
        }(element, options, challenge))) : (element.style.display = "none", element.innerHTML = "", done());
      }
      done = loadDone || noop, flow === Flow.PASSWORDLESS ? auth0Client.passwordless.getChallenge(challengeCallback) : flow === Flow.PASSWORD_RESET ? auth0Client.dbConnection.getPasswordResetChallenge(challengeCallback) : flow === Flow.SIGNUP ? auth0Client.dbConnection.getSignupChallenge(challengeCallback) : auth0Client.getChallenge(challengeCallback);
    }
    return options = objectHelper.merge(defaults$3).with(options || {}), load(callback), {
      reload: function (reloadDone) {
        captchaReloaded = !0, load(reloadDone);
      },
      getValue: function () {
        var captchaInput = element.querySelector('input[name="captcha"]');
        if (captchaInput) return captchaInput.value;
      }
    };
  },
  Flow: Flow
};
function defaultClock() {
  return new Date();
}
function WebAuth(options) {
  assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    domain: {
      type: "string",
      message: "domain option is required"
    },
    clientID: {
      type: "string",
      message: "clientID option is required"
    },
    responseType: {
      optional: !0,
      type: "string",
      message: "responseType is not valid"
    },
    responseMode: {
      optional: !0,
      type: "string",
      message: "responseMode is not valid"
    },
    redirectUri: {
      optional: !0,
      type: "string",
      message: "redirectUri is not valid"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope is not valid"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience is not valid"
    },
    popupOrigin: {
      optional: !0,
      type: "string",
      message: "popupOrigin is not valid"
    },
    leeway: {
      optional: !0,
      type: "number",
      message: "leeway is not valid"
    },
    plugins: {
      optional: !0,
      type: "array",
      message: "plugins is not valid"
    },
    maxAge: {
      optional: !0,
      type: "number",
      message: "maxAge is not valid"
    },
    stateExpiration: {
      optional: !0,
      type: "number",
      message: "stateExpiration is not valid"
    },
    legacySameSiteCookie: {
      optional: !0,
      type: "boolean",
      message: "legacySameSiteCookie option is not valid"
    },
    _disableDeprecationWarnings: {
      optional: !0,
      type: "boolean",
      message: "_disableDeprecationWarnings option is not valid"
    },
    _sendTelemetry: {
      optional: !0,
      type: "boolean",
      message: "_sendTelemetry option is not valid"
    },
    _telemetryInfo: {
      optional: !0,
      type: "object",
      message: "_telemetryInfo option is not valid"
    },
    _timesToRetryFailedRequests: {
      optional: !0,
      type: "number",
      message: "_timesToRetryFailedRequests option is not valid"
    }
  }), options.overrides && assert.check(options.overrides, {
    type: "object",
    message: "overrides option is not valid"
  }, {
    __tenant: {
      optional: !0,
      type: "string",
      message: "__tenant option is required"
    },
    __token_issuer: {
      optional: !0,
      type: "string",
      message: "__token_issuer option is required"
    },
    __jwks_uri: {
      optional: !0,
      type: "string",
      message: "__jwks_uri is required"
    }
  }), this.baseOptions = options, this.baseOptions.plugins = new PluginHandler(this, this.baseOptions.plugins || []), this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions._timesToRetryFailedRequests = options._timesToRetryFailedRequests ? parseInt(options._timesToRetryFailedRequests) : 0, this.baseOptions.tenant = this.baseOptions.overrides && this.baseOptions.overrides.__tenant || this.baseOptions.domain.split(".")[0], this.baseOptions.token_issuer = this.baseOptions.overrides && this.baseOptions.overrides.__token_issuer || "https://" + this.baseOptions.domain + "/", this.baseOptions.jwksURI = this.baseOptions.overrides && this.baseOptions.overrides.__jwks_uri, !1 !== options.legacySameSiteCookie && (this.baseOptions.legacySameSiteCookie = !0), this.transactionManager = new TransactionManager(this.baseOptions), this.client = new Authentication(this.baseOptions), this.redirect = new Redirect(this, this.baseOptions), this.popup = new Popup(this, this.baseOptions), this.crossOriginAuthentication = new CrossOriginAuthentication(this, this.baseOptions), this.webMessageHandler = new WebMessageHandler(this), this._universalLogin = new HostedPages(this, this.baseOptions), this.ssodataStorage = new SSODataStorage(this.baseOptions);
}
function PasswordlessAuthentication(request, options) {
  this.baseOptions = options, this.request = request;
}
function DBConnection(request, options) {
  this.baseOptions = options, this.request = request;
}
function Authentication(auth0, options) {
  2 === arguments.length ? this.auth0 = auth0 : options = auth0, assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    domain: {
      type: "string",
      message: "domain option is required"
    },
    clientID: {
      type: "string",
      message: "clientID option is required"
    },
    responseType: {
      optional: !0,
      type: "string",
      message: "responseType is not valid"
    },
    responseMode: {
      optional: !0,
      type: "string",
      message: "responseMode is not valid"
    },
    redirectUri: {
      optional: !0,
      type: "string",
      message: "redirectUri is not valid"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope is not valid"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience is not valid"
    },
    _disableDeprecationWarnings: {
      optional: !0,
      type: "boolean",
      message: "_disableDeprecationWarnings option is not valid"
    },
    _sendTelemetry: {
      optional: !0,
      type: "boolean",
      message: "_sendTelemetry option is not valid"
    },
    _telemetryInfo: {
      optional: !0,
      type: "object",
      message: "_telemetryInfo option is not valid"
    }
  }), this.baseOptions = options, this.baseOptions._sendTelemetry = !1 !== this.baseOptions._sendTelemetry || this.baseOptions._sendTelemetry, this.baseOptions.rootUrl = this.baseOptions.domain && 0 === this.baseOptions.domain.toLowerCase().indexOf("http") ? this.baseOptions.domain : "https://" + this.baseOptions.domain, this.request = new RequestBuilder(this.baseOptions), this.passwordless = new PasswordlessAuthentication(this.request, this.baseOptions), this.dbConnection = new DBConnection(this.request, this.baseOptions), this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  }), this.ssodataStorage = new SSODataStorage(this.baseOptions);
}
function Management(options) {
  assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    domain: {
      type: "string",
      message: "domain option is required"
    },
    token: {
      type: "string",
      message: "token option is required"
    },
    _sendTelemetry: {
      optional: !0,
      type: "boolean",
      message: "_sendTelemetry option is not valid"
    },
    _telemetryInfo: {
      optional: !0,
      type: "object",
      message: "_telemetryInfo option is not valid"
    }
  }), this.baseOptions = options, this.baseOptions.headers = {
    Authorization: "Bearer " + this.baseOptions.token
  }, this.request = new RequestBuilder(this.baseOptions), this.baseOptions.rootUrl = urlJoin("https://" + this.baseOptions.domain, "api", "v2");
}
WebAuth.prototype.parseHash = function (options, cb) {
  var parsedQs, err;
  cb || "function" != typeof options ? options = options || {} : (cb = options, options = {});
  var hashStr = void 0 === options.hash ? windowHelper.getWindow().location.hash : options.hash;
  if (hashStr = hashStr.replace(/^#?\/?/, ""), (parsedQs = lib_parse(hashStr)).hasOwnProperty("error")) return err = error.buildResponse(parsedQs.error, parsedQs.error_description), parsedQs.state && (err.state = parsedQs.state), cb(err);
  if (!parsedQs.hasOwnProperty("access_token") && !parsedQs.hasOwnProperty("id_token") && !parsedQs.hasOwnProperty("refresh_token")) return cb(null, null);
  var responseTypes = (this.baseOptions.responseType || options.responseType || "").split(" ");
  return responseTypes.length > 0 && -1 !== responseTypes.indexOf("token") && !parsedQs.hasOwnProperty("access_token") ? cb(error.buildResponse("invalid_hash", "response_type contains `token`, but the parsed hash does not contain an `access_token` property")) : responseTypes.length > 0 && -1 !== responseTypes.indexOf("id_token") && !parsedQs.hasOwnProperty("id_token") ? cb(error.buildResponse("invalid_hash", "response_type contains `id_token`, but the parsed hash does not contain an `id_token` property")) : this.validateAuthenticationResponse(options, parsedQs, cb);
}, WebAuth.prototype.validateAuthenticationResponse = function (options, parsedHash, cb) {
  var _this = this;
  options.__enableIdPInitiatedLogin = options.__enableIdPInitiatedLogin || options.__enableImpersonation;
  var state = parsedHash.state,
    transaction = this.transactionManager.getStoredTransaction(state),
    transactionState = options.state || transaction && transaction.state || null,
    transactionStateMatchesState = transactionState === state;
  if (!(!state && !transactionState && options.__enableIdPInitiatedLogin) && !transactionStateMatchesState) return cb({
    error: "invalid_token",
    errorDescription: "`state` does not match."
  });
  var transactionNonce = options.nonce || transaction && transaction.nonce || null,
    transactionOrganization = transaction && transaction.organization,
    appState = options.state || transaction && transaction.appState || null,
    callback = function (err, payload) {
      if (err) return cb(err);
      var sub;
      transaction && transaction.lastUsedConnection && (payload && (sub = payload.sub), _this.ssodataStorage.set(transaction.lastUsedConnection, sub));
      return cb(null, function (qsParams, appState, token) {
        return {
          accessToken: qsParams.access_token || null,
          idToken: qsParams.id_token || null,
          idTokenPayload: token || null,
          appState: appState || null,
          refreshToken: qsParams.refresh_token || null,
          state: qsParams.state || null,
          expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
          tokenType: qsParams.token_type || null,
          scope: qsParams.scope || null
        };
      }(parsedHash, appState, payload));
    };
  return parsedHash.id_token ? this.validateToken(parsedHash.id_token, transactionNonce, function (validationError, payload) {
    if (!validationError) {
      if (transactionOrganization) if (0 === transactionOrganization.indexOf("org_")) {
        if (!payload.org_id) return callback(error.invalidToken("Organization Id (org_id) claim must be a string present in the ID token"));
        if (payload.org_id !== transactionOrganization) return callback(error.invalidToken('Organization Id (org_id) claim value mismatch in the ID token; expected "' + transactionOrganization + '", found "' + payload.org_id + '"'));
      } else {
        if (!payload.org_name) return callback(error.invalidToken("Organization Name (org_name) claim must be a string present in the ID token"));
        if (payload.org_name !== transactionOrganization.toLowerCase()) return callback(error.invalidToken('Organization Name (org_name) claim value mismatch in the ID token; expected "' + transactionOrganization + '", found "' + payload.org_name + '"'));
      }
      return parsedHash.access_token && payload.at_hash ? new I().validateAccessToken(parsedHash.access_token, "RS256", payload.at_hash, function (err) {
        return err ? callback(error.invalidToken(err.message)) : callback(null, payload);
      }) : callback(null, payload);
    }
    if ("invalid_token" !== validationError.error || validationError.errorDescription && validationError.errorDescription.indexOf("Nonce (nonce) claim value mismatch in the ID token") > -1) return callback(validationError);
    var decodedToken = new I().decode(parsedHash.id_token);
    if ("HS256" !== decodedToken.header.alg) return callback(validationError);
    if ((decodedToken.payload.nonce || null) !== transactionNonce) return callback({
      error: "invalid_token",
      errorDescription: 'Nonce (nonce) claim value mismatch in the ID token; expected "' + transactionNonce + '", found "' + decodedToken.payload.nonce + '"'
    });
    if (!parsedHash.access_token) {
      return callback({
        error: "invalid_token",
        description: "The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can’t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token"
      });
    }
    return _this.client.userInfo(parsedHash.access_token, function (errUserInfo, profile) {
      return errUserInfo ? callback(errUserInfo) : callback(null, profile);
    });
  }) : callback(null, null);
}, WebAuth.prototype.validateToken = function (token, nonce, cb) {
  new I({
    issuer: this.baseOptions.token_issuer,
    jwksURI: this.baseOptions.jwksURI,
    audience: this.baseOptions.clientID,
    leeway: this.baseOptions.leeway || 60,
    maxAge: this.baseOptions.maxAge,
    __clock: this.baseOptions.__clock || defaultClock
  }).verify(token, nonce, function (err, payload) {
    if (err) return cb(error.invalidToken(err.message));
    cb(null, payload);
  });
}, WebAuth.prototype.renewAuth = function (options, cb) {
  var usePostMessage = !!options.usePostMessage,
    postMessageDataType = options.postMessageDataType || !1,
    postMessageOrigin = options.postMessageOrigin || windowHelper.getWindow().origin,
    timeout = options.timeout,
    _this = this,
    params = objectHelper.merge(this.baseOptions, ["clientID", "redirectUri", "responseType", "scope", "audience", "_csrf", "state", "_intstate", "nonce"]).with(options);
  params.responseType = params.responseType || "token", params.responseMode = params.responseMode || "fragment", params = this.transactionManager.process(params), assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), params.prompt = "none", params = objectHelper.blacklist(params, ["usePostMessage", "tenant", "postMessageDataType", "postMessageOrigin"]), SilentAuthenticationHandler.create({
    authenticationUrl: this.client.buildAuthorizeUrl(params),
    postMessageDataType: postMessageDataType,
    postMessageOrigin: postMessageOrigin,
    timeout: timeout
  }).login(usePostMessage, function (err, hash) {
    if ("object" === _typeof(hash)) return cb(err, hash);
    _this.parseHash({
      hash: hash
    }, cb);
  });
}, WebAuth.prototype.checkSession = function (options, cb) {
  var params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce"]).with(options);
  return "code" === params.responseType ? cb({
    error: "error",
    error_description: "responseType can't be `code`"
  }) : (options.nonce || (params = this.transactionManager.process(params)), params.redirectUri ? (assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), params = objectHelper.blacklist(params, ["usePostMessage", "tenant", "postMessageDataType"]), void this.webMessageHandler.run(params, wrapCallback(cb, {
    forceLegacyError: !0,
    ignoreCasing: !0
  }))) : cb({
    error: "error",
    error_description: "redirectUri can't be empty"
  }));
}, WebAuth.prototype.changePassword = function (options, cb) {
  return this.client.dbConnection.changePassword(options, cb);
}, WebAuth.prototype.passwordlessStart = function (options, cb) {
  var authParams = objectHelper.merge(this.baseOptions, ["responseType", "responseMode", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce"]).with(options.authParams);
  return options.authParams = this.transactionManager.process(authParams), this.client.passwordless.start(options, cb);
}, WebAuth.prototype.signup = function (options, cb) {
  return this.client.dbConnection.signup(options, cb);
}, WebAuth.prototype.authorize = function (options) {
  var params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "responseMode", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce", "organization", "invitation"]).with(options);
  assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    responseType: {
      type: "string",
      message: "responseType option is required"
    }
  }), (params = this.transactionManager.process(params)).scope = params.scope || "openid profile email", windowHelper.redirect(this.client.buildAuthorizeUrl(params));
}, WebAuth.prototype.signupAndAuthorize = function (options, cb) {
  var _this = this;
  return this.client.dbConnection.signup(objectHelper.blacklist(options, ["popupHandler"]), function (err) {
    if (err) return cb(err);
    options.realm = options.connection, options.username || (options.username = options.email), _this.client.login(options, cb);
  });
}, WebAuth.prototype.login = function (options, cb) {
  var params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce", "onRedirecting", "organization", "invitation"]).with(options);
  params = this.transactionManager.process(params), windowHelper.getWindow().location.host === this.baseOptions.domain ? (params.connection = params.realm, delete params.realm, this._universalLogin.login(params, cb)) : this.crossOriginAuthentication.login(params, cb);
}, WebAuth.prototype.passwordlessLogin = function (options, cb) {
  var params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce", "onRedirecting"]).with(options);
  if (params = this.transactionManager.process(params), windowHelper.getWindow().location.host === this.baseOptions.domain) this.passwordlessVerify(params, cb);else {
    var crossOriginOptions = objectHelper.extend({
      credentialType: "http://auth0.com/oauth/grant-type/passwordless/otp",
      realm: params.connection,
      username: params.email || params.phoneNumber,
      otp: params.verificationCode
    }, objectHelper.blacklist(params, ["connection", "email", "phoneNumber", "verificationCode"]));
    this.crossOriginAuthentication.login(crossOriginOptions, cb);
  }
}, WebAuth.prototype.crossOriginAuthenticationCallback = function () {
  this.crossOriginVerification();
}, WebAuth.prototype.crossOriginVerification = function () {
  this.crossOriginAuthentication.callback();
}, WebAuth.prototype.logout = function (options) {
  windowHelper.redirect(this.client.buildLogoutUrl(options));
}, WebAuth.prototype.passwordlessVerify = function (options, cb) {
  var _this = this,
    params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "responseMode", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "nonce", "onRedirecting"]).with(options);
  return assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    responseType: {
      type: "string",
      message: "responseType option is required"
    }
  }), params = this.transactionManager.process(params), this.client.passwordless.verify(params, function (err) {
    if (err) return cb(err);
    function doAuth() {
      windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params));
    }
    if ("function" == typeof options.onRedirecting) return options.onRedirecting(function () {
      doAuth();
    });
    doAuth();
  });
}, WebAuth.prototype.renderCaptcha = function (element, options, callback) {
  return captcha.render(this.client, captcha.Flow.DEFAULT, element, options, callback);
}, WebAuth.prototype.renderSignupCaptcha = function (element, options, callback) {
  return captcha.render(this.client, captcha.Flow.SIGNUP, element, options, callback);
}, WebAuth.prototype.renderPasswordlessCaptcha = function (element, options, callback) {
  return captcha.render(this.client, captcha.Flow.PASSWORDLESS, element, options, callback);
}, WebAuth.prototype.renderPasswordResetCaptcha = function (element, options, callback) {
  return captcha.render(this.client, captcha.Flow.PASSWORD_RESET, element, options, callback);
}, PasswordlessAuthentication.prototype.buildVerifyUrl = function (options) {
  var params, qString;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    connection: {
      type: "string",
      message: "connection option is required"
    },
    verificationCode: {
      type: "string",
      message: "verificationCode option is required"
    },
    phoneNumber: {
      optional: !1,
      type: "string",
      message: "phoneNumber option is required",
      condition: function (o) {
        return !o.email;
      }
    },
    email: {
      optional: !1,
      type: "string",
      message: "email option is required",
      condition: function (o) {
        return !o.phoneNumber;
      }
    }
  }), params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "responseMode", "redirectUri", "scope", "audience", "_csrf", "state", "_intstate", "protocol", "nonce"]).with(options), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = objectHelper.toSnakeCase(params, ["auth0Client"]), qString = lib_stringify(params), urlJoin(this.baseOptions.rootUrl, "passwordless", "verify_redirect", "?" + qString);
}, PasswordlessAuthentication.prototype.start = function (options, cb) {
  var url, body;
  assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    connection: {
      type: "string",
      message: "connection option is required"
    },
    send: {
      type: "string",
      message: "send option is required",
      values: ["link", "code"],
      value_message: "send is not valid ([link, code])"
    },
    phoneNumber: {
      optional: !0,
      type: "string",
      message: "phoneNumber option is required",
      condition: function (o) {
        return "code" === o.send || !o.email;
      }
    },
    email: {
      optional: !0,
      type: "string",
      message: "email option is required",
      condition: function (o) {
        return "link" === o.send || !o.phoneNumber;
      }
    },
    authParams: {
      optional: !0,
      type: "object",
      message: "authParams option is required"
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "passwordless", "start");
  var xRequestLanguage = options.xRequestLanguage;
  delete options.xRequestLanguage, (body = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "redirectUri", "scope"]).with(options)).scope && (body.authParams = body.authParams || {}, body.authParams.scope = body.authParams.scope || body.scope), body.redirectUri && (body.authParams = body.authParams || {}, body.authParams.redirect_uri = body.authParams.redirectUri || body.redirectUri), body.responseType && (body.authParams = body.authParams || {}, body.authParams.response_type = body.authParams.responseType || body.responseType), delete body.redirectUri, delete body.responseType, delete body.scope, body = objectHelper.toSnakeCase(body, ["auth0Client", "authParams"]);
  var postOptions = xRequestLanguage ? {
    xRequestLanguage: xRequestLanguage
  } : void 0;
  return this.request.post(url, postOptions).send(body).end(wrapCallback(cb));
}, PasswordlessAuthentication.prototype.verify = function (options, cb) {
  var url, cleanOption;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    connection: {
      type: "string",
      message: "connection option is required"
    },
    verificationCode: {
      type: "string",
      message: "verificationCode option is required"
    },
    phoneNumber: {
      optional: !1,
      type: "string",
      message: "phoneNumber option is required",
      condition: function (o) {
        return !o.email;
      }
    },
    email: {
      optional: !1,
      type: "string",
      message: "email option is required",
      condition: function (o) {
        return !o.phoneNumber;
      }
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), cleanOption = objectHelper.pick(options, ["connection", "verificationCode", "phoneNumber", "email", "auth0Client", "clientID"]), cleanOption = objectHelper.toSnakeCase(cleanOption, ["auth0Client"]), url = urlJoin(this.baseOptions.rootUrl, "passwordless", "verify"), this.request.post(url).send(cleanOption).end(wrapCallback(cb));
}, PasswordlessAuthentication.prototype.getChallenge = function (cb) {
  if (assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), !this.baseOptions.state) return cb();
  var url = urlJoin(this.baseOptions.rootUrl, "passwordless", "challenge");
  return this.request.post(url).send({
    state: this.baseOptions.state
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, DBConnection.prototype.signup = function (options, cb) {
  var url, body, metadata;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    connection: {
      type: "string",
      message: "connection option is required"
    },
    email: {
      type: "string",
      message: "email option is required"
    },
    password: {
      type: "string",
      message: "password option is required"
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "dbconnections", "signup"), metadata = (body = objectHelper.merge(this.baseOptions, ["clientID", "state"]).with(options)).user_metadata || body.userMetadata, body = objectHelper.blacklist(body, ["scope", "userMetadata", "user_metadata"]), body = objectHelper.toSnakeCase(body, ["auth0Client"]), metadata && (body.user_metadata = metadata), this.request.post(url).send(body).end(wrapCallback(cb));
}, DBConnection.prototype.changePassword = function (options, cb) {
  var url, body;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    connection: {
      type: "string",
      message: "connection option is required"
    },
    email: {
      type: "string",
      message: "email option is required"
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "dbconnections", "change_password"), body = objectHelper.merge(this.baseOptions, ["clientID", "state"]).with(options, ["email", "connection", "captcha"]), body = objectHelper.toSnakeCase(body, ["auth0Client"]), this.request.post(url).send(body).end(wrapCallback(cb));
}, DBConnection.prototype.getPasswordResetChallenge = function (cb) {
  if (assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), !this.baseOptions.state) return cb();
  var url = urlJoin(this.baseOptions.rootUrl, "dbconnections", "change_password", "challenge");
  return this.request.post(url).send({
    state: this.baseOptions.state
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, DBConnection.prototype.getSignupChallenge = function (cb) {
  if (assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), !this.baseOptions.state) return cb();
  var url = urlJoin(this.baseOptions.rootUrl, "dbconnections", "signup", "challenge");
  return this.request.post(url).send({
    state: this.baseOptions.state
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Authentication.prototype.buildAuthorizeUrl = function (options) {
  var params, qString;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }), params = objectHelper.merge(this.baseOptions, ["clientID", "responseType", "responseMode", "redirectUri", "scope", "audience"]).with(options), assert.check(params, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    clientID: {
      type: "string",
      message: "clientID option is required"
    },
    redirectUri: {
      optional: !0,
      type: "string",
      message: "redirectUri option is required"
    },
    responseType: {
      type: "string",
      message: "responseType option is required"
    },
    nonce: {
      type: "string",
      message: "nonce option is required",
      condition: function (o) {
        return -1 === o.responseType.indexOf("code") && -1 !== o.responseType.indexOf("id_token");
      }
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope option is required"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience option is required"
    }
  }), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params.connection_scope && assert.isArray(params.connection_scope) && (params.connection_scope = params.connection_scope.join(",")), params = objectHelper.blacklist(params, ["username", "popupOptions", "domain", "tenant", "timeout", "appState"]), params = objectHelper.toSnakeCase(params, ["auth0Client"]), params = parametersWhitelist.oauthAuthorizeParams(this.warn, params), qString = lib_stringify(params), urlJoin(this.baseOptions.rootUrl, "authorize", "?" + qString);
}, Authentication.prototype.buildLogoutUrl = function (options) {
  var params, qString;
  return assert.check(options, {
    optional: !0,
    type: "object",
    message: "options parameter is not valid"
  }), params = objectHelper.merge(this.baseOptions, ["clientID"]).with(options || {}), this.baseOptions._sendTelemetry && (params.auth0Client = this.request.getTelemetryData()), params = objectHelper.toSnakeCase(params, ["auth0Client", "returnTo"]), qString = lib_stringify(objectHelper.blacklist(params, ["federated"])), options && void 0 !== options.federated && !1 !== options.federated && "false" !== options.federated && (qString += "&federated"), urlJoin(this.baseOptions.rootUrl, "v2", "logout", "?" + qString);
}, Authentication.prototype.loginWithDefaultDirectory = function (options, cb) {
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    username: {
      type: "string",
      message: "username option is required"
    },
    password: {
      type: "string",
      message: "password option is required"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope option is required"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience option is required"
    }
  }), options.grantType = "password", this.oauthToken(options, cb);
}, Authentication.prototype.login = function (options, cb) {
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    username: {
      type: "string",
      message: "username option is required"
    },
    password: {
      type: "string",
      message: "password option is required"
    },
    realm: {
      type: "string",
      message: "realm option is required"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope option is required"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience option is required"
    }
  }), options.grantType = "http://auth0.com/oauth/grant-type/password-realm", this.oauthToken(options, cb);
}, Authentication.prototype.oauthToken = function (options, cb) {
  var url, body;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "oauth", "token"), body = objectHelper.merge(this.baseOptions, ["clientID", "scope", "audience"]).with(options), assert.check(body, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    clientID: {
      type: "string",
      message: "clientID option is required"
    },
    grantType: {
      type: "string",
      message: "grantType option is required"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope option is required"
    },
    audience: {
      optional: !0,
      type: "string",
      message: "audience option is required"
    }
  }), body = objectHelper.toSnakeCase(body, ["auth0Client"]), body = parametersWhitelist.oauthTokenParams(this.warn, body), this.request.post(url).send(body).end(wrapCallback(cb));
}, Authentication.prototype.loginWithResourceOwner = function (options, cb) {
  var url, body;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    username: {
      type: "string",
      message: "username option is required"
    },
    password: {
      type: "string",
      message: "password option is required"
    },
    connection: {
      type: "string",
      message: "connection option is required"
    },
    scope: {
      optional: !0,
      type: "string",
      message: "scope option is required"
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "oauth", "ro"), body = objectHelper.merge(this.baseOptions, ["clientID", "scope"]).with(options, ["username", "password", "scope", "connection", "device"]), (body = objectHelper.toSnakeCase(body, ["auth0Client"])).grant_type = body.grant_type || "password", this.request.post(url).send(body).end(wrapCallback(cb));
}, Authentication.prototype.getSSOData = function (withActiveDirectories, cb) {
  if (this.auth0 || (this.auth0 = new WebAuth(this.baseOptions)), windowHelper.getWindow().location.host === this.baseOptions.domain) return this.auth0._universalLogin.getSSOData(withActiveDirectories, cb);
  "function" == typeof withActiveDirectories && (cb = withActiveDirectories), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  });
  var clientId = this.baseOptions.clientID,
    ssodataInformation = this.ssodataStorage.get() || {};
  this.auth0.checkSession({
    responseType: "token id_token",
    scope: "openid profile email",
    connection: ssodataInformation.lastUsedConnection,
    timeout: 5e3
  }, function (err, result) {
    return err ? "login_required" === err.error ? cb(null, {
      sso: !1
    }) : ("consent_required" === err.error && (err.error_description = "Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`."), cb(err, {
      sso: !1
    })) : ssodataInformation.lastUsedSub && ssodataInformation.lastUsedSub !== result.idTokenPayload.sub ? cb(err, {
      sso: !1
    }) : cb(null, {
      lastUsedConnection: {
        name: ssodataInformation.lastUsedConnection
      },
      lastUsedUserID: result.idTokenPayload.sub,
      lastUsedUsername: result.idTokenPayload.email || result.idTokenPayload.name,
      lastUsedClientID: clientId,
      sessionClients: [clientId],
      sso: !0
    });
  });
}, Authentication.prototype.userInfo = function (accessToken, cb) {
  var url;
  return assert.check(accessToken, {
    type: "string",
    message: "accessToken parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "userinfo"), this.request.get(url).set("Authorization", "Bearer " + accessToken).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Authentication.prototype.getChallenge = function (cb) {
  if (assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), !this.baseOptions.state) return cb();
  var url = urlJoin(this.baseOptions.rootUrl, "usernamepassword", "challenge");
  return this.request.post(url).send({
    state: this.baseOptions.state
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Authentication.prototype.delegation = function (options, cb) {
  var url, body;
  return assert.check(options, {
    type: "object",
    message: "options parameter is not valid"
  }, {
    grant_type: {
      type: "string",
      message: "grant_type option is required"
    }
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "delegation"), body = objectHelper.merge(this.baseOptions, ["clientID"]).with(options), body = objectHelper.toSnakeCase(body, ["auth0Client"]), this.request.post(url).send(body).end(wrapCallback(cb));
}, Authentication.prototype.getUserCountry = function (cb) {
  var url;
  return assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "user", "geoloc", "country"), this.request.get(url).end(wrapCallback(cb));
}, Management.prototype.getUser = function (userId, cb) {
  var url;
  return assert.check(userId, {
    type: "string",
    message: "userId parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.get(url).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Management.prototype.patchUserMetadata = function (userId, userMetadata, cb) {
  var url;
  return assert.check(userId, {
    type: "string",
    message: "userId parameter is not valid"
  }), assert.check(userMetadata, {
    type: "object",
    message: "userMetadata parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send({
    user_metadata: userMetadata
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Management.prototype.patchUserAttributes = function (userId, user, cb) {
  var url;
  return assert.check(userId, {
    type: "string",
    message: "userId parameter is not valid"
  }), assert.check(user, {
    type: "object",
    message: "user parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "users", userId), this.request.patch(url).send(user).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
}, Management.prototype.linkUser = function (userId, secondaryUserToken, cb) {
  var url;
  return assert.check(userId, {
    type: "string",
    message: "userId parameter is not valid"
  }), assert.check(secondaryUserToken, {
    type: "string",
    message: "secondaryUserToken parameter is not valid"
  }), assert.check(cb, {
    type: "function",
    message: "cb parameter is not valid"
  }), url = urlJoin(this.baseOptions.rootUrl, "users", userId, "identities"), this.request.post(url).send({
    link_with: secondaryUserToken
  }).end(wrapCallback(cb, {
    ignoreCasing: !0
  }));
};
var index = {
  Authentication: Authentication,
  Management: Management,
  WebAuth: WebAuth,
  version: version
};
export default index;
export { Authentication, Management, WebAuth, version };